import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";
import {
  Search,
  User,
  Paperclip,
  ChevronDown,
  Users,
  MessageCircle,
  Send,
  UserPlus,
  Users2,
  X,
  ImageIcon,
  Film,
  FileText,
  ChevronRight,
  UserX,
  UserCog,
  Check,
  Lock,
  RotateCw,
  LoaderCircle,
  Pen,
  Tag,
  HelpCircle,
  Settings,
  MessageCircleMore,
  Tags,
  Info,
  Ellipsis,
  LogOut,
  Quote,
  ChevronLeft,
  Play,
  Link,
  Sparkles,
  Pin,
  Phone,
  Plus,
  StickyNote,
  Bot,
  EyeOff,
  Store,
  IdCard,
  Type,
} from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { ShopDropdown } from "../../components/ShopDropdown";
import { getShopsRequest } from "../../../Shop/slices/shopActions";
import shopApi from "../../../../api/shopApi";
import { getWebSocketUrl } from "../../../../api/websocket";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import shopGroupApi from "../../../../api/shopGroupApi";
import LoadingLeftBot from "../../../../components/LoadingLeftBot";
import ContactModal from "../../components/SearchModal";
import CreateGroupModal from "../../components/CreateGroupModal";
import GroupMemberSideBar from "../../components/GroupMemberSideBar";
import common from "../../../../utils/common";
import PermissionModal from "../../../Staff/components/PermissionModal";
import userApi from "../../../../api/userApi";
import tagApi from "../../../../api/tagApi";
import pipelineStageApi from "../../../../api/pipelineStageApi";
import quickMessageApi from "../../../../api/quickMessageApi.js";
import SelectQuickMessageModal from "../../components/SelectQuickMessageModal/index.jsx";
import SendContactCardModal from "../../components/SendContactCardModal/index.jsx";
import { useNotification } from "../../../../hooks/useNotification.jsx";
import useBrowserNotification from "../../../../hooks/useBrowserNotification.jsx";
import AddFriendModal from "../../components/AddFriendModal/index.jsx";
import UserInfoModal from "../../components/UserInfoModal/index.jsx";
import ImageAlbumModal from "../../components/ImageAlbumModal";
import ImageGridAlbum from "../../components/ImageGridAlbum";
import ReliableChatImage from "../../components/ReliableChatImage";
import { logoutRequest } from "../../../Auth/slices/authActions.js";
import SettingModal from "../../../Setting/components/SettingModal/index.jsx";
import LinkifyText from "../../../../components/LinkifyText/index.jsx";
import RichText from "../../../../components/RichText/index.jsx";
import { EmojiPicker } from "../../components/EmojiPicker/index.jsx";
// ConversationFilters moved to Sidebar - filters are now in NavItems > SidebarFilters
import { Button } from "../../../../components/UI/Button/index.jsx";
import SearchContactModal from "../../components/SearchContactModal/index.jsx";
import ChatSearchBar from "../../components/ChatSearchBar/index.jsx";
import HiddenConversationsModal from "../../components/HiddenConversationsModal/index.jsx";
import { useChatHeader } from "../../../../contexts/ChatHeaderContext.jsx";
import { cn } from "../../../../utils/utils.js";
import { useIsMobile } from "../../../../hooks/useIsMobile.jsx";
import StaffAssignmentPopover from "../../components/StaffAssignmentPopover/index.jsx";
import TagAssignmentPopover from "../../components/TagAssignmentPopover/index.jsx";
import PipelineStageSelector from "../../components/PipelineStageSelector/index.jsx";
import PipelineStagesManager from "../../components/PipelineStagesManager/index.jsx";
import { MessageActionMenu } from "../../components/MessageActionMenu/index.jsx";
import { MessageActionsBar } from "../../components/MessageActionsBar/index.jsx";
import zaloApi from "../../../../api/zaloApi.js";
import outboxApi from "../../../../api/outboxApi.js";
import {
  addPending,
  removePending,
  getPendingByShop,
} from "./pendingSends.js";
import {
  attachRealtimeShopMetadata,
  getRealtimeHydrationKey,
  isMessageForContactUid,
  mergeRealtimeContactPage,
  mergeRealtimeContact,
  runDedupedHydration,
  upsertRealtimeContact,
} from "./realtimeSync.js";
import {
  applyImageBatchAckToMessages,
  buildOptimisticImageMessages,
  dedupeMessagesByStableKey,
  mergeIncomingMessagesWithOptimistic,
} from "./imageMessageSync.js";
import { getContactUnreadMessageCount } from "./unreadCounts.js";
import { StickerPicker } from "../../components/StickerPicker/index.jsx";
import AIAssistantPanel from "../../../AIAssistant/AIAssistantPanel/index.jsx";
import SelectMentionModal from "../../components/SelectMentionModal/index.jsx";
import ShareMessageModal from "../../components/ShareMessageModal/index.jsx";
import { PinnedMessagesPanel } from "../../components/PinnedMessagesPanel/index.jsx";
import { PinnedMessageBadge } from "../../components/PinnedMessageBadge/index.jsx";
import BotMessagesTab from "../../components/BotMessagesTab/index.jsx";
import TagList from "../../components/ContactListItem/TagList.jsx";
import TagZaloPicker from "../../components/TagZaloPicker/index.jsx";
import TagChipsBar from "../../components/TagChipsBar/index.jsx";
import ScreenshotCapture from "../../components/ScreenshotCapture/index.jsx";
import { ReactionBadge } from "../../components/ReactionBadge/index.jsx";
import { RichTextComposer } from "../../components/RichTextComposer/index.jsx";
import {
  htmlToZaloStyles,
  stripHtml,
  plainToHtml,
  hasContent,
} from "../../utils/richText.js";
import {
  applyReactionEventsToMessages,
  hasActiveReactions,
} from "../../utils/messageReactions.js";

// Persist the "recently marked as read" grace map across reloads so the badge
// doesn't flicker back to unread in the 30s window after a click + refresh.
const RECENTLY_READ_GRACE_MS = 30000;
const RECENTLY_READ_STORAGE_PREFIX = "akabiz:recentlyRead";
const REALTIME_LISTEN_RETRY_BASE_MS = 1000;
const REALTIME_LISTEN_RETRY_MAX_MS = 30000;
const recentlyReadStorageKey = (userId) =>
  `${RECENTLY_READ_STORAGE_PREFIX}:${userId}`;

const isMessageForContact = isMessageForContactUid;

const isMessageForScopedContact = (message, contact) => {
  if (!isMessageForContact(message, contact?.uid)) return false;

  const messageShopId = message?.shopId;
  const contactShopId = contact?._shopId || contact?.shopId;
  return (
    !messageShopId ||
    !contactShopId ||
    String(messageShopId) === String(contactShopId)
  );
};

const normalizePersistedSendMessages = (messages) =>
  (Array.isArray(messages) ? messages : [messages]).filter(Boolean);

// export const ChatPage = () => {
//   const dispatch = useDispatch();
//   const auth = useSelector((state) => state.auth);

//   useEffect(() => {
//     if (auth.isError) addNotification(auth.errorMessage, -1);
//   }, [auth]);

//   const handleLogoutClick = () => {
//     dispatch(logoutRequest());
//   };

//   return (
//     <>
//       <p>{auth.isLoading ? "loading..." : "Chat"}</p>
//       <button onClick={handleLogoutClick}>Đăng xuất</button>
//     </>
//   );
// };

const parseGroupEventContent = (content) => {
  if (!content) return null;
  const joinMatch = content.match(/^(.+?)\s+vừa tham gia group\s*$/);
  if (joinMatch) {
    return {
      names: joinMatch[1].split(",").map((s) => s.trim()).filter(Boolean),
      eventKind: "join",
      tail: " vừa tham gia group",
    };
  }
  const leaveMatch = content.match(/^(.+?)\s+đã rời khỏi group\s*$/);
  if (leaveMatch) {
    return {
      names: [leaveMatch[1].trim()],
      eventKind: "leave",
      tail: " đã rời khỏi group",
    };
  }
  return null;
};

const normalizeGroupEventMemberName = (value) =>
  typeof value === "string"
    ? value.trim().replace(/\s+/g, " ").toLowerCase()
    : "";

const registerGroupEventLookupValue = (lookupMap, rawValue, uid) => {
  const rawKey = typeof rawValue === "string" ? rawValue.trim() : "";
  const normalizedKey = normalizeGroupEventMemberName(rawValue);
  if (!uid || (!rawKey && !normalizedKey)) return;

  const writeValue = (key) => {
    if (!key) return;
    const current = lookupMap.get(key);
    if (!current) {
      lookupMap.set(key, uid);
      return;
    }
    if (current !== uid) {
      lookupMap.set(key, null);
    }
  };

  writeValue(rawKey);
  writeValue(normalizedKey);
};

const resolveGroupEventMemberUid = (name, memberLookup) => {
  if (!memberLookup || !name) return null;
  const rawKey = typeof name === "string" ? name.trim() : "";
  const normalizedKey = normalizeGroupEventMemberName(name);

  if (rawKey && memberLookup.has(rawKey)) {
    return memberLookup.get(rawKey) || null;
  }
  if (normalizedKey && memberLookup.has(normalizedKey)) {
    return memberLookup.get(normalizedKey) || null;
  }
  return null;
};

const renderGroupEventContent = (msg, onClickMember, memberLookup) => {
  let names = Array.isArray(msg.memberNames)
    ? msg.memberNames.map((name) => (typeof name === "string" ? name.trim() : ""))
    : [];
  let ids = Array.isArray(msg.memberIds)
    ? msg.memberIds.map((uid) => (uid == null ? null : String(uid).trim() || null))
    : [];
  let tail =
    msg.eventKind === "join"
      ? " vừa tham gia group"
      : msg.eventKind === "leave"
        ? " đã rời khỏi group"
        : null;

  if (!names.filter(Boolean).length) {
    const parsed = parseGroupEventContent(msg.content);
    if (!parsed) return msg.content;
    names = parsed.names;
    tail = parsed.tail;
  }

  names = names.filter(Boolean);

  if (ids.length !== names.length) {
    ids = names.map((_, index) => ids[index] ?? null);
  }

  ids = names.map(
    (name, index) => ids[index] || resolveGroupEventMemberUid(name, memberLookup),
  );

  if (tail === null) {
    const parsed = parseGroupEventContent(msg.content);
    if (parsed?.tail) {
      tail = parsed.tail;
    }
  }

  if (tail === null) {
    const joined = names.join(", ");
    const content = msg.content ?? "";
    tail = content.startsWith(joined)
      ? content.slice(joined.length)
      : ` ${content}`;
  }

  return (
    <>
      {names.map((name, i) => {
        const uid = ids[i];
        return (
          <span key={`${uid ?? name}-${i}`}>
            {i > 0 && ", "}
            <button
              type="button"
              onClick={() => onClickMember({ uid, name })}
              className="text-blue-600 hover:underline font-medium"
            >
              {name}
            </button>
          </span>
        );
      })}
      {tail}
    </>
  );
};

const ChatPage = ({ setIsLoadingScreen }) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { addNotification } = useNotification();
  const showBrowserNotification = useBrowserNotification();
  const { shopId, groupId, shopIds: shopIdsParam } = useParams(); // shopId | groupId | shopIds (multi ad-hoc)
  const multiShopIds = useMemo(
    () => (shopIdsParam ? shopIdsParam.split(",").filter(Boolean) : []),
    [shopIdsParam],
  );
  const auth = useSelector((state) => state.auth);
  const shops = useSelector((state) => state.shops);
  const isChatbotEventEnabled = useSelector(
    (state) => state.chatbotEventAccess.enabled === true,
  );
  const [
    isOpenManageTagModal,
    setIsOpenManageTagModal,
    isOpenManageQuickMessageModal,
    setIsOpenManageQuickMessageModal,
    handleManageStaffClick,
    handleManageTagClick,
    handleManageQuickMessageClick,
    staffs,
    setStaffs,
    isSidebarOpen,
    setIsSidebarOpen,
  ] = useOutletContext();

  const [mobileShowing, setMobileShowing] = useState("contacts");

  const [user, setUser] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGroupMember, setIsLoadingGroupMember] = useState(false);
  const [activeTab, setActiveTab] = useState("messages");
  const [selectedMainMenu, setSelectedMainMenu] = useState("messages");
  const [selectedSubMenu, setSelectedSubMenu] = useState("all");
  const [openMenus, setOpenMenus] = useState({
    messages: true,
    tagZalo: false,
    systemTags: false,
    chatInfo: true,
    contactInfo: false,
    addPhone: false,
    addEmail: false,
    noteInfo: false,
    addNote: false,
    mutualGroup: false,
    images: false,
    files: false,
    links: false,
    account: false,
    sidebarInfo: false,
    aiAssistant: false,
  });
  const [sidebarInfoWidth, setSidebarInfoWidth] = useState(320); // default 20rem
  const sidebarResizingRef = useRef(false);
  // Resize cho pannel trái (danh sách hội thoại) — persist qua localStorage
  const [contactListWidth, setContactListWidth] = useState(() => {
    const saved = Number(window.localStorage.getItem("contactListWidth"));
    return Number.isFinite(saved) && saved >= 240 && saved <= 560 ? saved : 320;
  });
  const contactListResizingRef = useRef(false);
  // Composer (chat input) height — user có thể kéo thanh handle phía trên để thay đổi
  const [composerHeight, setComposerHeight] = useState(210);
  const composerResizingRef = useRef(false);
  const composerContainerRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [isHiddenConversationsModalOpen, setIsHiddenConversationsModalOpen] =
    useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedTagZalos, setSelectedTagZalos] = useState([]);
  const [selectedStaffs, setSelectedStaffs] = useState([]);
  const [selectedPipelineStageIds, setSelectedPipelineStageIds] = useState([]);
  const [needsReplyMinutes, setNeedsReplyMinutes] = useState(null);
  const [newCustomerDays, setNewCustomerDays] = useState(null);
  const [hasContactInfo, setHasContactInfo] = useState(null);
  const [upcomingBirthdayDays, setUpcomingBirthdayDays] = useState(null);
  const [pipelineStages, setPipelineStages] = useState([]);
  const [filterRole, setFilterRole] = useState(() => {
    return localStorage.getItem("filterRole") || "sales";
  });
  const [activePresetId, setActivePresetId] = useState(null);
  const [isStagesManagerOpen, setIsStagesManagerOpen] = useState(false);
  const lastMessageDivRef = useRef(null);

  const showManageStaffButton =
    auth.user?.role?.includes("super_admin") ||
    auth.user?.role?.includes("admin");

  const [selectedShop, setSelectedShop] = useState(null);
  const selectedShopStateRef = useRef(selectedShop);
  const [realtimeConnectionStatus, setRealtimeConnectionStatus] = useState({
    state: "idle",
  });

  // Group mode state (groupId comes from useParams now)
  const [isGroupMode, setIsGroupMode] = useState(false);
  const isGroupModeRef = useRef(false); // Ref to track latest value for cleanup functions
  const [groupShops, setGroupShops] = useState([]);
  const groupShopsStateRef = useRef(groupShops);
  const groupSocketsRef = useRef(new Map()); // shopId → WebSocket
  const [activeContactShop, setActiveContactShop] = useState(null); // Shop for current contact in group mode
  const activeContactShopRef = useRef(activeContactShop);
  const [shopGroupsList, setShopGroupsList] = useState([]); // All shop groups for current user
  const [activeShopGroup, setActiveShopGroup] = useState(null); // Currently selected group (for display)

  const [contacts, setContacts] = useState([]);
  const contactsRef = useRef(contacts);
  const [unreadMessageTotal, setUnreadMessageTotal] = useState(0);
  // Tick every 60s so relative time labels ("8 phút trước") refresh without refetching.
  const [, setTimeTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTimeTick((v) => v + 1), 60000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    selectedShopStateRef.current = selectedShop;
  }, [selectedShop]);
  useEffect(() => {
    groupShopsStateRef.current = groupShops;
  }, [groupShops]);
  useEffect(() => {
    activeContactShopRef.current = activeContactShop;
  }, [activeContactShop]);
  const [selectedChat, setSelectedChat] = useState(null);
  const selectedChatRef = useRef(selectedChat);
  const [selectedChatOnline, setSelectedChatOnline] = useState(null);
  // Track conversations recently marked as read to prevent stale socket updates
  const markedAsReadRef = useRef(new Map());
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [groupMembers, setGroupMembers] = useState([]);
  const [isOpenSelectMentionModal, setIsOpenSelectMentionModal] =
    useState(false);
  const [isOpenSelectQuickMessageModal, setIsOpenSelectQuickMessageModal] =
    useState(false);
  const [mentions, setMentions] = useState([]);
  const [message, setMessage] = useState("");
  const [isAdvancedCompose, setIsAdvancedCompose] = useState(false);
  const [messageHtml, setMessageHtml] = useState("");
  const messageInputRef = useRef(null);
  const [files, setFiles] = useState([]);
  const imageInputRef = useRef(null);
  const fileInputRef = useRef(null);
  const mediaRetryCacheRef = useRef(new Map());
  const sendWatchdogsRef = useRef(new Map());
  const [, setMediaRetryTick] = useState(0);
  const [repMessage, setRepMessage] = useState(null);

  const [fileSearch, setFileSearch] = useState("");
  const [fileFilter, setFileFilter] = useState("all");
  const [filePage, setFilePage] = useState(1);

  const [newContact, setNewContact] = useState(null);

  const [isOpenSearchModal, setIsOpenSearchModal] = useState(false);
  const [selectedCreateGroupContacts, setSelectedCreateGroupContacts] =
    useState([]);
  const [selectedInviteGroup, setSelectedInviteGroup] = useState(null);
  const [isOpenCreateGroupModal, setIsOpenCreateGroupModal] = useState(false);
  const [isOpenGroupMembersSideBar, setIsOpenGroupMembersSideBar] =
    useState(false);
  const [isOpenPermissionModal, setIsOpenPermissionModal] = useState(false);
  const [isOpenSettingModal, setIsOpenSettingModal] = useState(false);
  const [isOpenAddFriendModal, setIsOpenAddFriendModal] = useState(false);
  const [isOpenSendCardModal, setIsOpenSendCardModal] = useState(false);
  const [isOpenShareModal, setIsOpenShareModal] = useState(false);
  const [userInfoUid, setUserInfoUid] = useState(null);
  const [isUserInfoOpen, setIsUserInfoOpen] = useState(false);
  const [shareMessage, setShareMessage] = useState(null);

  // Pinned Messages State
  const [pinnedMessages, setPinnedMessages] = useState([]);
  const [pinnedMessageIds, setPinnedMessageIds] = useState(new Set());
  const [showPinnedPanel, setShowPinnedPanel] = useState(false);

  // Jump-to-message from search state
  const [pendingSearchJump, setPendingSearchJump] = useState(null);

  // In-chat search (Ctrl+F)
  const [chatSearchOpen, setChatSearchOpen] = useState(false);
  const [chatSearchQuery, setChatSearchQuery] = useState("");

  const [isToggleSelectStaff, setIsToggleSelectStaff] = useState(false);
  const [searchStaff, setSearchStaff] = useState("");

  const [tagZalos, setTagZalos] = useState([]);
  const [tags, setTags] = useState([]);
  // Group mode: store all tags/tagZalos from all shops
  const [groupTags, setGroupTags] = useState([]);
  const [groupTagZalos, setGroupTagZalos] = useState([]);
  const [quickMessages, setQuickMessages] = useState([]);

  // Chat list preferences
  const [sortMode, setSortMode] = useState("recent"); // "recent" | "unread_first"
  const [conversationTab, setConversationTab] = useState("all"); // "all" | "unread"
  const [conversationType, setConversationType] = useState("all"); // "all" | "personal" | "group"

  // Provide header data (nav items + filters + user) to the top bar
  const { setHeaderData, clearHeaderData } = useChatHeader();

  const [selectedChatName, setSelectedChatName] = useState("");
  const [isEditingName, setIsEditingName] = useState(false);
  const [isRenaming, setIsRenaming] = useState(false);


  // Media Album State
  const [albumState, setAlbumState] = useState({
    isOpen: false,
    initialMedia: null,
  });
  const previewObjectUrlsRef = useRef(new Set());

  const releasePreviewObjectUrl = useCallback((value) => {
    if (
      !value ||
      typeof value !== "string" ||
      !value.startsWith("blob:") ||
      !previewObjectUrlsRef.current.has(value)
    ) {
      return;
    }

    URL.revokeObjectURL(value);
    previewObjectUrlsRef.current.delete(value);
  }, []);

  const releaseMessagePreview = useCallback(
    (message) => {
      releasePreviewObjectUrl(message?.localPreviewUrl);
      if (message?.previewSrc !== message?.localPreviewUrl) {
        releasePreviewObjectUrl(message?.previewSrc);
      }
    },
    [releasePreviewObjectUrl],
  );

  useEffect(
    () => () => {
      for (const url of previewObjectUrlsRef.current) {
        URL.revokeObjectURL(url);
      }
      previewObjectUrlsRef.current.clear();
    },
    [],
  );

  useEffect(() => {
    const referencedUrls = new Set();
    const registerFromMessages = (messages) => {
      for (const message of messages || []) {
        if (
          typeof message?.localPreviewUrl === "string" &&
          message.localPreviewUrl.startsWith("blob:")
        ) {
          referencedUrls.add(message.localPreviewUrl);
        }
        if (
          typeof message?.previewSrc === "string" &&
          message.previewSrc.startsWith("blob:")
        ) {
          referencedUrls.add(message.previewSrc);
        }
      }
    };

    registerFromMessages(selectedChat?.messages);
    for (const contact of contacts) {
      registerFromMessages(contact?.messages);
    }

    for (const url of Array.from(previewObjectUrlsRef.current)) {
      if (!referencedUrls.has(url)) {
        URL.revokeObjectURL(url);
        previewObjectUrlsRef.current.delete(url);
      }
    }
  }, [contacts, selectedChat]);

  // Consolidate all media (images & videos) for the album
  const mediaMessages = useMemo(() => {
    if (!selectedChat?.messages) return [];
    const media = [];

    // Sort messages to ensure chronological order (oldest to newest) for the album
    const sortedMessages = [...selectedChat.messages].sort(
      (a, b) => new Date(a.dateAction) - new Date(b.dateAction),
    );

    const getSenderName = (msg) => {
      if (!selectedChat) return "";
      if (msg.uidFrom === "0") return "Bạn";
      if (!selectedChat.isGroup) return selectedChat.name;
      const member = contacts.find((c) => c.uid === msg.uidFrom);
      return member?.name || msg.uidFrom;
    };

    sortedMessages.forEach((m) => {
      // Single Image
      if (m.type === "image" && !m.isUndo) {
        media.push({
          ...m,
          senderName: getSenderName(m),
          // Ensure content field matches what ImageAlbumModal expects for consistency
          content: m.img || m.content,
          previewSrc: m.previewSrc || m.localPreviewUrl,
        });
      }
      // Grouped Images
      else if (m.type === "images" && Array.isArray(m.imgs) && !m.isUndo) {
        m.imgs.forEach((img, idx) => {
          media.push({
            ...m,
            img: img, // current image url
            content: img,
            _id: `${m._id}_${idx}`, // unique id for specific image in group
            senderName: getSenderName(m),
            previewSrc: m.previewImgs?.[idx],
          });
        });
      }
      // Video
      else if (m.type === "video" && !m.isUndo) {
        media.push({
          ...m,
          senderName: getSenderName(m),
          // Video usually has 'file' as url and 'content' as thumbnail, or vice-versa depending on backend.
          // Based on view_file: href={msg.file} (video url), src={msg.content} (thumb)
          // ImageAlbumModal expects 'file' for video url, 'content' for thumb.
        });
      }
    });
    return media;
  }, [selectedChat, contacts]);

  const handleMediaClick = (e, mediaItem, isVideo = false) => {
    e.preventDefault();
    setAlbumState({
      isOpen: true,
      initialMedia: mediaItem,
    });
  };

  // Context Menu State
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    contact: null,
  });

  const handleContextMenu = (e, contact) => {
    e.preventDefault();
    setContextMenu({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      contact: contact,
    });
  };

  useEffect(() => {
    const handleClick = () =>
      setContextMenu((prev) => ({ ...prev, visible: false }));
    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, []);

  const handlePinConversation = async (contact) => {
    try {
      const shopId = isGroupMode ? contact._shopId : selectedShop._id;
      const res = await shopApi.pinConversation(
        shopId,
        contact.uid,
        contact.isGroup,
      );
      if (res.status === 1) {
        setContacts((prev) =>
          prev.map((c) =>
            c._id === contact._id
              ? { ...c, isPinned: true, pinnedAt: new Date().toISOString() }
              : c,
          ),
        );
        addNotification("Đã ghim cuộc hội thoại", 1);
      } else {
        addNotification(res.message || "Lỗi khi ghim", -1);
      }
    } catch (error) {
      addNotification("Lỗi khi ghim: " + error.message, -1);
    }
  };

  const handleUnpinConversation = async (contact) => {
    try {
      const shopId = isGroupMode ? contact._shopId : selectedShop._id;
      const res = await shopApi.unpinConversation(
        shopId,
        contact.uid,
        contact.isGroup,
      );
      if (res.status === 1) {
        setContacts((prev) =>
          prev.map((c) =>
            c._id === contact._id
              ? { ...c, isPinned: false, pinnedAt: null }
              : c,
          ),
        );
        addNotification("Đã bỏ ghim cuộc hội thoại", 1);
      } else {
        addNotification(res.message || "Lỗi khi bỏ ghim", -1);
      }
    } catch (error) {
      addNotification("Lỗi khi bỏ ghim: " + error.message, -1);
    }
  };

  const handleHideConversation = async (contact) => {
    try {
      const shopId = isGroupMode ? contact._shopId : selectedShop._id;
      const res = await shopApi.hideConversation(shopId, contact.uid);
      if (res.status === 1) {
        setContacts((prev) => prev.filter((c) => c._id !== contact._id));
        addNotification("Đã ẩn cuộc hội thoại", 1);
      } else {
        addNotification(res.message || "Lỗi khi ẩn", -1);
      }
    } catch (error) {
      addNotification("Lỗi khi ẩn: " + error.message, -1);
    }
  };

  const handleUnhideConversation = async (contact) => {
    try {
      const shopId = isGroupMode ? contact._shopId : selectedShop._id;
      const res = await shopApi.unhideConversation(shopId, contact.uid);
      if (res.status === 1) {
        setContacts((prev) => prev.filter((c) => c._id !== contact._id));
        addNotification("Đã bỏ ẩn cuộc hội thoại", 1);
      } else {
        addNotification(res.message || "Lỗi khi bỏ ẩn", -1);
      }
    } catch (error) {
      addNotification("Lỗi khi bỏ ẩn: " + error.message, -1);
    }
  };

  const [hasMoreContacts, setHasMoreContacts] = useState(true);
  const [isLoadingMoreContacts, setIsLoadingMoreContacts] = useState(false);
  const [loadMoreContactsError, setLoadMoreContactsError] = useState(false);
  const [hasMoreMessages, setHasMoreMessages] = useState(true);
  const [isLoadingMoreMessages, setIsLoadingMoreMessages] = useState(false);
  const isLoadingMoreContactsRef = useRef(false);
  const isLoadingMoreMessagesRef = useRef(false);
  const hasMoreContactsRef = useRef(true);
  const hasMoreMessagesRef = useRef(true);
  const selectedCategoriesRef = useRef([]);
  const selectedTagsRef = useRef([]);
  const selectedTagZalosRef = useRef([]);
  const selectedStaffsRef = useRef([]);
  const selectedPipelineStageIdsRef = useRef([]);
  const needsReplyMinutesRef = useRef(null);
  const newCustomerDaysRef = useRef(null);
  const hasContactInfoRef = useRef(null);
  const upcomingBirthdayDaysRef = useRef(null);
  const sortModeRef = useRef("recent");

  // True if any server-side filter is active. Used to gate WebSocket-driven
  // contact appends — new contacts arriving via WS should NOT bypass the active
  // filter (otherwise list reloads back to unfiltered after a few seconds).
  const hasActiveFilter = () => {
    return (
      (selectedCategoriesRef.current?.length || 0) > 0 ||
      (selectedTagsRef.current?.length || 0) > 0 ||
      (selectedTagZalosRef.current?.length || 0) > 0 ||
      (selectedStaffsRef.current?.length || 0) > 0 ||
      (selectedPipelineStageIdsRef.current?.length || 0) > 0 ||
      !!needsReplyMinutesRef.current ||
      !!newCustomerDaysRef.current ||
      !!hasContactInfoRef.current ||
      !!upcomingBirthdayDaysRef.current
    );
  };
  const buildUnreadCountFilters = useCallback(
    () => ({
      categories: selectedCategoriesRef.current,
      staffId: auth.user?._id,
      tagIds: selectedTagsRef.current,
      tagZaloIds: selectedTagZalosRef.current,
      staffIds: selectedStaffsRef.current,
      pipelineStageIds: selectedPipelineStageIdsRef.current,
      needsReplyMinutes: needsReplyMinutesRef.current,
      newCustomerDays: newCustomerDaysRef.current,
      hasContactInfo: hasContactInfoRef.current,
      upcomingBirthdayDays: upcomingBirthdayDaysRef.current,
      sortMode: sortModeRef.current,
    }),
    [auth.user?._id],
  );
  const refreshUnreadMessageCount = useCallback(async () => {
    if (!auth.user?._id) {
      setUnreadMessageTotal(0);
      return;
    }

    const filters = buildUnreadCountFilters();
    try {
      if (isGroupModeRef.current) {
        const shopsToCount = groupShopsStateRef.current || [];
        if (shopsToCount.length === 0) {
          setUnreadMessageTotal(0);
          return;
        }

        const results = await Promise.allSettled(
          shopsToCount.map((shop) =>
            shopApi.getUnreadMessageCount(shop._id, filters),
          ),
        );
        const total = results.reduce((sum, result) => {
          if (result.status !== "fulfilled" || result.value?.status !== 1) {
            return sum;
          }
          return sum + Number(result.value.data?.totalUnreadMessages || 0);
        }, 0);
        setUnreadMessageTotal(total);
        return;
      }

      const shop = selectedShopStateRef.current;
      if (!shop?._id) {
        setUnreadMessageTotal(0);
        return;
      }

      const res = await shopApi.getUnreadMessageCount(shop._id, filters);
      if (res.status === 1) {
        setUnreadMessageTotal(Number(res.data?.totalUnreadMessages || 0));
      }
    } catch (error) {
      console.error("[UnreadCount] Refresh failed:", error);
    }
  }, [auth.user?._id, buildUnreadCountFilters]);
  const contactsFetchAbortRef = useRef(null);
  const sentinelRef = useRef(null);
  const realtimeHydrationRequestsRef = useRef(new Map());
  const realtimeRevalidateTimerRef = useRef(null);
  const isRealtimeRevalidatingRef = useRef(false);

  const linkMessages = useMemo(() => {
    if (!selectedChat?.messages) return [];
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[^\s]+\.[a-z]{2,})/gi;
    const links = [];
    selectedChat.messages.forEach((m) => {
      if (typeof m.content === "string") {
        const matches = m.content.match(urlRegex);
        if (matches) matches.forEach((link) => links.push({ ...m, link }));
      }
    });
    return links.reverse();
  }, [selectedChat]);

  const fileMessages = useMemo(() => {
    if (!selectedChat?.messages) return [];
    return selectedChat.messages
      .filter((m) => m.type === "file")
      .slice()
      .reverse();
  }, [selectedChat]);

  const filteredFileMessages = useMemo(() => {
    let files = fileMessages;
    if (fileSearch)
      files = files.filter((f) =>
        (f.content || "").toLowerCase().includes(fileSearch.toLowerCase()),
      );
    if (fileFilter !== "all") {
      files = files.filter((f) =>
        (f.content || "").toLowerCase().endsWith(`.${fileFilter}`),
      );
    }
    return files;
  }, [fileMessages, fileSearch, fileFilter]);

  const filesPerPage = 10;
  const paginatedFileMessages = useMemo(() => {
    const start = (filePage - 1) * filesPerPage;
    return filteredFileMessages.slice(start, start + filesPerPage);
  }, [filteredFileMessages, filePage]);

  // State for scrolling to quoted message
  const [isLoadingQuotedMessage, setIsLoadingQuotedMessage] = useState(false);
  const [scrollToMessageIndex, setScrollToMessageIndex] = useState(null); // Used to temporarily increase render limit

  // Load pinned messages for a conversation
  const loadPinnedMessages = async (shopId, conversationUid) => {
    console.log("[PinnedMessages] loadPinnedMessages called:", {
      shopId,
      conversationUid,
    });
    try {
      const result = await shopApi.getPinnedMessages(shopId, conversationUid);
      console.log("[PinnedMessages] API result:", result);
      if (result.status === 1) {
        setPinnedMessages(result.data || []);
        setPinnedMessageIds(
          new Set((result.data || []).map((p) => p.messageId)),
        );
        if (result.data?.length > 0) {
          console.log(
            "[PinnedMessages] Setting showPinnedPanel to true, count:",
            result.data.length,
          );
          setShowPinnedPanel(true);
        }
      } else {
        console.error("[PinnedMessages] API failed:", result.message);
        setPinnedMessages([]);
        setPinnedMessageIds(new Set());
      }
    } catch (error) {
      console.error("[PinnedMessages] Error loading pinned messages:", error);
      setPinnedMessages([]);
      setPinnedMessageIds(new Set());
    }
  };

  // Helper function to get the actual shop for current contact in group mode
  // In group mode, use activeContactShop or selectedChat._shopId; otherwise use selectedShop
  const getActualShop = useCallback(() => {
    if (isGroupModeRef.current) {
      // First try activeContactShop
      if (activeContactShop) return activeContactShop;
      // Then try to find shop from selectedChat._shopId
      if (selectedChat?._shopId) {
        const foundShop = groupShops.find(
          (s) => s._id === selectedChat._shopId,
        );
        if (foundShop) return foundShop;
      }
    }
    return selectedShop;
  }, [activeContactShop, selectedChat?._shopId, groupShops, selectedShop]);

  // Helper function to get the default search shop in group mode
  // Uses defaultSearchShopId from activeShopGroup for phone/contact search
  const getDefaultSearchShop = useCallback(() => {
    if (isGroupModeRef.current && activeShopGroup?.defaultSearchShopId) {
      const defaultShop = groupShops.find(
        (s) => s._id === activeShopGroup.defaultSearchShopId,
      );
      if (defaultShop) return defaultShop;
    }
    return selectedShop;
  }, [activeShopGroup?.defaultSearchShopId, groupShops, selectedShop]);

  // Handle pin change from MessageActionMenu
  const handlePinChange = (msg, isPinned) => {
    if (isPinned) {
      // Reload pinned messages to get full data
      const actualShop = getActualShop();
      if (actualShop && selectedChat) {
        loadPinnedMessages(actualShop._id, selectedChat.uid);
      }
    } else {
      // Remove from state
      const msgId = msg.id || msg._id;
      setPinnedMessages((prev) => prev.filter((p) => p.messageId !== msgId));
      setPinnedMessageIds((prev) => {
        const newSet = new Set(prev);
        newSet.delete(msgId);
        return newSet;
      });
    }
  };

  // Navigate to pinned message in chat
  const handleNavigateToPinnedMessage = async (message) => {
    const shop = getActualShop();
    if (!message || !shop || !selectedChat) return;

    const targetMsgId = message.msgId || message.cliMsgId;

    // First check if message is already in current messages
    const existingMessage = selectedChat.messages?.find(
      (m) =>
        String(m.msgId) === String(targetMsgId) ||
        String(m.cliMsgId) === String(targetMsgId),
    );

    if (existingMessage) {
      // Scroll to the message using data-msg-id attribute
      const element = document.querySelector(
        `[data-msg-id="${existingMessage.msgId || existingMessage.cliMsgId}"]`,
      );
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.classList.add("bg-yellow-100");
        setTimeout(() => element.classList.remove("bg-yellow-100"), 2000);
      }
      setShowPinnedPanel(false);
      return;
    }

    // If not found, load messages around the target
    try {
      const res = await shopApi.getMessagesByAnchor(
        shop._id,
        selectedChat.uid,
        {
          anchorDate: message.dateAction,
          direction: "around",
          limit: 40,
        },
      );

      if (res.status === 1 && res.data) {
        // Merge with existing messages
        const existingIds = new Set(
          selectedChat.messages?.map((m) => m._id) || [],
        );
        const newMessages = res.data.filter((m) => !existingIds.has(m._id));
        const mergedMessages = [
          ...newMessages,
          ...(selectedChat.messages || []),
        ].sort((a, b) => new Date(a.dateAction) - new Date(b.dateAction));

        setSelectedChat((prev) => ({
          ...prev,
          messages: mergedMessages,
        }));

        // Scroll to the message after render
        setTimeout(() => {
          const element = document.querySelector(
            `[data-msg-id="${targetMsgId}"]`,
          );
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "center" });
            element.classList.add("bg-yellow-100");
            setTimeout(() => element.classList.remove("bg-yellow-100"), 2000);
          }
        }, 100);
      }
    } catch (error) {
      console.error("Error navigating to pinned message:", error);
      addNotification("Không thể tải tin nhắn", -1);
    }

    setShowPinnedPanel(false);
  };

  // Effect: process pendingSearchJump when selectedChat matches target contact
  useEffect(() => {
    if (!pendingSearchJump) return;
    if (!selectedChat?._id) return;
    if (
      selectedChat._id !== pendingSearchJump.contactId &&
      selectedChat.uid !== pendingSearchJump.contactUid
    )
      return;
    const target = pendingSearchJump.message;
    setPendingSearchJump(null);
    const timer = setTimeout(() => {
      handleNavigateToPinnedMessage(target);
    }, 80);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedChat?._id, selectedChat?.uid, pendingSearchJump]);

  // Scroll to quoted message when clicking on a quote
  const scrollToQuotedMessage = async (quote) => {
    if (!quote || !selectedChat?.messages || !selectedShop) return;

    // Try different msgId fields that quote might have
    const targetMsgId = String(
      quote.globalMsgId || quote.cliMsgId || quote.msgId || "",
    );

    if (!targetMsgId) {
      addNotification("Không tìm thấy ID tin nhắn gốc", -1);
      return;
    }

    // Find message with matching msgId or cliMsgId (convert to string for comparison)
    let targetMessage = selectedChat.messages.find(
      (m) =>
        String(m.msgId) === targetMsgId || String(m.cliMsgId) === targetMsgId,
    );

    let finalMessages = selectedChat.messages;

    // If not found, use anchor-based loading to jump directly to the message
    if (!targetMessage) {
      setIsLoadingQuotedMessage(true);

      try {
        // Step 1: Find the target message's dateAction using findMessageByMsgId
        const searchRes = await shopApi.findMessageByMsgId(
          selectedShop._id,
          selectedChat.uid,
          targetMsgId,
        );

        if (searchRes.status === 1 && searchRes.data) {
          const targetAnchorDate = searchRes.data.dateAction;

          // Get the oldest message date from current messages
          const currentMessages = selectedChat.messages || [];
          const oldestCurrentDate =
            currentMessages.length > 0 ? currentMessages[0].dateAction : null;

          // Step 2: Load messages from target to oldest current message to fill gap
          // If target is older than oldest current, we need to load the range between them
          let allNewMessages = [];

          if (
            oldestCurrentDate &&
            new Date(targetAnchorDate) < new Date(oldestCurrentDate)
          ) {
            // Load messages between target and oldest current
            // Use multiple batches if needed
            let currentAnchor = oldestCurrentDate;
            let hasMore = true;
            const maxIterations = 10; // Safety limit
            let iterations = 0;

            while (hasMore && iterations < maxIterations) {
              const res = await shopApi.getMessagesByAnchor(
                selectedShop._id,
                selectedChat.uid,
                {
                  anchorDate: currentAnchor,
                  direction: "before",
                  limit: 50,
                },
              );

              if (res.status === 1 && res.data && res.data.length > 0) {
                allNewMessages = [...res.data, ...allNewMessages];

                // Check if we've reached or passed the target
                const oldestLoaded = res.data[0];
                if (
                  new Date(oldestLoaded.dateAction) <=
                  new Date(targetAnchorDate)
                ) {
                  hasMore = false;
                } else {
                  currentAnchor = oldestLoaded.dateAction;
                  hasMore = res.hasMoreBefore !== false;
                }
              } else {
                hasMore = false;
              }
              iterations++;
            }
          } else {
            // Target is newer or same as oldest - just load around
            const res = await shopApi.getMessagesByAnchor(
              selectedShop._id,
              selectedChat.uid,
              {
                anchorDate: targetAnchorDate,
                direction: "around",
                limit: 40,
              },
            );
            if (res.status === 1 && res.data) {
              allNewMessages = res.data;
            }
          }

          if (allNewMessages.length > 0) {
            // Merge with existing messages
            const existingIds = new Set(currentMessages.map((m) => m._id));
            const newMessages = allNewMessages.filter(
              (m) => !existingIds.has(m._id),
            );
            finalMessages = [...newMessages, ...currentMessages];
            finalMessages = finalMessages.sort(
              (a, b) => new Date(a.dateAction) - new Date(b.dateAction),
            );

            // Find target message in merged list
            targetMessage = finalMessages.find(
              (m) =>
                String(m.msgId) === targetMsgId ||
                String(m.cliMsgId) === targetMsgId,
            );
          }
        }
      } catch (error) {
        console.error("Error loading quoted message:", error);
      }

      setIsLoadingQuotedMessage(false);
    }

    if (!targetMessage) {
      addNotification("Tin nhắn gốc không tìm thấy trong cuộc trò chuyện", -1);
      return;
    }

    // displayMessages slices from the end of messages array, so we need to ensure
    // the target message is included in the slice. Set scrollToMessageIndex to
    // include all messages up to and including the target.
    const requiredRenderCount = finalMessages.length + 10; // Add buffer for merged images / timeline entries
    setScrollToMessageIndex(requiredRenderCount);

    // Update selectedChat with all loaded messages
    setSelectedChat((prev) => ({
      ...prev,
      messages: finalMessages,
    }));

    // Also update contacts to keep in sync, so future page loads don't lose these messages
    setContacts((prev) =>
      prev.map((c) =>
        c._id === selectedChat._id ? { ...c, messages: finalMessages } : c,
      ),
    );

    // Wait for DOM to update and retry finding the element
    const scrollToElement = (msgId, retries = 15) => {
      const messageElement = document.querySelector(`[data-msg-id="${msgId}"]`);

      if (messageElement) {
        messageElement.scrollIntoView({ behavior: "smooth", block: "center" });

        // Add highlight effect
        setTimeout(() => {
          messageElement.classList.add("bg-yellow-100");
          setTimeout(() => {
            messageElement.classList.remove("bg-yellow-100");
            setScrollToMessageIndex(null);
          }, 2000);
        }, 500);
      } else if (retries > 0) {
        setTimeout(() => scrollToElement(msgId, retries - 1), 200);
      } else {
        addNotification("Không thể cuộn đến tin nhắn", -1);
        setScrollToMessageIndex(null);
      }
    };

    // Start looking for the element with more delay for re-render
    setTimeout(() => scrollToElement(targetMessage.msgId), 300);
  };

  const handleContactClick = async (contact) => {
    setMobileShowing("chat");
    if (isMobile) setIsSidebarOpen(false);
    setSelectedGroup(null);
    setGroupMembers([]);
    setIsOpenGroupMembersSideBar(false);
    setSelectedChat(contact);
    setSelectedChatName(contact?.name ?? "");
    setIsEditingName(false);

    // Auto-switch shop in group mode if contact belongs to different shop
    // Use activeContactShop instead of selectedShop to avoid WebSocket reconnection
    let activeShop = isGroupMode
      ? activeContactShop || selectedShop
      : selectedShop;
    if (isGroupMode && contact._shopId) {
      const newShop = groupShops.find((s) => s._id === contact._shopId);
      if (newShop && newShop._id !== activeContactShop?._id) {
        console.log("[GroupMode] Setting active contact shop:", newShop.name);
        setActiveContactShop(newShop);
        activeShop = newShop;
      }
    }

    // Load pinned messages for this conversation
    console.log(
      "[PinnedMessages] handleContactClick - selectedShop:",
      selectedShop?._id,
      "contact.uid:",
      contact.uid,
    );
    if (activeShop && contact.uid) {
      loadPinnedMessages(activeShop._id, contact.uid);
    } else {
      console.warn(
        "[PinnedMessages] Cannot load pinned messages - selectedShop or contact.uid missing",
      );
    }

    // Load initial messages if contact only has 1 message (preview message)
    if (activeShop && contact.messages?.length <= 1) {
      setIsLoadingMoreMessages(true);
      isLoadingMoreMessagesRef.current = true;
      try {
        const res = await shopApi.getMessagesByAnchor(
          activeShop._id,
          contact.uid,
          {
            direction: "before",
            limit: 20,
          },
        );
        if (res.status === 1 && res.data && res.data.length > 0) {
          const existingIds = new Set(
            contact.messages?.map((m) => m._id) || [],
          );
          const newMessages = res.data.filter((m) => !existingIds.has(m._id));
          const mergedMessages = [...newMessages, ...(contact.messages || [])];

          setSelectedChat((prev) => ({
            ...prev,
            messages: mergedMessages,
          }));
          setContacts((prev) =>
            prev.map((c) =>
              c._id === contact._id ? { ...c, messages: mergedMessages } : c,
            ),
          );
          setHasMoreMessages(res.hasMoreBefore !== false);
          hasMoreMessagesRef.current = res.hasMoreBefore !== false;
        }
      } catch (err) {
        console.error("Error loading initial messages:", err);
      }
      setIsLoadingMoreMessages(false);
      isLoadingMoreMessagesRef.current = false;
    }

    // Mark conversation as read based on role:
    // - Owner/admin: check any staff has unread (team-wide oversight)
    // - Regular staff: only check their own unread
    const isAdminView = isOwnerOrAdmin();
    const hasUnreadToClear = isAdminView
      ? contact.unreadStaffIds?.length > 0 ||
        Object.values(contact.unreadCounts || {}).some((v) => Number(v) > 0)
      : contact.unreadStaffIds?.includes(auth.user._id) ||
        Number(contact.unreadCounts?.[auth.user._id] || 0) > 0;

    if (hasUnreadToClear) {
      // Track that this conversation was just marked as read (stores both _id and uid)
      markAsReadInRef(contact);

      // Optimistic update:
      // - Owner/admin: clear ALL unreadStaffIds + zero EVERY staff's count (team oversight cleared)
      // - Regular staff: filter only own ID + zero only own count (don't touch peer unread)
      setContacts((pre) =>
        pre.map((c) =>
          c._id === contact._id
            ? {
                ...c,
                unreadStaffIds: isAdminView
                  ? []
                  : (c.unreadStaffIds || []).filter(
                      (s) => s !== auth.user._id,
                    ),
                unreadCounts: isAdminView
                  ? Object.fromEntries(
                      Object.keys(c.unreadCounts || {}).map((k) => [k, 0]),
                    )
                  : {
                      ...(c.unreadCounts || {}),
                      [auth.user._id]: 0,
                    },
              }
            : c,
        ),
      );

      // Call API to mark as read (handles both unreadStaffIds and unreadCounts)
      if (activeShop?._id && contact.uid) {
        // Snapshot for rollback on API failure
        const prevUnreadStaffIds = contact.unreadStaffIds;
        const prevUnreadCounts = contact.unreadCounts;
        shopApi
          .markConversationAsRead(
            activeShop._id,
            contact.uid,
            auth.user._id,
          )
          .then((res) => {
            if (res?.status === 1) refreshUnreadMessageCount();
          })
          .catch((err) => {
            console.error("markConversationAsRead failed:", err);
            setContacts((pre) =>
              pre.map((c) =>
                c._id === contact._id
                  ? {
                      ...c,
                      unreadStaffIds: prevUnreadStaffIds,
                      unreadCounts: prevUnreadCounts,
                    }
                  : c,
              ),
            );
            clearRecentlyReadMark(contact);
            addNotification(
              "Không thể đánh dấu đã đọc, vui lòng thử lại",
              -1,
            );
          });
      }
    }
    messageInputRef?.current?.focus();
    scrollToLastMessage(300);
  };

  const loadGroupMembers = async () => {
    if (!selectedChat?.isGroup) return;
    setSelectedGroup(selectedChat);
    if (!selectedChat.isLoadGroupMember) {
      const actualShop = getActualShop();
      const res = await shopApi.loadGroupMembers({
        shopId: actualShop._id,
        groupId: selectedChat._id,
        memberIds: selectedChat.groupMemberIds,
      });
      if (res.status === 1) {
        // const resContacts = await shopApi.getContactsWithoutMessages(
        //   selectedShop._id
        // );
        // if (resContacts.status === 1) {
        //   setContacts((pre) =>
        //     resContacts.data.map((c) => ({
        //       ...c,
        //       messages: pre.find((x) => x._id === c._id)?.messages ?? [],
        //     }))
        //   );
        // setGroupMembers(
        //   resContacts.data.filter((x) =>
        //     selectedChat?.groupMemberIds.includes(x.uid)
        //   )
        // );
        const resGetGroupMembers = await shopApi.getContactByUids(
          selectedChat.shopId,
          selectedChat.groupMemberIds ?? [],
        );
        if (resGetGroupMembers.status === 1)
          setGroupMembers(resGetGroupMembers.data);
        // }
      }
    } else {
      // setGroupMembers(
      //   contacts.filter((x) => selectedChat?.groupMemberIds.includes(x.uid))
      // );
      const resGetGroupMembers = await shopApi.getContactByUids(
        selectedChat.shopId,
        selectedChat.groupMemberIds ?? [],
      );
      if (resGetGroupMembers.status === 1)
        setGroupMembers(resGetGroupMembers.data);
    }
  };

  const handleLogoutClick = () => {
    dispatch(logoutRequest());
  };

  const toggleMenu = (menu) => {
    setOpenMenus((prev) => ({ ...prev, [menu]: !prev[menu] }));
  };

  // Handle adding phone/email/note to contact lists
  const handleAddContactInfo = async (type, value) => {
    if (!selectedChat || !value) return;

    const actualShop = getActualShop();
    if (!actualShop) {
      addNotification("Không tìm thấy shop", -1);
      return;
    }

    // Validate email format
    if (type === "email" && !value.includes("@")) {
      addNotification("Email không hợp lệ", -1);
      return;
    }

    // Get current lists
    const currentPhoneList = selectedChat.phoneList || [];
    const currentEmailList = selectedChat.emailList || [];
    const currentNoteList = selectedChat.noteList || [];

    // Check for duplicates
    if (type === "phone" && currentPhoneList.includes(value)) {
      addNotification("SĐT đã tồn tại", -1);
      return;
    }
    if (type === "email" && currentEmailList.includes(value.toLowerCase())) {
      addNotification("Email đã tồn tại", -1);
      return;
    }
    if (type === "note" && currentNoteList.includes(value)) {
      addNotification("Ghi chú đã tồn tại", -1);
      return;
    }

    // Build new lists
    const newPhoneList =
      type === "phone" ? [...currentPhoneList, value] : currentPhoneList;
    const newEmailList =
      type === "email"
        ? [...currentEmailList, value.toLowerCase()]
        : currentEmailList;
    const newNoteList =
      type === "note" ? [...currentNoteList, value] : currentNoteList;

    try {
      const res = await shopApi.updateContact({
        _id: selectedChat._id,
        shopId: actualShop._id,
        phoneList: newPhoneList,
        emailList: newEmailList,
        noteList: newNoteList,
      });

      if (res.status === 1) {
        // Update local state
        setSelectedChat((prev) => ({
          ...prev,
          phoneList: newPhoneList,
          emailList: newEmailList,
          noteList: newNoteList,
        }));
        setContacts((prev) =>
          prev.map((c) =>
            c._id === selectedChat._id
              ? {
                  ...c,
                  phoneList: newPhoneList,
                  emailList: newEmailList,
                  noteList: newNoteList,
                }
              : c,
          ),
        );

        let msg = "Đã thêm ";
        if (type === "phone") msg += "SĐT";
        else if (type === "email") msg += "email";
        else msg += "ghi chú";

        addNotification(msg, 1);
      } else {
        addNotification(res.message || "Lỗi khi thêm", -1);
      }
    } catch (error) {
      addNotification("Lỗi: " + error.message, -1);
    }
  };

  const handleEmojiSelect = (emoji) => {
    setMessage((prev) => prev + emoji);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);
    setFiles((prevFiles) => [...prevFiles, ...files]);
    e.target.value = null;
  };

  const handlePaste = (e) => {
    const items = e.clipboardData.items;
    const files = [];
    for (let i = 0; i < items.length; i++) {
      const file = items[i].getAsFile();
      if (file) {
        files.push(file);
      }
    }
    setFiles((prevFiles) => [...prevFiles, ...files]);
  };

  const handleImageClick = () => {
    imageInputRef.current?.click();
    messageInputRef.current?.focus();
  };

  const handleFileClick = () => {
    fileInputRef.current?.click();
    messageInputRef.current?.focus();
  };

  const handleRemoveFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleMainMenuClick = (menu) => {
    setSelectedMainMenu(menu);
    if (menu === "messages") {
      setSelectedSubMenu("all");
    } else {
      setSelectedSubMenu("");
    }
  };

  const handleSubMenuClick = (subMenu) => {
    setSelectedSubMenu(subMenu);
  };

  // --- Send pipeline helpers -------------------------------------------------
  // Reconcile optimistic messages with server HTTP responses / WS echoes.
  // HTTP response is the authoritative ACK: zca-js Promise resolve means Zalo
  // has accepted the message. We no longer send `create_message_error` to the
  // server on timeout — the local watchdog is UI-only.
  const generateCliMsgId = () =>
    (typeof crypto !== "undefined" && crypto.randomUUID?.()) ||
    `${Date.now()}-${Math.random().toString(36).slice(2)}`;

  const patchMessages = useCallback((messages, matcher, patch) => {
    if (!Array.isArray(messages)) return messages;
    return messages.map((message) => {
      if (!matcher(message)) return message;
      const nextPatch = typeof patch === "function" ? patch(message) : patch;
      return nextPatch ? { ...message, ...nextPatch } : message;
    });
  }, []);

  const updateMessagesByMatcher = useCallback(
    (matcher, patch) => {
      setSelectedChat((pre) =>
        pre?.messages
          ? { ...pre, messages: patchMessages(pre.messages, matcher, patch) }
          : pre,
      );
      setContacts((pre) =>
        pre.map((contact) =>
          contact.messages
            ? {
                ...contact,
                messages:
                  patchMessages(contact.messages, matcher, patch) ||
                  contact.messages,
              }
            : contact,
        ),
      );
    },
    [patchMessages],
  );

  const updateMessageByCliMsgId = useCallback(
    (cliMsgId, patch) => {
      if (!cliMsgId) return;
      updateMessagesByMatcher(
        (message) => message.cliMsgId === cliMsgId,
        patch,
      );
    },
    [updateMessagesByMatcher],
  );

  const markImageMessageResolved = useCallback(
    (imageRef) => {
      if (!imageRef) return;

      updateMessagesByMatcher(
        (message) =>
          (imageRef._id && message._id === imageRef._id) ||
          (imageRef.msgId &&
            String(message.msgId) === String(imageRef.msgId)) ||
          (imageRef.cliMsgId &&
            message.cliMsgId === imageRef.cliMsgId &&
            message.batchIndex === imageRef.batchIndex),
        (message) => {
          releaseMessagePreview(message);
          return {
            previewSrc: undefined,
            localPreviewUrl: undefined,
          };
        },
      );
    },
    [releaseMessagePreview, updateMessagesByMatcher],
  );

  const clearSendWatchdog = useCallback((cliMsgId) => {
    if (!cliMsgId) return;
    const timerId = sendWatchdogsRef.current.get(cliMsgId);
    if (timerId) {
      window.clearTimeout(timerId);
      sendWatchdogsRef.current.delete(cliMsgId);
    }
  }, []);

  const cacheMediaRetryDraft = useCallback((cliMsgId, draft) => {
    if (!cliMsgId || !draft) return;
    mediaRetryCacheRef.current.set(cliMsgId, draft);
    setMediaRetryTick((tick) => tick + 1);
  }, []);

  const removeMediaRetryDraft = useCallback((cliMsgId) => {
    if (!cliMsgId) return;
    if (mediaRetryCacheRef.current.delete(cliMsgId)) {
      setMediaRetryTick((tick) => tick + 1);
    }
  }, []);

  const hasImageBatchForCliMsgId = useCallback((cliMsgId) => {
    if (!cliMsgId) return false;
    let imageCount = 0;

    const registerMessages = (messages) => {
      for (const message of messages || []) {
        if (message?.cliMsgId !== cliMsgId || message?.type !== "image") {
          continue;
        }
        imageCount += 1;
        if (imageCount > 1) return true;
      }
      return false;
    };

    if (registerMessages(selectedChatRef.current?.messages)) return true;
    for (const contact of contactsRef.current || []) {
      if (registerMessages(contact?.messages)) return true;
    }
    return false;
  }, []);

  const markSent = useCallback(
    (cliMsgId, { msgId, outboxId } = {}) => {
      clearSendWatchdog(cliMsgId);
      const shouldSkipMsgId = hasImageBatchForCliMsgId(cliMsgId);
      updateMessageByCliMsgId(cliMsgId, {
        isSending: false,
        sendingStatus: undefined,
        errorMessage: undefined,
        ...(!shouldSkipMsgId && msgId != null
          ? { msgId: String(msgId) }
          : {}),
        ...(outboxId ? { outboxId } : {}),
      });
      // Once a terminal state is reached there is nothing for reload-resync to
      // recover — drop the localStorage record immediately.
      removePending(cliMsgId);
      removeMediaRetryDraft(cliMsgId);
    },
    [
      clearSendWatchdog,
      hasImageBatchForCliMsgId,
      updateMessageByCliMsgId,
      removeMediaRetryDraft,
    ],
  );

  const markImageBatchSent = useCallback(
    (cliMsgId, { attachments, outboxId } = {}) => {
      clearSendWatchdog(cliMsgId);
      setSelectedChat((pre) =>
        pre?.messages
          ? {
              ...pre,
              messages: applyImageBatchAckToMessages(pre.messages, cliMsgId, {
                attachments,
                outboxId,
              }),
            }
          : pre,
      );
      setContacts((pre) =>
        pre.map((contact) =>
          contact.messages
            ? {
                ...contact,
                messages: applyImageBatchAckToMessages(
                  contact.messages,
                  cliMsgId,
                  {
                    attachments,
                    outboxId,
                  },
                ),
              }
            : contact,
        ),
      );
      removePending(cliMsgId);
      removeMediaRetryDraft(cliMsgId);
    },
    [clearSendWatchdog, removeMediaRetryDraft],
  );

  const markError = useCallback(
    (cliMsgId, errorMessage) => {
      clearSendWatchdog(cliMsgId);
      updateMessageByCliMsgId(cliMsgId, {
        isSending: false,
        sendingStatus: "error",
        errorMessage,
      });
      removePending(cliMsgId);
    },
    [clearSendWatchdog, updateMessageByCliMsgId],
  );

  const markQueued = useCallback(
    (cliMsgId, { outboxId } = {}) =>
      updateMessageByCliMsgId(cliMsgId, {
        isSending: true,
        sendingStatus: "queued",
        errorMessage: undefined,
        ...(outboxId ? { outboxId } : {}),
      }),
    [updateMessageByCliMsgId],
  );

  const mergePersistedSendMessages = useCallback((messages) => {
    const persistedMessages = normalizePersistedSendMessages(messages);
    if (persistedMessages.length === 0) return;

    setContacts((prevContacts) =>
      prevContacts.map((contact) => {
        const contactMessages = persistedMessages.filter((message) =>
          isMessageForScopedContact(message, contact),
        );
        if (contactMessages.length === 0) return contact;
        return {
          ...contact,
          messages: mergeIncomingMessagesWithOptimistic(
            contact.messages || [],
            contactMessages,
          ),
        };
      }),
    );

    setSelectedChat((prevChat) => {
      if (!prevChat) return prevChat;
      const chatMessages = persistedMessages.filter((message) =>
        isMessageForScopedContact(message, prevChat),
      );
      if (chatMessages.length === 0) return prevChat;
      return {
        ...prevChat,
        messages: mergeIncomingMessagesWithOptimistic(
          prevChat.messages || [],
          chatMessages,
        ),
      };
    });
  }, []);

  const scheduleSendWatchdog = useCallback(
    (cliMsgId, contactUid) => {
      if (!cliMsgId) return;
      clearSendWatchdog(cliMsgId);
      const timerId = window.setTimeout(() => {
        const stillSending = contactsRef.current
          .find((x) => x.uid === contactUid)
          ?.messages?.find((x) => x.cliMsgId === cliMsgId && x.isSending);
        if (stillSending) {
          markError(
            cliMsgId,
            "Không xác nhận được từ server sau 60s. Kiểm tra mạng và thử lại.",
          );
        }
      }, 60000);
      sendWatchdogsRef.current.set(cliMsgId, timerId);
    },
    [clearSendWatchdog, markError],
  );

  // Handle a send API promise: reconcile optimistic UI from HTTP response.
  // res shape: {status, data:{message:{msgId}}|{msgId}, outboxId?, willRetry?, message}
  const reconcileSendResponse = useCallback(
    (cliMsgId, promise) =>
      promise
        .then((res) => {
          if (res?.willRetry) {
            markQueued(cliMsgId, { outboxId: res.outboxId });
          } else if (res?.status === 1) {
            // Zalo accepted — HTTP ack is authoritative, no need to wait for echo.
            mergePersistedSendMessages(
              res.persistedMessages || res.data?.persistedMessages,
            );
            const zaloMsgId =
              res.data?.message?.msgId ||
              res.data?.attachment?.[0]?.msgId ||
              res.data?.msgId;
            markSent(cliMsgId, { msgId: zaloMsgId, outboxId: res.outboxId });
          } else {
            markError(cliMsgId, res?.message);
            if (res?.message) addNotification(res.message, res.status);
          }
          return res;
        })
        .catch((err) => {
          const msg = err?.message || "Mất kết nối";
          markError(cliMsgId, msg);
          addNotification(msg, -1);
          throw err;
        }),
    [markSent, markError, markQueued, addNotification, mergePersistedSendMessages],
  );

  const reconcileImageBatchSendResponse = useCallback(
    (cliMsgId, promise) =>
      promise
        .then((res) => {
          if (res?.willRetry) {
            markQueued(cliMsgId, { outboxId: res.outboxId });
          } else if (res?.status === 1) {
            markImageBatchSent(cliMsgId, {
              attachments: res.data?.attachment || [],
              outboxId: res.outboxId,
            });
          } else {
            markError(cliMsgId, res?.message);
            if (res?.message) addNotification(res.message, res.status);
          }
          return res;
        })
        .catch((err) => {
          const msg = err?.message || "Mất kết nối";
          markError(cliMsgId, msg);
          addNotification(msg, -1);
          throw err;
        }),
    [addNotification, markError, markImageBatchSent, markQueued],
  );

  const sendImageBatchDirect = useCallback(
    ({ cliMsgId, shopId, uid, isGroup, files }) => {
      cacheMediaRetryDraft(cliMsgId, {
        type: "image",
        request: { shopId, uid, isGroup },
        files,
      });
      scheduleSendWatchdog(cliMsgId, uid);
      return reconcileImageBatchSendResponse(
        cliMsgId,
        shopApi.sendImageV2({
          shopId,
          uid,
          isGroup,
          files,
          cliMsgId,
        }),
      );
    },
    [
      cacheMediaRetryDraft,
      scheduleSendWatchdog,
      reconcileImageBatchSendResponse,
    ],
  );

  const sendFileDirect = useCallback(
    ({ cliMsgId, shopId, id, isGroup, file }) => {
      cacheMediaRetryDraft(cliMsgId, {
        type: "file",
        request: { shopId, id, isGroup },
        file,
      });
      scheduleSendWatchdog(cliMsgId, id);
      return reconcileSendResponse(
        cliMsgId,
        zaloApi.sendFile({
          shopId,
          id,
          isGroup,
          file,
          cliMsgId,
        }),
      );
    },
    [cacheMediaRetryDraft, scheduleSendWatchdog, reconcileSendResponse],
  );

  const handleRetryMediaSend = useCallback(
    (cliMsgId) => {
      const draft = mediaRetryCacheRef.current.get(cliMsgId);
      if (!draft) return;

      updateMessageByCliMsgId(cliMsgId, {
        isSending: true,
        sendingStatus: undefined,
        errorMessage: undefined,
      });

      if (draft.type === "image") {
        sendImageBatchDirect({
          cliMsgId,
          ...draft.request,
          files: draft.files,
        });
        return;
      }

      sendFileDirect({
        cliMsgId,
        ...draft.request,
        file: draft.file,
      });
    },
    [sendFileDirect, sendImageBatchDirect, updateMessageByCliMsgId],
  );

  useEffect(
    () => () => {
      for (const timerId of sendWatchdogsRef.current.values()) {
        window.clearTimeout(timerId);
      }
      sendWatchdogsRef.current.clear();
      mediaRetryCacheRef.current.clear();
    },
    [],
  );

  const canRetryMediaMessage = (msg) =>
    msg?.uidFrom === "0" &&
    msg?.sendingStatus === "error" &&
    (msg?.type === "image" || msg?.type === "file") &&
    msg?.cliMsgId &&
    mediaRetryCacheRef.current.has(msg.cliMsgId);

  const renderMediaRetryAction = (msg) => {
    if (!canRetryMediaMessage(msg)) return null;
    return (
      <button
        type="button"
        onClick={() => handleRetryMediaSend(msg.cliMsgId)}
        className="ml-1 inline-flex items-center gap-1 text-blue-600 hover:text-blue-700 hover:underline"
      >
        <RotateCw className="h-3 w-3" />
        Thử lại
      </button>
    );
  };

  // Reload resync: on mount, ask the server for the final status of every
  // pending send we persisted in localStorage. sent → clean up; dead → mark
  // error; queued/sending/failed → leave; missing (server never saw it) →
  // clean up so the ghost doesn't linger forever.
  useEffect(() => {
    const byShop = getPendingByShop();
    const shopIds = Object.keys(byShop);
    if (shopIds.length === 0) return;
    let cancelled = false;
    (async () => {
      for (const shopId of shopIds) {
        const entries = byShop[shopId];
        const cliMsgIds = entries.map((e) => e.cliMsgId);
        try {
          const res = await outboxApi.getStatus(shopId, cliMsgIds);
          if (cancelled) return;
          const statuses = res?.statuses || {};
          for (const entry of entries) {
            const s = statuses[entry.cliMsgId];
            if (!s) {
              // Server never ingested — optimistic bubble is already gone
              // (reload wipes React state), so just drop the stale record.
              removePending(entry.cliMsgId);
              continue;
            }
            if (s.status === "sent") {
              mergePersistedSendMessages(s.persistedMessages);
              markSent(entry.cliMsgId, {
                msgId: s.msgId,
                outboxId: s.outboxId,
              });
            } else if (s.status === "dead") {
              markError(
                entry.cliMsgId,
                s.lastError || "Không gửi được sau nhiều lần thử",
              );
            }
            // pending/sending/failed → outbox worker still owns it; the next
            // WS `send_status` event will reconcile when a terminal state hits.
          }
        } catch (err) {
          console.warn("[outbox resync] failed for shop", shopId, err?.message);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [markSent, markError, mergePersistedSendMessages]);

  const handleSendMessage = async (tempShopId, contactUid) => {
    const richResult =
      isAdvancedCompose && hasContent(messageHtml)
        ? htmlToZaloStyles(messageHtml)
        : null;
    const effectiveText = richResult ? richResult.text : message;
    const effectiveStyles = richResult ? richResult.styles : null;

    if (!effectiveText?.trim() && files.length === 0) return;

    // In group mode, use activeContactShop; otherwise use selectedShop
    const actualShop = isGroupMode
      ? activeContactShop || selectedShop
      : selectedShop;

    if ((selectedChat.staffIds?.length ?? 0) === 0)
      shopApi.updateContact({
        _id: selectedChat._id,
        shopId: actualShop._id,
        staffIds: [user._id],
      });
    const newMessages = [];

    // Filter image files for grouped sending
    const imageFiles = files.filter((f) => f.type.startsWith("image/"));
    const otherFiles = files.filter((f) => !f.type.startsWith("image/"));

    // Send all images in a single request (zca-js handles grouped images automatically).
    // One cliMsgId covers the whole batch since zca-js sends them as a single request,
    // and the echo from Zalo maps each returned attachment msgId back to our optimistic entries.
    if (imageFiles.length > 0) {
      const imageCliMsgId = generateCliMsgId();
      sendImageBatchDirect({
        cliMsgId: imageCliMsgId,
        shopId: actualShop._id,
        uid: selectedChat.uid,
        isGroup: selectedChat.isGroup,
        files: imageFiles,
      });

      const optimisticImageMessages = buildOptimisticImageMessages({
        files: imageFiles,
        cliMsgId: imageCliMsgId,
        user,
      });
      for (const optimisticImage of optimisticImageMessages) {
        if (optimisticImage.localPreviewUrl?.startsWith("blob:")) {
          previewObjectUrlsRef.current.add(optimisticImage.localPreviewUrl);
        }
        newMessages.push(optimisticImage);
      }
    }

    // Send other files (non-images)
    for (const file of otherFiles) {
      const fileCliMsgId = generateCliMsgId();
      sendFileDirect({
        cliMsgId: fileCliMsgId,
        shopId: actualShop._id,
        id: selectedChat.uid,
        isGroup: selectedChat.isGroup,
        file,
      });
      newMessages.push({
        type: "file",
        uidFrom: "0",
        content: file.name,
        dateAction: new Date(),
        isSending: true,
        staffId: user._id,
        staffName: user.name,
        cliMsgId: fileCliMsgId,
      });
    }

    if (files.length > 0) {
      scrollToLastMessage(500 + 500 * imageFiles.length);
    }

    if (effectiveText.trim()) {
      // Idempotency key: shared between optimistic bubble, outbox row, and HTTP response.
      // zca-js generates its OWN internal cliMsgId for Zalo — this one is purely for
      // client ↔ server reconciliation.
      const cliMsgId = generateCliMsgId();
      addPending(cliMsgId, {
        shopId: actualShop._id,
        contactUid: selectedChat.uid,
        type: "text",
        content: effectiveText.trim().slice(0, 200),
      });
      if (repMessage) {
        const quotePromise = selectedChat.isGroup
          ? shopApi.quoteGroup({
              shopId: actualShop._id,
              id: selectedChat.uid,
              content: effectiveText,
              ownerId:
                repMessage.uidFrom === "0"
                  ? actualShop.zaloId
                  : repMessage.uidFrom,
              msgId: repMessage.msgId,
              cliMsgId: repMessage.cliMsgId,
              type: repMessage.type,
              msgTs: repMessage.ts,
              msgContent: repMessage.content,
            })
          : shopApi.quote({
              shopId: actualShop._id,
              id: selectedChat.uid,
              content: effectiveText,
              ownerId:
                repMessage.uidFrom === "0"
                  ? actualShop.zaloId
                  : repMessage.uidFrom,
              msgId: repMessage.msgId,
              cliMsgId: repMessage.cliMsgId,
              type: repMessage.type,
              msgTs: repMessage.ts,
              msgContent: repMessage.content,
            });
        reconcileSendResponse(cliMsgId, quotePromise);
      } else {
        // Route via zaloApi.sendMessage (which supports styles) when we have
        // rich-text styles OR mentions; otherwise use the faster shopApi path
        // for plain text to preserve existing behavior for 500+ live shops.
        const hasStyles = effectiveStyles && effectiveStyles.length > 0;
        const sendPromise =
          !hasStyles && mentions.length === 0
            ? shopApi.sendMessage({
                shopId: actualShop._id,
                uid: selectedChat.uid,
                content: effectiveText,
                isGroup: selectedChat.isGroup,
                userId: user._id,
                cliMsgId,
              })
            : zaloApi.sendMessage({
                shopId: actualShop._id,
                id: selectedChat.uid,
                isGroup: selectedChat.isGroup,
                userId: user._id,
                message: {
                  msg: effectiveText,
                  mentions,
                  ...(hasStyles ? { styles: effectiveStyles } : {}),
                },
                cliMsgId,
              });
        reconcileSendResponse(cliMsgId, sendPromise);
      }
      newMessages.push({
        type: "text",
        uidFrom: "0",
        content: effectiveText.trim(),
        styles:
          effectiveStyles && effectiveStyles.length > 0
            ? effectiveStyles
            : undefined,
        dateAction: new Date(),
        isSending: true,
        staffId: user._id,
        staffName: user.name,
        cliMsgId,
      });
      scrollToLastMessage();
    }
    for (const nm of newMessages) {
      if (!nm.cliMsgId || nm.type === "image" || nm.type === "file") continue;
      scheduleSendWatchdog(nm.cliMsgId, contactUid);
    }
    setSelectedChat((pre) => ({
      ...pre,
      messages: [
        ...(pre?.messages || []),
        ...newMessages.filter((m) => m.type === "text"),
        ...newMessages.filter(
          (m) => m.type === "image" || m.type === "file" || m.type === "video",
        ),
      ],
    }));
    setContacts((pre) =>
      pre.map((c) =>
        c._id === selectedChat._id
          ? {
              ...c,
              messages: [
                ...(c?.messages || []),
                ...newMessages.filter((m) => m.type === "text"),
                ...newMessages.filter(
                  (m) =>
                    m.type === "image" ||
                    m.type === "file" ||
                    m.type === "video",
                ),
              ],
            }
          : c,
      ),
    );
    setMessage("");
    setMessageHtml("");
    setMentions([]);
    setRepMessage(null);

    if (messageInputRef?.current) {
      messageInputRef.current.style.height = "24px";
      messageInputRef.current.focus();
    }

    setFiles([]);
  };

  /**
   * Open the conversation with a contact referenced by a contact card.
   * Mirrors SearchModal.handleMessageClick: check via getContactByUid,
   * create-if-missing via createContacts, then delegate the actual
   * selection/message-load to the `newContact` useEffect so group mode,
   * message fetching and composer focus all behave the same way as the
   * "Thêm bạn → Nhắn tin" flow.
   */
  const handleOpenCardConversation = useCallback(
    async (card) => {
      if (!card?.contactUid) return;
      const actualShop = isGroupMode
        ? activeContactShop || selectedShop
        : selectedShop;
      if (!actualShop?._id) return;

      try {
        const check = await shopApi.getContactByUid(
          actualShop._id,
          card.contactUid,
        );
        if (check?.status === 1 && check?.data?.[0]) {
          setNewContact({ uid: card.contactUid, _shopId: actualShop._id });
          return;
        }

        // Not in DB yet — create from the card payload (mirrors
        // SearchModal.handleMessageClick when phone-search returns a stranger).
        const created = await shopApi.createContacts({
          staffIds: auth.user?._id ? [auth.user._id] : [],
          shopId: actualShop._id,
          uid: card.contactUid,
          name: card.contactName || "",
          zaloName: card.contactName || "",
          avatar: card.contactAvatar || "",
          phone: card.phoneNumber || "",
          isFriend: false,
        });
        if (created?.status === 1) {
          setNewContact({ uid: card.contactUid, _shopId: actualShop._id });
        } else {
          addNotification(
            created?.message || "Không thể mở danh thiếp",
            created?.status ?? -1,
          );
        }
      } catch (err) {
        addNotification(err?.message || "Lỗi mạng khi mở danh thiếp", -1);
      }
    },
    [
      isGroupMode,
      activeContactShop,
      selectedShop,
      auth.user?._id,
      addNotification,
    ],
  );

  const handleSendContactCards = async (selectedContacts) => {
    if (!selectedContacts?.length) return;
    setIsOpenSendCardModal(false);

    const actualShop = isGroupMode
      ? activeContactShop || selectedShop
      : selectedShop;
    if (!actualShop || !selectedChat) return;

    const optimisticMessages = [];
    for (const contact of selectedContacts) {
      const cliMsgId = generateCliMsgId();
      const phoneNumber = (contact.phoneList || [])[0] || contact.phone || "";
      addPending(cliMsgId, {
        shopId: actualShop._id,
        contactUid: selectedChat.uid,
        type: "card",
        content: `Danh thiếp: ${contact.displayName || ""}`.slice(0, 200),
      });
      const optimistic = {
        type: "card",
        uidFrom: "0",
        content: contact.displayName || "[Danh thiếp]",
        dateAction: new Date(),
        isSending: true,
        staffId: user?._id,
        staffName: user?.name,
        cliMsgId,
        card: {
          contactUid: contact.uid,
          contactName: contact.displayName || "",
          contactAvatar: contact.avatar || "",
          phoneNumber,
        },
      };
      optimisticMessages.push(optimistic);
      reconcileSendResponse(
        cliMsgId,
        zaloApi.sendCard({
          shopId: actualShop._id,
          id: selectedChat.uid,
          isGroup: selectedChat.isGroup,
          userId: contact.uid,
          actorId: user?._id,
          phoneNumber: phoneNumber || undefined,
          cliMsgId,
        }),
      );
    }

    setSelectedChat((pre) => ({
      ...pre,
      messages: [...(pre?.messages || []), ...optimisticMessages],
    }));
    setContacts((pre) =>
      pre.map((c) =>
        c._id === selectedChat._id
          ? { ...c, messages: [...(c?.messages || []), ...optimisticMessages] }
          : c,
      ),
    );
    scrollToLastMessage();

    // Safety net: surface stuck sends after 60s, same as handleSendMessage.
    setTimeout(() => {
      for (const om of optimisticMessages) {
        const stillSending = contactsRef.current
          .find((x) => x.uid === selectedChat.uid)
          ?.messages?.find((x) => x.cliMsgId === om.cliMsgId && x.isSending);
        if (stillSending) {
          markError(
            om.cliMsgId,
            "Không xác nhận được từ server sau 60s. Kiểm tra mạng và thử lại.",
          );
        }
      }
    }, 60000);
  };

  function getImageInfo(url) {
    const img = new Image();

    const promise = new Promise((resolve, reject) => {
      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;

        resolve({ width, height });
      };

      // Reject promise on error
      img.onerror = reject;
    });

    img.src = url;

    return promise;
  }

  const handleAddFriend = async (contentAddFriend) => {
    // Await updateContact to prevent race condition where staffIds is empty
    // when contact_updated event arrives after accepting friend request
    const actualShop = getActualShop();
    if ((selectedChat.staffIds?.length ?? 0) === 0) {
      await shopApi.updateContact({
        _id: selectedChat._id,
        shopId: actualShop._id,
        staffIds: [user._id],
      });
    }
    const resAddFriend = await shopApi.addFriend({
      uid: selectedChat.uid,
      contentAddFriend: contentAddFriend,
      contactId: selectedChat._id,
      shopId: actualShop._id,
      zaloId: actualShop.zaloId,
      staffId: user._id,
    });
    if (resAddFriend.status !== 1) {
      addNotification(resAddFriend.message, resAddFriend.status);
      return;
    }
    if (resAddFriend.message === "Tự động kết bạn")
      addNotification("Kết bạn thành công", 1);
    else addNotification("Gửi lời mời kết bạn thành công", 1);
  };

  const handleRemoveFriend = async () => {
    try {
      const actualShop = getActualShop();
      const resRemoveFriend = await shopApi.removeFriend({
        uid: selectedChat.uid,
        shopId: actualShop._id,
        zaloId: actualShop.zaloId,
        staffId: user._id,
      });
      if (resRemoveFriend.status !== 1)
        addNotification(resRemoveFriend.message, resRemoveFriend.status);
    } catch (error) {
      addNotification(error.message, -1);
    }
  };

  const handleEditName = async () => {
    const newName =
      selectedChatName === "" ? selectedChat?.zaloName : selectedChatName;

    setIsRenaming(true);
    const actualShop = getActualShop();
    const res = await shopApi.renameZalo({
      contactId: selectedChat._id,
      shopId: actualShop._id,
      uid: selectedChat.uid,
      newName: newName,
      zaloName: selectedChat.zaloName,
    });
    setIsRenaming(false);
    setIsEditingName(false);
    if (res.status === 1) {
      addNotification("Đổi tên thành công", res.status);
      setSelectedChatName(newName);
      setContacts((prev) =>
        prev.map((c) =>
          c._id === selectedChat._id ? { ...c, name: newName } : c,
        ),
      );
      setSelectedChat((prev) => (prev ? { ...prev, name: newName } : prev));
    } else {
      addNotification(res.message, res.status);
      setSelectedChatName(selectedChat?.name);
    }
  };

  const handleRepMessageClick = (msg) => {
    setRepMessage(msg);
    messageInputRef?.current?.focus();
  };

  const handleShareClick = (msg) => {
    setShareMessage(msg);
    setIsOpenShareModal(true);
  };

  const handleSortModeChange = async (mode) => {
    setSortMode(mode);
    setActivePresetId(null);
    try {
      await userApi.updateById({
        _id: user._id,
        preferences: {
          ...user.preferences,
          chatList: { ...user.preferences?.chatList, sortMode: mode },
        },
      });
    } catch (error) {
      console.error("Error saving sort mode:", error);
    }
  };

  const handleRoleChange = (nextRole) => {
    setFilterRole(nextRole);
    localStorage.setItem("filterRole", nextRole);
    setActivePresetId(null);
  };

  // Apply a preset: clears all filter selections then applies the preset's filter set.
  const handleApplyPreset = ({ presetId, resolved }) => {
    setActivePresetId(presetId);
    setSelectedCategories(resolved.categories || []);
    setSelectedTags(resolved.tagIds || []);
    setSelectedTagZalos(resolved.tagZaloIds || []);
    setSelectedStaffs(resolved.staffIds || []);
    setSelectedPipelineStageIds(resolved.pipelineStageIds || []);
    setNeedsReplyMinutes(resolved.needsReplyMinutes ?? null);
    setNewCustomerDays(resolved.newCustomerDays ?? null);
    setHasContactInfo(resolved.hasContactInfo ?? null);
    setUpcomingBirthdayDays(resolved.upcomingBirthdayDays ?? null);
    if (resolved.sortMode) setSortMode(resolved.sortMode);
  };

  // Update a contact's pipeline stage (nullable = clear).
  const handleUpdatePipelineStage = async (stageId) => {
    if (!selectedChat?._id) return;
    const prev = selectedChat.pipelineStageId;
    // Optimistic update
    setSelectedChat((c) => ({ ...c, pipelineStageId: stageId }));
    setContacts((list) =>
      list.map((c) =>
        c._id === selectedChat._id ? { ...c, pipelineStageId: stageId } : c,
      ),
    );
    try {
      const res = await shopApi.updateContact({
        _id: selectedChat._id,
        pipelineStageId: stageId,
      });
      if (res?.status !== 1) throw new Error(res?.message || "update failed");
    } catch (err) {
      console.error("updatePipelineStage failed:", err);
      // Rollback
      setSelectedChat((c) => ({ ...c, pipelineStageId: prev }));
      setContacts((list) =>
        list.map((c) =>
          c._id === selectedChat._id ? { ...c, pipelineStageId: prev } : c,
        ),
      );
    }
  };

  const getUser = async (notTryAgain) => {
    try {
      const res = await userApi.get(auth.user._id);
      if (res.status === 1) {
        setUser(res.data);
        // Load sort mode from preferences
        if (res.data?.preferences?.chatList?.sortMode) {
          setSortMode(res.data.preferences.chatList.sortMode);
        }
      }
    } catch (error) {
      console.log(error);
      if (notTryAgain) return;
      setTimeout(() => getUser(true), 3000);
    }
  };

  const getShopGroups = async () => {
    try {
      const res = await shopGroupApi.getAll(auth.user._id);
      if (res.status === 1) {
        setShopGroupsList(res.data || []);
      }
    } catch (error) {
      console.log("Error fetching shop groups:", error);
    }
  };

  const getContacts = async () => {
    setContactPage(1);
    setHasMoreContacts(true);
    hasMoreContactsRef.current = true;
    const filters = { categories: selectedCategories, staffId: auth.user._id };
    const resContacts = await shopApi.getContacts(
      selectedShop._id,
      0,
      1,
      20,
      filters,
    );
    if (resContacts.status === 1) {
      // Merge new data while preserving read state for recently read conversations
      setContacts((prev) =>
        prev.length > 0
          ? mergeContactsPreservingReadState(resContacts.data, prev)
          : resContacts.data,
      );
    }
  };

  // Load contacts from multiple shops (for group mode)
  const loadContactsFromShops = async (shopList, page = 1, append = false) => {
    const filters = {
      categories: selectedCategoriesRef.current,
      staffId: auth.user._id,
    };
    const allContacts = [];
    const allTags = [];
    const allTagZalos = [];
    let hasMore = false;

    // Only load tags on first page load
    const shouldLoadTags = page === 1 && !append;

    for (const shop of shopList) {
      try {
        const promises = [shopApi.getContacts(shop._id, 0, page, 50, filters)];

        // Fetch tags and tagZalos if needed
        if (shouldLoadTags) {
          promises.push(tagApi.getByShopId(shop._id));
          promises.push(shopApi.getTagZalos(shop._id));
        }

        const [res, resTags, resTagZalos] = await Promise.all(promises);

        if (res.status === 1) {
          // Add shopId to each contact so we know which shop it belongs to
          const contactsWithShop = res.data.map((c) => ({
            ...c,
            _shopId: shop._id,
            _shopName: shop.name,
            _shopAvatar: shop.avatar,
          }));
          allContacts.push(...contactsWithShop);
          // If any shop has more data, we have more to load
          if (res.hasMore !== false && res.data.length > 0) {
            hasMore = true;
          }
        }

        // Process tags
        if (shouldLoadTags && resTags?.status === 1) {
          const tagsWithShop = resTags.data.map((t) => ({
            ...t,
            _shopId: shop._id,
          }));
          allTags.push(...tagsWithShop);
        }

        // Process tagZalos
        if (shouldLoadTags && resTagZalos?.status === 1) {
          const tagZalosWithShop = resTagZalos.data.map((t) => ({
            ...t,
            _shopId: shop._id,
          }));
          allTagZalos.push(...tagZalosWithShop);
        }
      } catch (err) {
        console.error(`Error loading data from shop ${shop.name}:`, err);
      }
    }

    // Sort by last message date
    allContacts.sort((a, b) => {
      const dateA = a.messages?.[a.messages.length - 1]?.dateAction || 0;
      const dateB = b.messages?.[b.messages.length - 1]?.dateAction || 0;
      return new Date(dateB) - new Date(dateA);
    });

    if (append) {
      setContacts((prev) => {
        const existingIds = new Set(prev.map((c) => c._id));
        const newContacts = allContacts.filter((c) => !existingIds.has(c._id));
        return [...prev, ...newContacts];
      });
    } else {
      setContacts(allContacts);
      if (shouldLoadTags) {
        setGroupTags(allTags);
        setGroupTagZalos(allTagZalos);
      }
    }
    setHasMoreContacts(hasMore);
    hasMoreContactsRef.current = hasMore;
  };

  const getContactsWithoutMessages = async () => {
    const resContacts = await shopApi.getContactsWithoutMessages(
      selectedShop._id,
    );
    if (resContacts.status === 1)
      setContacts((pre) =>
        resContacts.data.map((c) => ({
          ...c,
          messages: pre.find((x) => x._id === c._id)?.messages ?? [],
        })),
      );
  };

  const getTagZalos = async (shopId, notTryAgain) => {
    try {
      const res = await shopApi.getTagZalos(shopId);
      if (res.status === 1) {
        setTagZalos(res.data);
        // Also update groupTagZalos
        setGroupTagZalos((prev) => {
          const otherShopsTags = prev.filter((t) => t._shopId !== shopId);
          const newShopTags = res.data.map((t) => ({ ...t, _shopId: shopId }));
          return [...otherShopsTags, ...newShopTags];
        });
      }
    } catch (error) {
      console.log(error);
      if (notTryAgain) return;
      setTimeout(() => getTagZalos(shopId, true), 3000);
    }
  };

  const handleChangeStaffManageClick = async (isChecked, staff) => {
    const newStaffIds = isChecked
      ? [...selectedChat.staffIds, staff._id]
      : selectedChat.staffIds.filter((sId) => sId !== staff._id);
    setContacts((preContacts) =>
      preContacts.map((c) =>
        c._id === selectedChat._id
          ? {
              ...c,
              staffIds: newStaffIds,
            }
          : c,
      ),
    );
    const actualShop = getActualShop();
    shopApi
      .updateContact({
        _id: selectedChat._id,
        shopId: actualShop._id,
        staffIds: newStaffIds,
      })
      .then((res) => {
        socketRef?.current?.send(
          JSON.stringify({
            type: "sync_data",
            shopId: actualShop?._id,
            uid: selectedChat.uid,
          }),
        );
        addNotification(
          `${!isChecked ? "Gỡ quyền" : "Phân quyền"} ${
            res.status === 1 ? "thành công" : "thất bại"
          }`,
          res.status,
        );
        if (res.status !== 1) {
          getContactsWithoutMessages();
        }
      });
  };

  const handleAddRemoveTag = async (tag) => {
    let res;
    const isRemoving = selectedChat.tagIds?.includes(tag._id);
    const tagAction = isRemoving ? "remove_tag_akabiz" : "add_tag_akabiz";

    if (isRemoving) {
      // if (window.confirm(`Bạn của muốn gỡ tag ${tag.name} không?`)) {
      setContacts((preContacts) =>
        preContacts.map((c) =>
          c._id === selectedChat._id
            ? {
                ...c,
                tagIds: c.tagIds.filter((tagId) => tagId !== tag._id),
              }
            : c,
        ),
      );
      res = await shopApi.updateContact({
        _id: selectedChat._id,
        shopId: getActualShop()._id,
        uid: selectedChat.uid,
        tagIds: selectedChat.tagIds.filter((tagId) => tagId !== tag._id),
        tagAction,
        tagName: tag.name,
      });
      // } else return;
    } else {
      setContacts((preContacts) =>
        preContacts.map((c) =>
          c._id === selectedChat._id
            ? {
                ...c,
                tagIds: c.tagIds ? [...c.tagIds, tag._id] : [tag._id],
              }
            : c,
        ),
      );
      res = await shopApi.updateContact({
        _id: selectedChat._id,
        shopId: getActualShop()._id,
        uid: selectedChat.uid,
        tagIds: selectedChat.tagIds
          ? [...selectedChat.tagIds, tag._id]
          : [tag._id],
        tagAction,
        tagName: tag.name,
      });
    }
    if (res.status !== 1) {
      await getContactsWithoutMessages();
    }
  };

  const scrollToLastMessage = (timeout = 200) => {
    setTimeout(
      () => lastMessageDivRef?.current?.scrollIntoView({ behavior: "smooth" }),
      timeout,
    );
  };

  // Merge consecutive images from same sender into a single "images" type message
  // Does NOT insert timeline entries or reverse - that's handled by displayMessages
  const mergeImageMessages = (messageList) => {
    if (!messageList || messageList.length === 0) return [];
    const mergedMessages = [];
    let tempImages = [];

    for (const message of messageList) {
      // Check if this image can be merged with previous images:
      // 1. Must be an image type
      // 2. Must not be undone
      // 3. Must be from same sender
      // 4. Must be within 3 seconds of last image in tempImages
      const canMerge =
        message.type === "image" &&
        !message.isUndo &&
        tempImages.length > 0 &&
        tempImages[tempImages.length - 1].uidFrom === message.uidFrom &&
        Math.abs(
          new Date(message.dateAction) -
            new Date(tempImages[tempImages.length - 1].dateAction),
        ) <= 1000; // 1 seconds

      if (
        message.type === "image" &&
        !message.isUndo &&
        (tempImages.length === 0 || canMerge)
      ) {
        tempImages.push(message);
      } else {
        if (tempImages.length > 1) {
          // Add merged images as a single object
          mergedMessages.push({
            ...tempImages[tempImages.length - 1],
            type: "images",
            imgs: tempImages.map((t) => t.img),
            previewImgs: tempImages.map(
              (t) => t.previewSrc || t.localPreviewUrl || undefined,
            ),
            imageRefs: tempImages.map((t) => ({
              _id: t._id,
              msgId: t.msgId,
              cliMsgId: t.cliMsgId,
              batchIndex: t.batchIndex,
            })),
          });
        } else if (tempImages.length === 1) mergedMessages.push(tempImages[0]);
        tempImages = [];
        if (message.type === "image" && !message.isUndo)
          tempImages.push(message);
        else mergedMessages.push(message);
      }
    }

    // Check if there are any images left to merge after the loop
    if (tempImages.length > 1) {
      mergedMessages.push({
        ...tempImages[tempImages.length - 1],
        type: "images",
        imgs: tempImages.map((t) => t.img),
        previewImgs: tempImages.map(
          (t) => t.previewSrc || t.localPreviewUrl || undefined,
        ),
        imageRefs: tempImages.map((t) => ({
          _id: t._id,
          msgId: t.msgId,
          cliMsgId: t.cliMsgId,
          batchIndex: t.batchIndex,
        })),
      });
    } else if (tempImages.length === 1) mergedMessages.push(tempImages[0]);

    return mergedMessages;
  };

  useEffect(() => {
    contactsRef.current = contacts;
  }, [contacts]);

  useEffect(() => {
    selectedChatRef.current = selectedChat;
  }, [selectedChat]);

  // Fetch Zalo online status for the currently-focused contact. Refresh every 30s
  // while focused; stop on unmount or contact change. Groups are skipped.
  useEffect(() => {
    const uid = selectedChat?.uid;
    const isGroup = !!selectedChat?.isGroup;
    const shop = getActualShop();
    if (!uid || isGroup || !shop?._id || shop?.isLogin === false) {
      setSelectedChatOnline(null);
      return;
    }

    let cancelled = false;
    const fetchOnce = async () => {
      try {
        const res = await shopApi.lastOnline({
          shopId: shop._id,
          uid,
        });
        if (cancelled) return;
        if (res?.status === 1 && res.data) {
          setSelectedChatOnline({ uid, ...res.data });
        }
      } catch (e) {
        // silent — không muốn làm phiền user khi Zalo rate-limit/fail
      }
    };

    fetchOnce();
    const timer = setInterval(fetchOnce, 30_000);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [selectedChat?.uid, selectedChat?.isGroup, getActualShop]);

  // Hydrate the "recently marked as read" grace map from localStorage on mount
  // so a page reload within 30s of clicking doesn't flicker the conversation
  // back to unread while server/WebSocket state settles.
  useEffect(() => {
    const userId = auth?.user?._id;
    if (!userId || typeof window === "undefined" || !window.localStorage)
      return;
    try {
      const raw = window.localStorage.getItem(recentlyReadStorageKey(userId));
      if (!raw) return;
      const entries = JSON.parse(raw);
      if (!Array.isArray(entries)) return;
      const now = Date.now();
      for (const [key, ts] of entries) {
        if (
          typeof key === "string" &&
          typeof ts === "number" &&
          now - ts < RECENTLY_READ_GRACE_MS
        ) {
          markedAsReadRef.current.set(key, ts);
        }
      }
    } catch {
      // corrupted storage — ignore and start fresh
    }
  }, [auth?.user?._id]);

  // Persist the in-memory grace map so it survives reload within the TTL.
  const persistMarkedAsRead = () => {
    try {
      const userId = auth?.user?._id;
      if (!userId || typeof window === "undefined" || !window.localStorage)
        return;
      const now = Date.now();
      const entries = [];
      for (const [key, ts] of markedAsReadRef.current.entries()) {
        if (typeof ts === "number" && now - ts < RECENTLY_READ_GRACE_MS) {
          entries.push([key, ts]);
        }
      }
      if (entries.length === 0) {
        window.localStorage.removeItem(recentlyReadStorageKey(userId));
      } else {
        window.localStorage.setItem(
          recentlyReadStorageKey(userId),
          JSON.stringify(entries),
        );
      }
    } catch {
      // ignore storage errors (quota exceeded, privacy mode, etc.)
    }
  };

  // Helper to mark a conversation as read in the tracking map
  // Stores both _id and uid to handle key mismatch in socket payloads
  const markAsReadInRef = (contact) => {
    const now = Date.now();
    if (contact._id) markedAsReadRef.current.set(contact._id, now);
    if (contact.uid) markedAsReadRef.current.set(contact.uid, now);
    persistMarkedAsRead();
  };

  // Helper to invalidate the "recently read" grace for a contact.
  // Called when a new inbound message arrives so the UI can re-show unread.
  const clearRecentlyReadMark = (contact) => {
    if (contact?._id) markedAsReadRef.current.delete(contact._id);
    if (contact?.uid) markedAsReadRef.current.delete(contact.uid);
    persistMarkedAsRead();
  };

  // Returns true if any staff (owner or assigned) has unread on this contact.
  // Used for owner/admin view where they oversee all staff unread.
  const hasAnyUnread = (c) =>
    (c?.unreadStaffIds?.length > 0) ||
    Object.values(c?.unreadCounts || {}).some((v) => Number(v) > 0);

  // Returns true only if CURRENT USER has unread on this contact.
  // Used for regular staff view so they don't see peer staff's unread.
  const hasOwnUnread = (c) =>
    c?.unreadStaffIds?.includes(auth.user._id) ||
    Number(c?.unreadCounts?.[auth.user._id] || 0) > 0;

  // True if current user is shop owner / admin / super_admin.
  // Mirrors the permission check used for showPermissionButton (line ~4149).
  const isOwnerOrAdmin = () =>
    Boolean(
      user?.role?.includes("super_admin") ||
        user?.role?.includes("admin") ||
        user?._id === selectedShop?.staffId ||
        user?.shopRoles
          ?.find((sr) => sr.shopId === selectedShop?._id)
          ?.role?.includes("admin"),
    );

  // Role-aware wrapper: owner/admin sees team-wide unread,
  // regular staff sees only their own.
  const shouldShowUnread = (c) =>
    isOwnerOrAdmin() ? hasAnyUnread(c) : hasOwnUnread(c);

  // Helper to check if a conversation was recently marked as read
  // Uses 30s grace (RECENTLY_READ_GRACE_MS) and checks both _id and uid
  const wasRecentlyMarkedAsRead = (contact) => {
    const id = contact?._id || contact;
    const uid = contact?.uid;
    const now = Date.now();
    let pruned = false;

    const checkKey = (key) => {
      if (!key) return false;
      const timestamp = markedAsReadRef.current.get(key);
      if (!timestamp) return false;
      if (now - timestamp < RECENTLY_READ_GRACE_MS) return true;
      // Clean up expired entries
      markedAsReadRef.current.delete(key);
      pruned = true;
      return false;
    };

    const result = checkKey(id) || checkKey(uid);
    if (pruned) persistMarkedAsRead();
    return result;
  };

  // Helper to merge new contacts data while preserving local unreadStaffIds
  // for conversations that are selected or recently marked as read
  const mergeContactsPreservingReadState = (
    newContacts,
    prevContacts,
    { mergeMessages = false } = {},
  ) => {
    const prevContactsMap = new Map(prevContacts.map((c) => [c._id, c]));
    const isAdminView = isOwnerOrAdmin();

    return newContacts.map((newContact) => {
      const prevContact = prevContactsMap.get(newContact._id);
      if (!prevContact) return newContact;
      return mergeRealtimeContact(prevContact, newContact, {
        authUserId: auth.user._id,
        isSelectedChat: selectedChatRef.current?._id === newContact._id,
        recentlyRead: wasRecentlyMarkedAsRead(newContact),
        isAdminView,
        preserveExistingMessages: true,
        mergeMessages,
      });
    });
  };

  const applyRealtimeContactState = (contact, shop, options = {}) => {
    if (!contact || !shop?._id) return null;

    const contactWithShop = attachRealtimeShopMetadata(contact, shop);
    const selectedChatShopId =
      selectedChatRef.current?._shopId || selectedChatRef.current?.shopId;
    const isSelectedChat =
      selectedChatRef.current?._id === contactWithShop._id ||
      (selectedChatRef.current?.uid === contactWithShop.uid &&
        selectedChatShopId === contactWithShop._shopId);
    const recentlyRead = wasRecentlyMarkedAsRead(contactWithShop);

    setContacts((prevContacts) =>
      upsertRealtimeContact(prevContacts, contactWithShop, {
        selectedCategories: selectedCategoriesRef.current,
        authUserId: auth.user._id,
        isSelectedChat,
        recentlyRead,
        isAdminView: isOwnerOrAdmin(),
        insertAtStart: options.insertAtStart ?? true,
        preserveExistingMessages: options.preserveExistingMessages ?? true,
        mergeMessages: options.mergeMessages ?? false,
      }),
    );

    if (isSelectedChat && contactWithShop.name) {
      setSelectedChatName(contactWithShop.name);
    }

    setSelectedChat((prevChat) => {
      if (!prevChat) return prevChat;
      const prevChatShopId = prevChat._shopId || prevChat.shopId;
      const isSameChat =
        prevChat._id === contactWithShop._id ||
        (prevChat.uid === contactWithShop.uid &&
          prevChatShopId === contactWithShop._shopId);
      if (!isSameChat) return prevChat;

      return mergeRealtimeContact(prevChat, contactWithShop, {
        authUserId: auth.user._id,
        isSelectedChat: true,
        recentlyRead,
        isAdminView: isOwnerOrAdmin(),
        preserveExistingMessages:
          options.preserveSelectedChatMessages ?? true,
        mergeMessages: options.mergeMessages ?? false,
      });
    });

    return contactWithShop;
  };

  const applyReactionEventsToChatState = useCallback((reactionEvents = []) => {
    if (!Array.isArray(reactionEvents) || reactionEvents.length === 0) return;

    setContacts((prevContacts) => {
      let didChange = false;
      const nextContacts = prevContacts.map((contact) => {
        const nextMessages = applyReactionEventsToMessages(
          contact.messages,
          reactionEvents,
        );

        if (nextMessages === contact.messages) return contact;

        didChange = true;
        return {
          ...contact,
          messages: nextMessages,
        };
      });

      return didChange ? nextContacts : prevContacts;
    });

    setSelectedChat((prevChat) => {
      if (!prevChat) return prevChat;

      const nextMessages = applyReactionEventsToMessages(
        prevChat.messages,
        reactionEvents,
      );

      if (nextMessages === prevChat.messages) return prevChat;

      return {
        ...prevChat,
        messages: nextMessages,
      };
    });
  }, []);

  const replaceReactsInChatState = useCallback((messageReactions = []) => {
    if (!Array.isArray(messageReactions) || messageReactions.length === 0) return;

    const byMsgId = new Map();
    const byCliMsgId = new Map();
    for (const mr of messageReactions) {
      const reacts = Array.isArray(mr?.reacts) ? mr.reacts : [];
      if (mr?.msgId !== undefined && mr?.msgId !== null && mr.msgId !== "") {
        byMsgId.set(String(mr.msgId), reacts);
      }
      if (
        mr?.cliMsgId !== undefined &&
        mr?.cliMsgId !== null &&
        mr.cliMsgId !== ""
      ) {
        byCliMsgId.set(String(mr.cliMsgId), reacts);
      }
    }

    if (byMsgId.size === 0 && byCliMsgId.size === 0) return;

    const patchMessage = (message) => {
      if (!message) return message;
      const msgKey =
        message.msgId !== undefined && message.msgId !== null
          ? String(message.msgId)
          : null;
      const cliKey =
        message.cliMsgId !== undefined && message.cliMsgId !== null
          ? String(message.cliMsgId)
          : null;
      const next =
        (msgKey && byMsgId.get(msgKey)) ??
        (cliKey && byCliMsgId.get(cliKey)) ??
        null;
      if (!next) return message;
      return { ...message, reacts: next };
    };

    setContacts((prevContacts) => {
      let didChange = false;
      const nextContacts = prevContacts.map((contact) => {
        if (!Array.isArray(contact?.messages) || contact.messages.length === 0) {
          return contact;
        }
        let contactChanged = false;
        const nextMessages = contact.messages.map((m) => {
          const patched = patchMessage(m);
          if (patched !== m) contactChanged = true;
          return patched;
        });
        if (!contactChanged) return contact;
        didChange = true;
        return { ...contact, messages: nextMessages };
      });
      return didChange ? nextContacts : prevContacts;
    });

    setSelectedChat((prevChat) => {
      if (!prevChat || !Array.isArray(prevChat.messages)) return prevChat;
      let chatChanged = false;
      const nextMessages = prevChat.messages.map((m) => {
        const patched = patchMessage(m);
        if (patched !== m) chatChanged = true;
        return patched;
      });
      if (!chatChanged) return prevChat;
      return { ...prevChat, messages: nextMessages };
    });
  }, []);

  const hydrateRealtimeContact = async (shop, uid, options = {}) => {
    if (!shop?._id || !uid) return null;

    const key = getRealtimeHydrationKey(shop._id, uid);
    return runDedupedHydration(
      realtimeHydrationRequestsRef.current,
      key,
      async () => {
        const res = await shopApi.getContactByUids(shop._id, [uid], 1);
        if (res.status !== 1 || !res.data?.[0]) return null;
        return applyRealtimeContactState(res.data[0], shop, options);
      },
    );
  };

  const ensureRealtimeContactsHydrated = async (
    shop,
    uids = [],
    payloadContacts = [],
    options = {},
  ) => {
    if (!shop?._id) return [];

    const scopedKnownContacts = contactsRef.current.filter(
      (contact) => (contact._shopId || shop._id) === shop._id,
    );
    const knownKeys = new Set(
      scopedKnownContacts.map((contact) =>
        getRealtimeHydrationKey(shop._id, contact.uid),
      ),
    );

    payloadContacts.forEach((contact) => {
      if (contact?.uid) {
        knownKeys.add(getRealtimeHydrationKey(shop._id, contact.uid));
      }
    });

    const missingUids = [...new Set(uids.filter(Boolean))].filter(
      (uid) => !knownKeys.has(getRealtimeHydrationKey(shop._id, uid)),
    );

    if (missingUids.length === 0) return [];

    return Promise.all(
      missingUids.map((missingUid) =>
        hydrateRealtimeContact(shop, missingUid, options),
      ),
    );
  };

  const isSameRealtimeSelectedChat = (contact) => {
    if (!contact) return false;
    const selectedChatShopId =
      selectedChatRef.current?._shopId || selectedChatRef.current?.shopId;
    const contactShopId = contact._shopId || contact.shopId;

    if (selectedChatRef.current?._id === contact._id) {
      return true;
    }

    if (!selectedChatRef.current?.uid || selectedChatRef.current.uid !== contact.uid) {
      return false;
    }

    if (!selectedChatShopId || !contactShopId) return true;
    return selectedChatShopId === contactShopId;
  };

  const mergeRevalidatedContacts = (prevContacts, refreshedContacts) => {
    if (contactPage <= 1 && prevContacts.length <= 20) {
      return prevContacts.length > 0
        ? mergeContactsPreservingReadState(refreshedContacts, prevContacts, {
            mergeMessages: true,
          })
        : refreshedContacts;
    }

    return mergeRealtimeContactPage(prevContacts, refreshedContacts, {
      selectedCategories: selectedCategoriesRef.current,
      authUserId: auth.user._id,
      isSelectedChat: (contact) => isSameRealtimeSelectedChat(contact),
      recentlyRead: (contact) => wasRecentlyMarkedAsRead(contact),
      preserveExistingMessages: true,
      mergeMessages: true,
    });
  };

  const refreshSingleShopContactsFirstPage = async (shop) => {
    if (!shop?._id) return;

    const filters = {
      categories: selectedCategoriesRef.current,
      staffId: auth.user._id,
      tagIds: selectedTagsRef.current,
      tagZaloIds: selectedTagZalosRef.current,
      staffIds: selectedStaffsRef.current,
      pipelineStageIds: selectedPipelineStageIdsRef.current,
      needsReplyMinutes: needsReplyMinutesRef.current,
      newCustomerDays: newCustomerDaysRef.current,
      hasContactInfo: hasContactInfoRef.current,
      upcomingBirthdayDays: upcomingBirthdayDaysRef.current,
      sortMode: sortModeRef.current,
    };
    const res = await shopApi.getContacts(shop._id, 0, 1, 20, filters);
    if (res.status !== 1) return;

    const refreshedContacts = res.data.map((contact) =>
      attachRealtimeShopMetadata(contact, shop),
    );

    setContacts((prevContacts) =>
      mergeRevalidatedContacts(prevContacts, refreshedContacts),
    );
    setHasMoreContacts(res.hasMore !== false);
    hasMoreContactsRef.current = res.hasMore !== false;
  };

  const refreshGroupContactsFirstPage = async () => {
    if (groupShops.length === 0) return;

    const filters = {
      categories: selectedCategoriesRef.current,
      staffId: auth.user._id,
      tagIds: selectedTagsRef.current,
      tagZaloIds: selectedTagZalosRef.current,
      staffIds: selectedStaffsRef.current,
      pipelineStageIds: selectedPipelineStageIdsRef.current,
      needsReplyMinutes: needsReplyMinutesRef.current,
      newCustomerDays: newCustomerDaysRef.current,
      hasContactInfo: hasContactInfoRef.current,
      upcomingBirthdayDays: upcomingBirthdayDaysRef.current,
      sortMode: sortModeRef.current,
    };

    const results = await Promise.allSettled(
      groupShops.map((shop) => shopApi.getContacts(shop._id, 0, 1, 20, filters)),
    );

    const refreshedContacts = [];
    let hasMore = false;

    results.forEach((result, index) => {
      if (result.status !== "fulfilled") return;

      const res = result.value;
      if (res.status !== 1) return;

      const shop = groupShops[index];
      refreshedContacts.push(
        ...res.data.map((contact) => attachRealtimeShopMetadata(contact, shop)),
      );
      if (res.hasMore !== false && res.data.length > 0) {
        hasMore = true;
      }
    });

    refreshedContacts.sort((a, b) => {
      const dateA = a.messages?.[a.messages.length - 1]?.dateAction || 0;
      const dateB = b.messages?.[b.messages.length - 1]?.dateAction || 0;
      return new Date(dateB) - new Date(dateA);
    });

    setContacts((prevContacts) =>
      mergeRevalidatedContacts(prevContacts, refreshedContacts),
    );
    setHasMoreContacts(hasMore);
    hasMoreContactsRef.current = hasMore;
  };

  const revalidateRealtimeContacts = async () => {
    if (isRealtimeRevalidatingRef.current) return;

    isRealtimeRevalidatingRef.current = true;
    try {
      if (isGroupModeRef.current) {
        await refreshGroupContactsFirstPage();
      } else if (selectedShop?._id) {
        await refreshSingleShopContactsFirstPage(selectedShop);
      }
      await refreshUnreadMessageCount();
    } catch (error) {
      console.error("[RealtimeSync] Revalidate failed:", error);
    } finally {
      isRealtimeRevalidatingRef.current = false;
    }
  };

  const scheduleRealtimeRevalidate = (delay = 250) => {
    if (realtimeRevalidateTimerRef.current) {
      clearTimeout(realtimeRevalidateTimerRef.current);
    }

    realtimeRevalidateTimerRef.current = setTimeout(() => {
      realtimeRevalidateTimerRef.current = null;
      revalidateRealtimeContacts();
    }, delay);
  };

  // Removed polling - now using socket for real-time sync

  useEffect(() => {
    if (!auth.user?._id) return;
    if (!selectedShop?._id && groupShops.length === 0) return;

    const handleRealtimeRevalidate = () => {
      if (document.visibilityState === "hidden") return;
      scheduleRealtimeRevalidate(0);
    };

    const intervalMs = isGroupMode ? 15000 : 10000;
    const intervalId = window.setInterval(() => {
      if (document.visibilityState === "hidden") return;
      scheduleRealtimeRevalidate();
    }, intervalMs);

    window.addEventListener("focus", handleRealtimeRevalidate);
    document.addEventListener("visibilitychange", handleRealtimeRevalidate);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("focus", handleRealtimeRevalidate);
      document.removeEventListener(
        "visibilitychange",
        handleRealtimeRevalidate,
      );
      if (realtimeRevalidateTimerRef.current) {
        clearTimeout(realtimeRevalidateTimerRef.current);
        realtimeRevalidateTimerRef.current = null;
      }
    };
  }, [auth.user?._id, selectedShop?._id, isGroupMode, groupShops]);

  useEffect(() => {
    (async () => {
      if (newContact) {
        // Use newContact._shopId if available, otherwise getDefaultSearchShop()._id
        const shopId =
          newContact._shopId ||
          getDefaultSearchShop()?._id ||
          selectedShop?._id;
        if (!shopId) return;

        const resContacts = await shopApi.getContactByUids(
          shopId,
          [newContact.uid],
          1,
        );
        if (resContacts.status === 1) {
          // Add shop metadata in group mode
          const contactData = resContacts.data.map((c) => ({
            ...c,
            _shopId: shopId,
            _shopName: isGroupMode
              ? groupShops.find((s) => s._id === shopId)?.name
              : selectedShop?.name,
            _shopAvatar: isGroupMode
              ? groupShops.find((s) => s._id === shopId)?.avatar
              : selectedShop?.avatar,
          }));

          setContacts((pre) =>
            pre.map((x) => x.uid).includes(newContact.uid)
              ? pre
              : [...pre, ...contactData],
          );

          const foundContact = contactData.find(
            (x) => x.uid === newContact.uid,
          );
          console.log(foundContact);
          setSelectedGroup(null);
          setGroupMembers([]);
          setIsOpenGroupMembersSideBar(false);
          setSelectedChat(foundContact);
          setSelectedChatName(foundContact?.name ?? "");

          // Set activeContactShop in group mode
          if (isGroupMode && shopId) {
            const shop = groupShops.find((s) => s._id === shopId);
            if (shop) setActiveContactShop(shop);
          }

          messageInputRef?.current?.focus();
        }
        setNewContact(null);
      }
    })();
  }, [newContact]);

  const socketRef = useRef(null);
  const SOCKET_SUBSCRIPTION_HEARTBEAT_MS = 30000;
  const hasShopSessionChanged = (currentShop, nextShop) => {
    if (!currentShop && !nextShop) return false;
    if (!currentShop || !nextShop) return true;
    return (
      currentShop._id !== nextShop._id ||
      currentShop.isLogin !== nextShop.isLogin ||
      currentShop.sessionRevision !== nextShop.sessionRevision ||
      currentShop.zaloId !== nextShop.zaloId ||
      currentShop.staffId !== nextShop.staffId
    );
  };

  const refreshShopSessions = useCallback(async () => {
    if (!auth.user?._id) return [];

    const params = {
      accountId: auth.user.accountId,
      staffId: auth.user._id,
    };

    const res = await shopApi.getShops(params);
    if (res.status !== 1) {
      dispatch(getShopsRequest(params));
      return [];
    }

    const nextShops = res.data || [];
    dispatch(getShopsRequest(params));

    const currentGroupShops = groupShopsStateRef.current || [];
    const currentSelectedShop = selectedShopStateRef.current;
    const currentActiveContactShop = activeContactShopRef.current;

    if (currentGroupShops.length > 0) {
      const currentGroupIds = new Set(
        currentGroupShops.map((shop) => shop._id),
      );
      const nextGroupShops = nextShops.filter((shop) =>
        currentGroupIds.has(shop._id),
      );

      const hasGroupChange =
        nextGroupShops.length !== currentGroupShops.length ||
        nextGroupShops.some((shop) => {
          const previous = currentGroupShops.find(
            (item) => item._id === shop._id,
          );
          return hasShopSessionChanged(previous, shop);
        });

      if (hasGroupChange) {
        setGroupShops(nextGroupShops);
      }

      if (currentActiveContactShop?._id) {
        const nextActiveContactShop =
          nextGroupShops.find(
            (shop) => shop._id === currentActiveContactShop._id,
          ) || null;
        if (
          hasShopSessionChanged(
            currentActiveContactShop,
            nextActiveContactShop,
          )
        ) {
          setActiveContactShop(nextActiveContactShop);
        }
      }

      if (currentSelectedShop?._id) {
        const nextSelectedShop =
          nextGroupShops.find(
            (shop) => shop._id === currentSelectedShop._id,
          ) ||
          nextGroupShops[0] ||
          null;
        if (hasShopSessionChanged(currentSelectedShop, nextSelectedShop)) {
          setSelectedShop(nextSelectedShop);
        }
      }
    } else if (currentSelectedShop?._id) {
      const nextSelectedShop =
        nextShops.find((shop) => shop._id === currentSelectedShop._id) || null;
      if (hasShopSessionChanged(currentSelectedShop, nextSelectedShop)) {
        setSelectedShop(nextSelectedShop);
      }
    }

    return nextShops;
  }, [auth.user?._id, auth.user?.accountId, dispatch]);

  const groupSocketKey = useMemo(
    () =>
      groupShops
        .map(
          (shop) =>
            `${shop._id}:${shop.isLogin ? 1 : 0}:${shop.sessionRevision ?? 0}:${shop.zaloId || ""}`,
        )
        .sort()
        .join("|"),
    [groupShops],
  );

  const buildListenMessage = (shop, { isHeartbeat = false } = {}) => {
    if (!shop?._id) return null;

    return {
      type: "listen_message",
      accountId: auth.user.accountId,
      staffId: auth.user._id,
      shopStaffId: shop.staffId,
      profileId: shop.profileId,
      shopId: shop._id,
      zaloId: shop.zaloId,
      sessionRevision: shop.sessionRevision ?? 0,
      isHeartbeat,
    };
  };

  const sendListenMessage = (socket, shop, options = {}) => {
    const payload = buildListenMessage(shop, options);
    if (!payload || socket?.readyState !== WebSocket.OPEN) return false;

    try {
      socket.send(JSON.stringify(payload));
      return true;
    } catch (error) {
      console.error("[WS] Failed to send listen_message:", error);
      return false;
    }
  };

  useEffect(() => {
    if (!selectedShop) return;

    // In group mode (groupId in URL), skip main socket - use group sockets instead
    if (groupId) {
      console.log("[GroupMode] Skipping main socket - using group sockets");
      return;
    }

    if (!selectedShop.isLogin || !selectedShop.zaloId) {
      setIsLoading(false);
      setIsLoadingScreen(false);
      return;
    }

    let reconnectDelay = 3000;
    const MAX_RECONNECT_DELAY = 30_000;
    let reconnectTimer = null;
    let isManuallyClosed = false;
    let isFirstConnect = true;
    let subscriptionHeartbeatTimer = null;
    let listenRetryAttempt = 0;
    let listenRetryTimer = null;

    const clearSubscriptionHeartbeat = () => {
      if (subscriptionHeartbeatTimer) {
        clearInterval(subscriptionHeartbeatTimer);
        subscriptionHeartbeatTimer = null;
      }
    };

    const clearListenRetry = () => {
      if (listenRetryTimer) {
        clearTimeout(listenRetryTimer);
        listenRetryTimer = null;
      }
    };

    const resetRealtimeConnectionStatus = () => {
      listenRetryAttempt = 0;
      clearListenRetry();
      setRealtimeConnectionStatus((prev) =>
        prev.shopId === selectedShop._id ? { state: "idle" } : prev,
      );
    };

    const scheduleListenRetry = (payload = {}) => {
      if (isManuallyClosed) return;
      clearListenRetry();

      if (payload.retryable === false) {
        setRealtimeConnectionStatus({
          state: "failed",
          shopId: selectedShop._id,
          shopName: selectedShop.name,
          message: payload.message || "Không kết nối được realtime",
        });
        return;
      }

      const delay = Math.min(
        REALTIME_LISTEN_RETRY_BASE_MS * 2 ** Math.min(listenRetryAttempt, 5),
        REALTIME_LISTEN_RETRY_MAX_MS,
      );
      listenRetryAttempt += 1;
      setRealtimeConnectionStatus({
        state: "retrying",
        shopId: selectedShop._id,
        shopName: selectedShop.name,
        message: payload.message || "Đang kết nối lại realtime",
      });

      listenRetryTimer = setTimeout(() => {
        listenRetryTimer = null;
        sendListenMessage(socketRef.current, selectedShop, {
          isHeartbeat: true,
        });
      }, delay);
    };

    const startSubscriptionHeartbeat = () => {
      clearSubscriptionHeartbeat();
      subscriptionHeartbeatTimer = setInterval(() => {
        sendListenMessage(socketRef.current, selectedShop, {
          isHeartbeat: true,
        });
      }, SOCKET_SUBSCRIPTION_HEARTBEAT_MS);
    };

    const handleSocketRefocus = () => {
      if (document.visibilityState === "hidden") return;
      sendListenMessage(socketRef.current, selectedShop, {
        isHeartbeat: true,
      });
    };

    const scheduleReconnect = () => {
      if (isManuallyClosed) return;
      console.log(`[WS] Reconnecting in ${reconnectDelay / 1000}s...`);
      setRealtimeConnectionStatus({
        state: "retrying",
        shopId: selectedShop._id,
        shopName: selectedShop.name,
        message: "Mất kết nối realtime, đang nối lại",
      });
      reconnectTimer = setTimeout(() => {
        connectSocket();
        // Exponential backoff, capped
        reconnectDelay = Math.min(reconnectDelay * 1.5, MAX_RECONNECT_DELAY);
      }, reconnectDelay);
    };

    const connectSocket = () => {
      socketRef.current = new WebSocket(getWebSocketUrl());

      const stopAndRefreshSession = async ({
        notification,
        markLoggedOut = false,
      } = {}) => {
        isManuallyClosed = true;
        clearSubscriptionHeartbeat();
        clearListenRetry();
        if (markLoggedOut && selectedShop?._id) {
          try {
            await shopApi.updateShop(selectedShop._id, {
              isLogin: false,
            });
          } catch (error) {
            console.log(error);
          }
        }
        try {
          await refreshShopSessions();
        } catch (error) {
          console.log(error);
        }
        if (notification) {
          addNotification(notification, -1);
        }
        setIsLoading(false);
        setIsLoadingScreen(false);
        try {
          socketRef.current?.close();
        } catch (_) {}
      };

      socketRef.current.onopen = () => {
        console.log("Connected to WebSocket server");
        reconnectDelay = 3000; // Reset backoff on successful connect
        sendListenMessage(socketRef.current, selectedShop);
        startSubscriptionHeartbeat();
        const wasFirstConnect = isFirstConnect;
        isFirstConnect = false;

        if (wasFirstConnect) {
          setIsLoadingScreen(true);
          setContactPage(1);
          setHasMoreContacts(true);
          hasMoreContactsRef.current = true;
        }

        // In group mode, contacts are already loaded by group useEffect
        // Only load contacts for the main socket in single-shop mode
        if (isGroupMode) {
          if (wasFirstConnect) {
            setIsLoadingScreen(false);
            setIsLoading(false);
          }
        } else {
          const filters = {
            categories: selectedCategories,
            staffId: auth.user._id,
          };
          shopApi
            .getContacts(selectedShop._id, 0, 1, 20, filters)
            .then((res) => {
              if (res.status === 1) {
                // Merge new data while preserving read state for recently read conversations
                setContacts((prev) =>
                  prev.length > 0
                    ? mergeContactsPreservingReadState(res.data, prev)
                    : res.data,
                );
                if (wasFirstConnect) {
                  setHasMoreContacts(res.hasMore !== false);
                  hasMoreContactsRef.current = res.hasMore !== false;
                }
              }
              if (wasFirstConnect) {
                setIsLoadingScreen(false);
                setIsLoading(false);
              }
            });
        }
      };

      socketRef.current.onmessage = (event) => {
        const message = JSON.parse(event.data);
        console.log("Received from server:", message);
        (async () => {
          if (message.type === "logged_in") {
            resetRealtimeConnectionStatus();
            try {
              await shopApi.updateShop(selectedShop._id, {
                isLogin: true,
              });
            } catch (error) {
              console.log(error);
            }
            setSelectedShop((prev) =>
              prev?._id === selectedShop._id
                ? (() => {
                    const nextSessionRevision =
                      message.sessionRevision ?? prev.sessionRevision;
                    if (
                      prev.isLogin === true &&
                      prev.sessionRevision === nextSessionRevision
                    ) {
                      return prev;
                    }
                    return {
                      ...prev,
                      isLogin: true,
                      sessionRevision: nextSessionRevision,
                    };
                  })()
                : prev,
            );
            addNotification("Đã đồng bộ tin nhắn", 1);
            setIsLoading(false);
          } else if (message.type === "logged_out") {
            await stopAndRefreshSession({
              notification: "Tài khoản chưa đăng nhập",
              markLoggedOut: true,
            });
          } else if (message.type === "duplicate_zalo_active") {
            await stopAndRefreshSession({
              notification:
                "Zalo này đang được một shop khác giữ active, vui lòng đồng bộ lại danh sách shop",
            });
          } else if (message.type === "session_stale") {
            await stopAndRefreshSession({
              notification:
                "Phiên làm việc đã cũ, hệ thống đang đồng bộ lại trạng thái đăng nhập",
            });
          } else if (message.type === "session_expired") {
            await stopAndRefreshSession({
              notification:
                "Phiên đăng nhập Zalo đã hết hạn, vui lòng đăng nhập lại",
            });
          } else if (message.type === "error_browser") {
            addNotification("Có lỗi xảy ra, vui lòng load lại web", -1);
            setIsLoading(false);
          } else if (message.type === "zalo_reconnected") {
            sendListenMessage(socketRef.current, selectedShop, {
              isHeartbeat: true,
            });
            scheduleRealtimeRevalidate(0);
          } else if (message.type === "listen_message_error") {
            scheduleListenRetry(message);
            return;
          } else if (message.type === "sync_data") {
            await hydrateRealtimeContact(selectedShop, message.uid, {
              insertAtStart: false,
              mergeMessages: true,
            });
            scheduleRealtimeRevalidate(0);
          } else if (message.type === "synced_contacts") {
            // Server finished syncing groups/friends from Zalo after login.
            // Re-fetch the first page so newly-synced groups appear in the sidebar.
            if (!isGroupMode) {
              const filters = {
                categories: selectedCategories,
                staffId: auth.user._id,
              };
              shopApi
                .getContacts(selectedShop._id, 0, 1, 20, filters)
                .then((res) => {
                  if (res.status === 1) {
                    setContacts((prev) =>
                      prev.length > 0
                        ? mergeContactsPreservingReadState(res.data, prev)
                        : res.data,
                    );
                    setHasMoreContacts(res.hasMore !== false);
                    hasMoreContactsRef.current = res.hasMore !== false;
                  }
                });
            }
          }
          if (message.type === "send_status" && message.cliMsgId) {
            // Server-authoritative send state update from outbox worker or
            // sync path. Fires even if the initiating HTTP response never
            // reached the client (network blip, closed tab, etc.).
            if (message.status === "sent") {
              mergePersistedSendMessages(message.persistedMessages);
              markSent(message.cliMsgId, {
                msgId: message.msgId,
                outboxId: message.outboxId,
              });
            } else if (message.status === "dead") {
              markError(
                message.cliMsgId,
                message.error || "Không gửi được sau nhiều lần thử",
              );
            } else if (message.status === "queued") {
              markQueued(message.cliMsgId);
            }
            return;
          }
          if (
            message.type === "received_message" ||
            message.type === "new_react" ||
            message.type === "undo" ||
            message.type === "seen_messages"
          ) {
            const newMessagesFromServer = message.newMessages || [];
            if (message.data) {
              // Helper function to merge messages properly
              const mergeMessages = (prevMessages, newMessages) => {
                if (!newMessages || newMessages.length === 0)
                  return prevMessages || [];
                if (!prevMessages || prevMessages.length === 0)
                  return newMessages;

                // Merge `card` payload between the optimistic bubble and the
                // DB-backed echo. Two reasons:
                // 1. If the messages.card column migration hasn't been applied,
                //    the server echo arrives with no card → without this, the
                //    bubble collapses to plain text.
                // 2. The Zalo echo carries `contactUid = gUid` (shareable ID,
                //    alphanumeric) while the optimistic uses the real user uid
                //    (numeric). The real uid is what "Nhắn Tin" needs to find
                //    the conversation, so we keep it. QR / avatar are only in
                //    the echo so we prefer those.
                const optimisticCardByKey = new Map();
                for (const m of prevMessages) {
                  if (m?.type === "card" && m?.card) {
                    if (m.msgId) optimisticCardByKey.set(`m:${m.msgId}`, m.card);
                    if (m.cliMsgId)
                      optimisticCardByKey.set(`c:${m.cliMsgId}`, m.card);
                  }
                }
                if (optimisticCardByKey.size > 0) {
                  newMessages = newMessages.map((m) => {
                    if (m?.type !== "card") return m;
                    const carried =
                      (m.msgId && optimisticCardByKey.get(`m:${m.msgId}`)) ||
                      (m.cliMsgId &&
                        optimisticCardByKey.get(`c:${m.cliMsgId}`));
                    if (!carried) return m;
                    if (!m.card) return { ...m, card: carried };
                    return {
                      ...m,
                      card: {
                        ...m.card,
                        contactUid: carried.contactUid || m.card.contactUid,
                        contactAvatar:
                          m.card.contactAvatar || carried.contactAvatar,
                        phoneNumber:
                          carried.phoneNumber || m.card.phoneNumber,
                      },
                    };
                  });
                }

                return mergeIncomingMessagesWithOptimistic(
                  prevMessages,
                  newMessages,
                  {
                    onMatch: (existingMsg, matchedServerMsg) => {
                      if (!existingMsg.staffId || !matchedServerMsg?._id) {
                        return;
                      }
                      shopApi.updateMessageStaff({
                        messageId: matchedServerMsg._id,
                        staffId: existingMsg.staffId,
                        staffName: existingMsg.staffName,
                      });
                    },
                  },
                );
              };

              // Get new messages from the appropriate field based on message type
              // For received_message: use message.newMessages
              // For other types: newMessages is empty (handled below with reacts/undos/seenMessages)
              for (const contact of message.data) {
                // Skip hidden contacts unless viewing hidden filter
                if (
                  contact.isHidden &&
                  !selectedCategoriesRef.current.includes("hidden")
                )
                  continue;
                // Update contacts
                setContacts((prevContacts) => {
                  const existingContact = prevContacts.find(
                    (c) => c._id === contact._id,
                  );
                  if (existingContact) {
                    // Get relevant new messages for this contact
                    const contactNewMessages = newMessagesFromServer.filter(
                      (m) => isMessageForContact(m, contact.uid),
                    );
                    // Count inbound new messages (from customer, not self) for unread fallback
                    const inboundNewCount = contactNewMessages.filter(
                      (m) => m.uidFrom && m.uidFrom !== "0",
                    ).length;
                    // New inbound message invalidates the 30s "recently read" grace
                    // so this contact can re-show as unread.
                    if (inboundNewCount > 0) clearRecentlyReadMark(contact);
                    // Check if this contact is selected or was recently marked as read
                    const isSelectedChat =
                      selectedChatRef.current?._id === contact._id;
                    const recentlyRead = wasRecentlyMarkedAsRead(contact);
                    const isAdminView = isOwnerOrAdmin();
                    // If selected or recently read, preserve local unreadStaffIds.
                    // Admin acknowledged → team-wide clear (matches optimistic UI).
                    let preservedUnreadStaffIds;
                    if (isSelectedChat || recentlyRead) {
                      preservedUnreadStaffIds = isAdminView
                        ? []
                        : existingContact.unreadStaffIds?.filter(
                            (s) => s !== auth.user._id,
                          );
                    } else {
                      preservedUnreadStaffIds = contact.unreadStaffIds;
                    }
                    // Fallback: if there's an inbound message and chat not open,
                    // ensure this user is marked unread even when server omits it.
                    if (
                      inboundNewCount > 0 &&
                      !isSelectedChat &&
                      !recentlyRead
                    ) {
                      const base = Array.isArray(preservedUnreadStaffIds)
                        ? preservedUnreadStaffIds
                        : [];
                      if (!base.includes(auth.user._id)) {
                        preservedUnreadStaffIds = [...base, auth.user._id];
                      }
                    }
                    // Unread counts: respect server, but bump if server skipped us.
                    // Admin acknowledged → zero every staff's count locally.
                    const serverUnreadCounts =
                      contact.unreadCounts ||
                      existingContact.unreadCounts ||
                      {};
                    let mergedUnreadCounts = serverUnreadCounts;
                    if (isSelectedChat || recentlyRead) {
                      mergedUnreadCounts = isAdminView
                        ? Object.fromEntries(
                            Object.keys(serverUnreadCounts).map((k) => [k, 0]),
                          )
                        : {
                            ...serverUnreadCounts,
                            [auth.user._id]: 0,
                          };
                    } else if (inboundNewCount > 0) {
                      const prevCount =
                        existingContact.unreadCounts?.[auth.user._id] || 0;
                      const serverCount =
                        serverUnreadCounts[auth.user._id] || 0;
                      mergedUnreadCounts = {
                        ...serverUnreadCounts,
                        [auth.user._id]: Math.max(
                          serverCount,
                          prevCount + inboundNewCount,
                        ),
                      };
                    }
                    // In group mode, add shop info to contact
                    const shopInfo = isGroupModeRef.current
                      ? {
                          _shopId: selectedShop._id,
                          _shopName: selectedShop.name,
                          _shopAvatar: selectedShop.avatar,
                        }
                      : {};
                    return prevContacts.map((c) =>
                      c._id === contact._id
                        ? {
                            ...c,
                            ...contact,
                            ...shopInfo,
                            unreadStaffIds: preservedUnreadStaffIds,
                            unreadCounts: mergedUnreadCounts,
                            messages: mergeMessages(
                              c.messages,
                              contactNewMessages,
                            ),
                          }
                        : c,
                    );
                  } else {
                    // New contact from WebSocket — if any server-side filter is active,
                    // skip appending. Otherwise the filtered list would "reload" with
                    // unfiltered contacts after a few seconds of live traffic.
                    if (hasActiveFilter()) {
                      return prevContacts;
                    }
                    // New contact, add with its new messages
                    const contactNewMessages = newMessagesFromServer.filter(
                      (m) => isMessageForContact(m, contact.uid),
                    );
                    const inboundNewCount = contactNewMessages.filter(
                      (m) => m.uidFrom && m.uidFrom !== "0",
                    ).length;
                    const baseUnreadStaffIds = Array.isArray(
                      contact.unreadStaffIds,
                    )
                      ? contact.unreadStaffIds
                      : [];
                    const ensuredUnreadStaffIds =
                      inboundNewCount > 0 &&
                      !baseUnreadStaffIds.includes(auth.user._id)
                        ? [...baseUnreadStaffIds, auth.user._id]
                        : baseUnreadStaffIds;
                    const baseUnreadCounts = contact.unreadCounts || {};
                    const ensuredUnreadCounts =
                      inboundNewCount > 0
                        ? {
                            ...baseUnreadCounts,
                            [auth.user._id]: Math.max(
                              baseUnreadCounts[auth.user._id] || 0,
                              inboundNewCount,
                            ),
                          }
                        : baseUnreadCounts;
                    return [
                      ...prevContacts,
                      {
                        ...contact,
                        unreadStaffIds: ensuredUnreadStaffIds,
                        unreadCounts: ensuredUnreadCounts,
                        messages: contactNewMessages,
                      },
                    ];
                  }
                });

                // Update selectedChat
                setSelectedChat((prevChat) => {
                  if (prevChat?._id !== contact._id) return prevChat;
                  const contactNewMessages = newMessagesFromServer.filter(
                    (m) => isMessageForContact(m, prevChat.uid),
                  );
                  // Preserve local unreadStaffIds - user is viewing this chat
                  const preservedUnreadStaffIds =
                    prevChat.unreadStaffIds?.filter((s) => s !== auth.user._id);
                  return {
                    ...prevChat,
                    ...contact,
                    unreadStaffIds: preservedUnreadStaffIds,
                    messages: mergeMessages(
                      prevChat.messages,
                      contactNewMessages,
                    ),
                  };
                });
              }

              // Handle reacts - update specific messages with new reacts
              if (message.type === "new_react") {
                if (
                  Array.isArray(message.messageReactions) &&
                  message.messageReactions.length > 0
                ) {
                  replaceReactsInChatState(message.messageReactions);
                } else if (message.reacts) {
                  applyReactionEventsToChatState(message.reacts);
                }
              }

              // Handle undos - mark specific messages as undone
              if (message.type === "undo" && message.undos) {
                for (const undo of message.undos) {
                  setContacts((prevContacts) =>
                    prevContacts.map((c) => ({
                      ...c,
                      messages: c.messages?.map((m) =>
                        String(m.msgId) === String(undo.msgId) ||
                        String(m.cliMsgId) === String(undo.cliMsgId)
                          ? { ...m, isUndo: true }
                          : m,
                      ),
                    })),
                  );
                  setSelectedChat((prevChat) =>
                    prevChat
                      ? {
                          ...prevChat,
                          messages: prevChat.messages?.map((m) =>
                            String(m.msgId) === String(undo.msgId) ||
                            String(m.cliMsgId) === String(undo.cliMsgId)
                              ? { ...m, isUndo: true }
                              : m,
                          ),
                        }
                      : prevChat,
                  );
                }
              }

              // Handle seen messages - update sendingStatus
              if (message.type === "seen_messages" && message.seenMessages) {
                for (const seen of message.seenMessages) {
                  setContacts((prevContacts) =>
                    prevContacts.map((c) => ({
                      ...c,
                      messages: c.messages?.map((m) =>
                        String(m.msgId) === String(seen.msgId)
                          ? { ...m, sendingStatus: "seen" }
                          : m,
                      ),
                    })),
                  );
                  setSelectedChat((prevChat) =>
                    prevChat
                      ? {
                          ...prevChat,
                          messages: prevChat.messages?.map((m) =>
                            String(m.msgId) === String(seen.msgId)
                              ? { ...m, sendingStatus: "seen" }
                              : m,
                          ),
                        }
                      : prevChat,
                  );
                }
              }
            }
            if (message.noties)
              for (const noti of message.noties) {
                showBrowserNotification(noti.title, { body: noti.content });
              }
            if (message.type === "received_message") {
              await ensureRealtimeContactsHydrated(
                selectedShop,
                newMessagesFromServer.map((m) => m.messageId),
                message.data,
                {
                  insertAtStart: true,
                  preserveExistingMessages: true,
                  mergeMessages: true,
                },
              );
              scheduleRealtimeRevalidate();
            }
          } else if (message.type === "control") {
            // const resContacts = await shopApi.getContacts(selectedShop._id);
            // if (resContacts.status === 1) {
            //   setContacts(resContacts.data);
            //   if (message.isNewGroup) {
            //     setSelectedGroup(null);
            //     setGroupMembers([]);
            //     setIsOpenGroupMembersSideBar(false);
            //     setSelectedChat(
            //       resContacts.data.find((x) => x.uid === message.groupId)
            //     );
            //     setSelectedChatName(
            //       resContacts.data.find((x) => x.uid === message.groupId)?.name
            //     );
            //     messageInputRef?.current?.focus();
            //   }
            // }
            if (message.data) {
              // Helper function to merge messages properly (same as above)
              const mergeMessages = (prevMessages, newMessages) => {
                if (!newMessages || newMessages.length === 0)
                  return prevMessages || [];
                if (!prevMessages || prevMessages.length === 0)
                  return newMessages;

                // Update existing messages by _id
                const mergedMessages = prevMessages.map((existingMsg) => {
                  const updatedMsg = newMessages.find(
                    (m) => m._id && m._id === existingMsg._id,
                  );
                  return updatedMsg
                    ? { ...existingMsg, ...updatedMsg }
                    : existingMsg;
                });

                // Add truly new messages (not in existing by _id)
                const existingIds = new Set(
                  prevMessages.map((m) => m._id).filter(Boolean),
                );
                const brandNewMessages = newMessages.filter(
                  (m) => !existingIds.has(m._id),
                );

                return [...mergedMessages, ...brandNewMessages];
              };

              // Get new messages from server for event messages
              const newMessagesFromServer = message.newMessages || [];

              for (const contact of message.data) {
                // Get relevant new messages for this contact
                const contactNewMessages = newMessagesFromServer.filter(
                  (m) => isMessageForContact(m, contact.uid),
                );

                // Update contacts - merge with new event messages
                setContacts((prevContacts) => {
                  const existingContact = prevContacts.find(
                    (c) => c._id === contact._id,
                  );
                  if (existingContact) {
                    const inboundNewCount = contactNewMessages.filter(
                      (m) => m.uidFrom && m.uidFrom !== "0",
                    ).length;
                    // New inbound message invalidates the 30s "recently read" grace.
                    if (inboundNewCount > 0) clearRecentlyReadMark(contact);
                    // Check if this contact is selected or was recently marked as read
                    const isSelectedChat =
                      selectedChatRef.current?._id === contact._id;
                    const recentlyRead = wasRecentlyMarkedAsRead(contact);
                    const isAdminView = isOwnerOrAdmin();
                    // If selected or recently read, preserve local unreadStaffIds.
                    // Admin acknowledged → team-wide clear (matches optimistic UI).
                    let preservedUnreadStaffIds;
                    if (isSelectedChat || recentlyRead) {
                      preservedUnreadStaffIds = isAdminView
                        ? []
                        : existingContact.unreadStaffIds?.filter(
                            (s) => s !== auth.user._id,
                          );
                    } else {
                      preservedUnreadStaffIds = contact.unreadStaffIds;
                    }
                    if (
                      inboundNewCount > 0 &&
                      !isSelectedChat &&
                      !recentlyRead
                    ) {
                      const base = Array.isArray(preservedUnreadStaffIds)
                        ? preservedUnreadStaffIds
                        : [];
                      if (!base.includes(auth.user._id)) {
                        preservedUnreadStaffIds = [...base, auth.user._id];
                      }
                    }
                    const serverUnreadCounts =
                      contact.unreadCounts ||
                      existingContact.unreadCounts ||
                      {};
                    let mergedUnreadCounts = serverUnreadCounts;
                    if (isSelectedChat || recentlyRead) {
                      mergedUnreadCounts = isAdminView
                        ? Object.fromEntries(
                            Object.keys(serverUnreadCounts).map((k) => [k, 0]),
                          )
                        : {
                            ...serverUnreadCounts,
                            [auth.user._id]: 0,
                          };
                    } else if (inboundNewCount > 0) {
                      const prevCount =
                        existingContact.unreadCounts?.[auth.user._id] || 0;
                      const serverCount =
                        serverUnreadCounts[auth.user._id] || 0;
                      mergedUnreadCounts = {
                        ...serverUnreadCounts,
                        [auth.user._id]: Math.max(
                          serverCount,
                          prevCount + inboundNewCount,
                        ),
                      };
                    }
                    return prevContacts.map((c) =>
                      c._id === contact._id
                        ? {
                            ...c,
                            ...contact,
                            unreadStaffIds: preservedUnreadStaffIds,
                            unreadCounts: mergedUnreadCounts,
                            messages: mergeMessages(
                              c.messages,
                              contactNewMessages,
                            ),
                          }
                        : c,
                    );
                  } else {
                    return [
                      ...prevContacts,
                      { ...contact, messages: contactNewMessages },
                    ];
                  }
                });

                // Update selectedChat - merge with new event messages
                setSelectedChat((prevChat) => {
                  if (prevChat?._id !== contact._id) return prevChat;
                  const chatNewMessages = newMessagesFromServer.filter(
                    (m) => isMessageForContact(m, prevChat.uid),
                  );
                  // Preserve local unreadStaffIds - user is viewing this chat
                  const preservedUnreadStaffIds =
                    prevChat.unreadStaffIds?.filter((s) => s !== auth.user._id);
                  return {
                    ...prevChat,
                    ...contact,
                    unreadStaffIds: preservedUnreadStaffIds,
                    messages: mergeMessages(prevChat.messages, chatNewMessages),
                  };
                });

                if (contact.isGroup) {
                  setSelectedGroup(contact);
                }
              }
              if (message.isNewGroup) {
                setSelectedGroup(null);
                setGroupMembers([]);
                setIsOpenGroupMembersSideBar(false);
                setSelectedChat(
                  message.data.find((x) => x.uid === message.groupId),
                );
                setSelectedChatName(
                  message.data.find((x) => x.uid === message.groupId)?.name,
                );
                messageInputRef?.current?.focus();
              }
              await ensureRealtimeContactsHydrated(
                selectedShop,
                newMessagesFromServer.map((m) => m.messageId),
                message.data,
                {
                  insertAtStart: true,
                  preserveExistingMessages: true,
                  mergeMessages: true,
                },
              );
              scheduleRealtimeRevalidate();
            }
            if (message.removeGroupIds && message.removeGroupIds?.length > 0) {
              setContacts((prevContacts) =>
                prevContacts.filter(
                  (c) => !message.removeGroupIds?.includes(c.uid),
                ),
              );
            }
          }
          // Handle contact_updated event for real-time sync
          if (message.type === "contact_updated" && message.data) {
            await hydrateRealtimeContact(selectedShop, message.data.uid, {
              insertAtStart: false,
              mergeMessages: true,
            });
            scheduleRealtimeRevalidate(0);
          }
          // Handle staff_updated event for permission sync
          if (message.type === "staff_updated" && message.data) {
            const updatedStaff = message.data;
            setStaffs((prevStaffs) =>
              prevStaffs.map((s) =>
                s._id === updatedStaff._id ? { ...s, ...updatedStaff } : s,
              ),
            );
            // If it's the current user, update auth state
            if (updatedStaff._id === auth.user._id) {
              getUser();
            }
          }
          // Handle tagzalo_updated event for tag zalo sync
          if (message.type === "tagzalo_updated") {
            getTagZalos(selectedShop._id);
            // getTagZalos already updates groupTagZalos
          }

          // Handle tag_updated event (Main Socket)
          if (message.type === "tag_updated") {
            const resTags = await tagApi.getByShopId(selectedShop._id);
            if (resTags.status === 1) {
              setTags(resTags.data);
              // Also update groupTags
              setGroupTags((prev) => {
                const otherShopsTags = prev.filter(
                  (t) => t._shopId !== selectedShop._id,
                );
                const newShopTags = resTags.data.map((t) => ({
                  ...t,
                  _shopId: selectedShop._id,
                }));
                return [...otherShopsTags, ...newShopTags];
              });
            }
          }

          // Handle message_pinned event
          if (message.type === "message_pinned" && message.data) {
            const { conversationUid, messageId, pinnedMessage, pinnedByName } =
              message.data;
            // Update pinned messages state if viewing the same conversation
            if (selectedChatRef.current?.uid === conversationUid) {
              setPinnedMessages((prev) => {
                // Check if already exists
                if (prev.some((p) => p.messageId === messageId)) return prev;
                return [
                  { ...pinnedMessage, messages: message.data.message },
                  ...prev,
                ];
              });
              setPinnedMessageIds((prev) => new Set([...prev, messageId]));
            }
          }

          // Handle message_unpinned event
          if (message.type === "message_unpinned" && message.data) {
            const { conversationUid, messageId } = message.data;
            // Update pinned messages state if viewing the same conversation
            if (selectedChatRef.current?.uid === conversationUid) {
              setPinnedMessages((prev) =>
                prev.filter((p) => p.messageId !== messageId),
              );
              setPinnedMessageIds((prev) => {
                const newSet = new Set(prev);
                newSet.delete(messageId);
                return newSet;
              });
            }
          }
        })();
      };

      socketRef.current.onerror = (error) => {
        console.error("WebSocket error:", error);
        clearSubscriptionHeartbeat();
        clearListenRetry();
      };

      socketRef.current.onclose = (event) => {
        console.log(
          `WebSocket closed: code=${event.code} clean=${event.wasClean}`,
        );
        clearSubscriptionHeartbeat();
        clearListenRetry();
        // Always reconnect unless manually closed
        scheduleReconnect();
      };
    };

    window.addEventListener("focus", handleSocketRefocus);
    document.addEventListener("visibilitychange", handleSocketRefocus);
    connectSocket();

    return () => {
      isManuallyClosed = true;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      clearSubscriptionHeartbeat();
      clearListenRetry();
      window.removeEventListener("focus", handleSocketRefocus);
      document.removeEventListener("visibilitychange", handleSocketRefocus);
      // In group mode, don't close socket on selectedShop change
      if (!isGroupModeRef.current && socketRef.current) {
        socketRef.current.close();
      }
    };
  }, [groupId, refreshShopSessions, selectedShop]);

  // Group mode: Create WebSocket connections for ALL shops in the group
  useEffect(() => {
    if (!isGroupMode || groupShops.length === 0) {
      // Clean up any existing group sockets
      groupSocketsRef.current.forEach((socket) => socket.close());
      groupSocketsRef.current.clear();
      return;
    }

    // Track reconnect timers for cleanup
    const groupReconnectTimers = new Map();
    let isGroupManuallyClosed = false;
    const handleGroupSocketRefocus = () => {
      if (document.visibilityState === "hidden") return;
      groupSocketsRef.current.forEach((socket, shopId) => {
        const shop = groupShops.find((item) => item._id === shopId);
        if (!shop) return;
        sendListenMessage(socket, shop, { isHeartbeat: true });
      });
    };

    const connectGroupSocket = (shop) => {
      // Don't reconnect if manually closed
      if (isGroupManuallyClosed) return;
      if (!shop?.isLogin || !shop?.zaloId) return;

      const socket = new WebSocket(getWebSocketUrl());
      let reconnectDelay = 3000;
      const MAX_RECONNECT_DELAY = 30_000;
      let subscriptionHeartbeatTimer = null;
      let shouldReconnect = true;
      let listenRetryAttempt = 0;
      const listenRetryKey = `${shop._id}:listen`;

      const clearSubscriptionHeartbeat = () => {
        if (subscriptionHeartbeatTimer) {
          clearInterval(subscriptionHeartbeatTimer);
          subscriptionHeartbeatTimer = null;
        }
      };

      const clearGroupListenRetry = () => {
        const listenRetryTimer = groupReconnectTimers.get(listenRetryKey);
        if (listenRetryTimer) {
          clearTimeout(listenRetryTimer);
          groupReconnectTimers.delete(listenRetryKey);
        }
      };

      const resetGroupRealtimeConnectionStatus = () => {
        listenRetryAttempt = 0;
        clearGroupListenRetry();
        setRealtimeConnectionStatus((prev) =>
          prev.shopId === shop._id ? { state: "idle" } : prev,
        );
      };

      const scheduleGroupListenRetry = (payload = {}) => {
        if (isGroupManuallyClosed || !shouldReconnect) return;
        clearGroupListenRetry();

        if (payload.retryable === false) {
          setRealtimeConnectionStatus({
            state: "failed",
            shopId: shop._id,
            shopName: shop.name,
            message: payload.message || "Không kết nối được realtime",
          });
          return;
        }

        const delay = Math.min(
          REALTIME_LISTEN_RETRY_BASE_MS * 2 ** Math.min(listenRetryAttempt, 5),
          REALTIME_LISTEN_RETRY_MAX_MS,
        );
        listenRetryAttempt += 1;
        setRealtimeConnectionStatus({
          state: "retrying",
          shopId: shop._id,
          shopName: shop.name,
          message: payload.message || "Đang kết nối lại realtime",
        });

        const timer = setTimeout(() => {
          groupReconnectTimers.delete(listenRetryKey);
          sendListenMessage(socket, shop, { isHeartbeat: true });
        }, delay);
        groupReconnectTimers.set(listenRetryKey, timer);
      };

      const stopAndRefreshGroupSession = async ({
        notification,
        markLoggedOut = false,
      } = {}) => {
        shouldReconnect = false;
        clearSubscriptionHeartbeat();
        clearGroupListenRetry();
        if (markLoggedOut) {
          try {
            await shopApi.updateShop(shop._id, { isLogin: false });
          } catch (error) {
            console.log(error);
          }
        }
        try {
          await refreshShopSessions();
        } catch (error) {
          console.log(error);
        }
        if (notification) {
          addNotification(notification, -1);
        }
        setIsLoading(false);
        try {
          socket.close();
        } catch (_) {}
      };

      socket.onopen = () => {
        console.log(
          `[GroupMode] Connected to WebSocket for shop: ${shop.name}`,
        );
        reconnectDelay = 3000; // Reset backoff on successful connect
        sendListenMessage(socket, shop);
        clearSubscriptionHeartbeat();
        subscriptionHeartbeatTimer = setInterval(() => {
          sendListenMessage(socket, shop, { isHeartbeat: true });
        }, SOCKET_SUBSCRIPTION_HEARTBEAT_MS);
      };

      socket.onmessage = async (event) => {
        const message = JSON.parse(event.data);
        console.log(
          `[GroupMode] Received from shop ${shop.name}:`,
          message.type,
          message.data ? `(${message.data.length} contacts)` : "",
        );

        if (message.type === "send_status" && message.cliMsgId) {
          if (message.status === "sent") {
            mergePersistedSendMessages(message.persistedMessages);
            markSent(message.cliMsgId, {
              msgId: message.msgId,
              outboxId: message.outboxId,
            });
          } else if (message.status === "dead") {
            markError(
              message.cliMsgId,
              message.error || "Không gửi được sau nhiều lần thử",
            );
          } else if (message.status === "queued") {
            markQueued(message.cliMsgId);
          }
          return;
        }

        if (message.type === "zalo_reconnected") {
          sendListenMessage(socket, shop, { isHeartbeat: true });
          scheduleRealtimeRevalidate(0);
          return;
        }

        if (message.type === "listen_message_error") {
          scheduleGroupListenRetry(message);
          return;
        }

        if (message.type === "logged_in") {
          resetGroupRealtimeConnectionStatus();
          setGroupShops((prev) =>
            prev.map((item) =>
              item._id === shop._id
                ? {
                    ...item,
                    isLogin: true,
                    sessionRevision:
                      message.sessionRevision ?? item.sessionRevision,
                  }
                : item,
            ),
          );
        }

        if (message.type === "duplicate_zalo_active") {
          await stopAndRefreshGroupSession({
            notification: `Zalo của ${shop.name} đang được shop khác giữ active`,
          });
          return;
        }

        if (message.type === "session_stale") {
          await stopAndRefreshGroupSession({
            notification: `Phiên làm việc của ${shop.name} đã cũ, đang đồng bộ lại`,
          });
          return;
        }

        if (message.type === "session_expired") {
          await stopAndRefreshGroupSession({
            notification: `Phiên đăng nhập của ${shop.name} đã hết hạn, vui lòng đăng nhập lại`,
          });
          return;
        }

        // Handle received_message - update contacts with shop info
        if (message.type === "received_message" && message.data) {
          // Get new messages from message.newMessages (same as main socket)
          const newMessagesFromServer = message.newMessages || [];

          for (const contact of message.data) {
            // Skip hidden contacts unless viewing hidden filter
            if (
              contact.isHidden &&
              !selectedCategoriesRef.current.includes("hidden")
            )
              continue;
            const contactWithShop = {
              ...contact,
              _shopId: shop._id,
              _shopName: shop.name,
              _shopAvatar: shop.avatar,
            };

            // Get messages for this specific contact
            const contactNewMessages = newMessagesFromServer.filter(
              (m) => isMessageForContact(m, contact.uid),
            );

            console.log(
              `[GroupMode] Contact ${contact.uid}: ${contactNewMessages.length} new messages`,
            );

            setContacts((prev) => {
              const existingIndex = prev.findIndex(
                (c) => c._id === contact._id,
              );
              if (existingIndex >= 0) {
                const existing = prev[existingIndex];
                const existingMessages = existing.messages || [];
                const mergedMessages = mergeIncomingMessagesWithOptimistic(
                  existingMessages,
                  contactNewMessages,
                  {
                    onMatch: (existingMsg, matchedServerMsg) => {
                      if (!existingMsg.staffId || !matchedServerMsg?._id) {
                        return;
                      }
                      shopApi.updateMessageStaff({
                        messageId: matchedServerMsg._id,
                        staffId: existingMsg.staffId,
                        staffName: existingMsg.staffName,
                      });
                    },
                  },
                );

                // Preserve local unreadStaffIds when this chat is selected
                // or was recently marked as read — prevents server echo from
                // reverting the badge after the user clicks to read.
                const isSelectedChatGm =
                  selectedChatRef.current?._id === contact._id;
                const recentlyReadGm = wasRecentlyMarkedAsRead(contact);
                const preservedUnreadStaffIdsGm =
                  isSelectedChatGm || recentlyReadGm
                    ? existing.unreadStaffIds?.filter(
                        (s) => s !== auth.user._id,
                      )
                    : contactWithShop.unreadStaffIds;

                const updated = [...prev];
                updated[existingIndex] = {
                  ...existing,
                  ...contactWithShop,
                  unreadStaffIds: preservedUnreadStaffIdsGm,
                  messages: mergedMessages,
                };
                // Move to top if has new messages
                if (contactNewMessages.length > 0) {
                  const [item] = updated.splice(existingIndex, 1);
                  updated.unshift(item);
                }
                return updated;
              }
              return [
                {
                  ...contactWithShop,
                  messages: contactNewMessages,
                },
                ...prev,
              ];
            });

            // Update selectedChat if it matches
            setSelectedChat((prevChat) => {
              if (prevChat?._id === contact._id) {
                return {
                  ...prevChat,
                  ...contactWithShop,
                  messages: mergeIncomingMessagesWithOptimistic(
                    prevChat.messages || [],
                    contactNewMessages,
                  ),
                };
              }
              return prevChat;
            });
          }
          await ensureRealtimeContactsHydrated(
            shop,
            newMessagesFromServer.map((m) => m.messageId),
            message.data,
            {
              insertAtStart: true,
              preserveExistingMessages: true,
              mergeMessages: true,
            },
          );
          scheduleRealtimeRevalidate();
        }

        // Handle new_react - update message reactions (same logic as main socket)
        if (message.type === "new_react") {
          if (
            Array.isArray(message.messageReactions) &&
            message.messageReactions.length > 0
          ) {
            replaceReactsInChatState(message.messageReactions);
          } else if (message.reacts) {
            applyReactionEventsToChatState(message.reacts);
          }
        }

        // Handle undo - mark messages as recalled (same logic as main socket)
        if (message.type === "undo" && message.undos) {
          for (const undo of message.undos) {
            setContacts((prevContacts) =>
              prevContacts.map((c) => ({
                ...c,
                messages: c.messages?.map((m) =>
                  String(m.msgId) === String(undo.msgId) ||
                  String(m.cliMsgId) === String(undo.cliMsgId)
                    ? { ...m, isUndo: true }
                    : m,
                ),
              })),
            );
            setSelectedChat((prevChat) =>
              prevChat
                ? {
                    ...prevChat,
                    messages: prevChat.messages?.map((m) =>
                      String(m.msgId) === String(undo.msgId) ||
                      String(m.cliMsgId) === String(undo.cliMsgId)
                        ? { ...m, isUndo: true }
                        : m,
                    ),
                  }
                : prevChat,
            );
          }
        }

        // Handle seen_messages - update sendingStatus (same logic as main socket)
        if (message.type === "seen_messages" && message.seenMessages) {
          for (const seen of message.seenMessages) {
            setContacts((prevContacts) =>
              prevContacts.map((c) => ({
                ...c,
                messages: c.messages?.map((m) =>
                  String(m.msgId) === String(seen.msgId)
                    ? { ...m, sendingStatus: "seen" }
                    : m,
                ),
              })),
            );
            setSelectedChat((prevChat) =>
              prevChat
                ? {
                    ...prevChat,
                    messages: prevChat.messages?.map((m) =>
                      String(m.msgId) === String(seen.msgId)
                        ? { ...m, sendingStatus: "seen" }
                        : m,
                    ),
                  }
                : prevChat,
            );
          }
        }

        // Handle sync_data - refresh contact from API
        if (message.type === "sync_data" && message.uid) {
          await hydrateRealtimeContact(shop, message.uid, {
            insertAtStart: false,
            mergeMessages: true,
          });
          scheduleRealtimeRevalidate(0);
        }

        // Handle control events (group changes etc)
        if (message.type === "control" && message.data) {
          const newMessagesFromServer = message.newMessages || [];

          for (const contact of message.data) {
            const contactWithShop = {
              ...contact,
              _shopId: shop._id,
              _shopName: shop.name,
              _shopAvatar: shop.avatar,
            };
            const contactNewMessages = newMessagesFromServer.filter(
              (m) => isMessageForContact(m, contact.uid),
            );

            setContacts((prevContacts) => {
              const existingIndex = prevContacts.findIndex(
                (c) => c._id === contact._id,
              );
              if (existingIndex >= 0) {
                const existing = prevContacts[existingIndex];
                const isSelectedChat =
                  selectedChatRef.current?._id === contact._id;
                const recentlyRead = wasRecentlyMarkedAsRead(contact);
                const preservedUnreadStaffIds =
                  isSelectedChat || recentlyRead
                    ? existing.unreadStaffIds?.filter(
                        (s) => s !== auth.user._id,
                      )
                    : contact.unreadStaffIds;

                const existingMsgIds = new Set(
                  (existing.messages || []).map((m) => m._id).filter(Boolean),
                );
                const newMsgs = contactNewMessages.filter(
                  (m) => !existingMsgIds.has(m._id),
                );

                const updated = [...prevContacts];
                updated[existingIndex] = {
                  ...existing,
                  ...contactWithShop,
                  unreadStaffIds: preservedUnreadStaffIds,
                  messages: [...(existing.messages || []), ...newMsgs],
                };
                return updated;
              } else {
                return [
                  { ...contactWithShop, messages: contactNewMessages },
                  ...prevContacts,
                ];
              }
            });

            setSelectedChat((prevChat) => {
              if (prevChat?._id !== contact._id) return prevChat;
              const chatNewMessages = newMessagesFromServer.filter(
                (m) => isMessageForContact(m, prevChat.uid),
              );
              const existingMsgIds = new Set(
                (prevChat.messages || []).map((m) => m._id).filter(Boolean),
              );
              const newMsgs = chatNewMessages.filter(
                (m) => !existingMsgIds.has(m._id),
              );
              const preservedUnreadStaffIds = prevChat.unreadStaffIds?.filter(
                (s) => s !== auth.user._id,
              );
              return {
                ...prevChat,
                ...contactWithShop,
                unreadStaffIds: preservedUnreadStaffIds,
                messages: [...(prevChat.messages || []), ...newMsgs],
              };
            });

            if (contact.isGroup) {
              setSelectedGroup(contact);
            }
          }
          await ensureRealtimeContactsHydrated(
            shop,
            newMessagesFromServer.map((m) => m.messageId),
            message.data,
            {
              insertAtStart: true,
              preserveExistingMessages: true,
              mergeMessages: true,
            },
          );
          scheduleRealtimeRevalidate();

          if (message.removeGroupIds && message.removeGroupIds?.length > 0) {
            setContacts((prevContacts) =>
              prevContacts.filter(
                (c) => !message.removeGroupIds?.includes(c.uid),
              ),
            );
          }
        }

        // Handle contact_updated event
        if (message.type === "contact_updated" && message.data) {
          await hydrateRealtimeContact(shop, message.data.uid, {
            insertAtStart: false,
            mergeMessages: true,
          });
          scheduleRealtimeRevalidate(0);
        }

        // Handle staff_updated event
        if (message.type === "staff_updated" && message.data) {
          const updatedStaff = message.data;
          setStaffs((prevStaffs) =>
            prevStaffs.map((s) =>
              s._id === updatedStaff._id ? { ...s, ...updatedStaff } : s,
            ),
          );
          if (updatedStaff._id === auth.user._id) {
            getUser();
          }
        }

        // Handle tagzalo_updated event (Group Socket)
        if (message.type === "tagzalo_updated") {
          // Verify if this shop is in our group shops list
          const isInGroup = groupShops.some((s) => s._id === shop._id);
          if (isInGroup) {
            getTagZalos(shop._id);
          }
        }

        // Handle tag_updated event (Group Socket)
        if (message.type === "tag_updated") {
          const resTags = await tagApi.getByShopId(shop._id);
          if (resTags.status === 1) {
            // Always update groupTags regardless of active shop
            setGroupTags((prev) => {
              const otherShopsTags = prev.filter((t) => t._shopId !== shop._id);
              const newShopTags = resTags.data.map((t) => ({
                ...t,
                _shopId: shop._id,
              }));
              return [...otherShopsTags, ...newShopTags];
            });

            // Only update current view tags if it's the active shop
            const currentShopId = activeContactShop?._id || selectedShop?._id;
            if (shop._id === currentShopId) {
              setTags(resTags.data);
            }
          }
        }

        // Handle message_pinned event
        if (message.type === "message_pinned" && message.data) {
          const { conversationUid, messageId, pinnedMessage } = message.data;
          if (selectedChatRef.current?.uid === conversationUid) {
            setPinnedMessages((prev) => {
              if (prev.some((p) => p.messageId === messageId)) return prev;
              return [
                { ...pinnedMessage, messages: message.data.message },
                ...prev,
              ];
            });
            setPinnedMessageIds((prev) => new Set([...prev, messageId]));
          }
        }

        // Handle message_unpinned event
        if (message.type === "message_unpinned" && message.data) {
          const { conversationUid, messageId } = message.data;
          if (selectedChatRef.current?.uid === conversationUid) {
            setPinnedMessages((prev) =>
              prev.filter((p) => p.messageId !== messageId),
            );
            setPinnedMessageIds((prev) => {
              const newSet = new Set(prev);
              newSet.delete(messageId);
              return newSet;
            });
          }
        }

        // Handle synced event
        if (message.type === "synced") {
          resetGroupRealtimeConnectionStatus();
          try {
            await shopApi.updateShop(shop._id, { isLogin: true });
          } catch (error) {
            console.log(error);
          }
          addNotification(`Đã đồng bộ tin nhắn (${shop.name})`, 1);
          setIsLoading(false);
        }

        // Handle logged_out event
        if (message.type === "logged_out") {
          await stopAndRefreshGroupSession({
            notification: `Tài khoản ${shop.name} chưa đăng nhập`,
            markLoggedOut: true,
          });
          return;
        }

        // Handle error_browser event
        if (message.type === "error_browser") {
          addNotification(`Có lỗi xảy ra với ${shop.name}`, -1);
          setIsLoading(false);
        }
      };

      socket.onclose = () => {
        console.log(`[GroupMode] Disconnected from shop: ${shop.name}`);
        clearSubscriptionHeartbeat();
        clearGroupListenRetry();
        groupSocketsRef.current.delete(shop._id);
        // Auto-reconnect with exponential backoff
        if (!isGroupManuallyClosed && shouldReconnect) {
          setRealtimeConnectionStatus({
            state: "retrying",
            shopId: shop._id,
            shopName: shop.name,
            message: "Mất kết nối realtime, đang nối lại",
          });
          console.log(
            `[GroupMode] Reconnecting ${shop.name} in ${reconnectDelay / 1000}s...`,
          );
          const timer = setTimeout(() => {
            connectGroupSocket(shop);
            reconnectDelay = Math.min(
              reconnectDelay * 1.5,
              MAX_RECONNECT_DELAY,
            );
          }, reconnectDelay);
          groupReconnectTimers.set(shop._id, timer);
        }
      };

      socket.onerror = (error) => {
        console.error(`[GroupMode] WebSocket error for ${shop.name}:`, error);
        clearSubscriptionHeartbeat();
        clearGroupListenRetry();
      };

      groupSocketsRef.current.set(shop._id, socket);
    };

    // Connect all shops in the group
    groupShops.forEach((shop) => {
      // Skip if already connected
      if (groupSocketsRef.current.has(shop._id)) return;
      connectGroupSocket(shop);
    });

    window.addEventListener("focus", handleGroupSocketRefocus);
    document.addEventListener("visibilitychange", handleGroupSocketRefocus);

    return () => {
      isGroupManuallyClosed = true;
      window.removeEventListener("focus", handleGroupSocketRefocus);
      document.removeEventListener(
        "visibilitychange",
        handleGroupSocketRefocus,
      );
      // Clear all reconnect timers
      groupReconnectTimers.forEach((timer) => clearTimeout(timer));
      groupReconnectTimers.clear();
      groupSocketsRef.current.forEach((socket) => socket.close());
      groupSocketsRef.current.clear();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupSocketKey, isGroupMode, refreshShopSessions]); // Don't include selectedShop to avoid reconnection

  // Cập nhật title web
  useEffect(() => {
    const unreadCount = unreadMessageTotal;
    document.title = `${unreadCount > 0 ? `(${unreadCount}) ` : ""}${
      selectedShop?.name ? `${selectedShop.name} - ` : ""
    }akaBiz Chat`;
    return () => (document.title = "akaBiz Chat");
  }, [selectedShop, unreadMessageTotal]);

  useEffect(() => {
    // if (selectedChat) messageInputRef.current.focus();
    // Only mark as read if:
    // 1. User is in unreadStaffIds
    // 2. This conversation wasn't already marked as read recently (avoids double API call)
    if (
      selectedChat?.unreadStaffIds?.includes(auth.user._id) &&
      !wasRecentlyMarkedAsRead(selectedChat)
    ) {
      // Track that this conversation was just marked as read (stores both _id and uid)
      markAsReadInRef(selectedChat);
      setContacts((pre) =>
        pre.map((c) =>
          c._id === selectedChat._id
            ? {
                ...c,
                unreadStaffIds: selectedChat.unreadStaffIds?.filter(
                  (s) => s !== auth.user._id,
                ),
              }
            : c,
        ),
      );
      // API call is handled in handleContactClick via markConversationAsRead.
      // This useEffect only keeps the optimistic local update for paths that
      // set selectedChat outside of handleContactClick (deep links, sync events).
    }
    loadGroupMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedChat?._id]); // Only re-run when chat ID changes, not when messages update

  useEffect(() => {
    setRepMessage(null);
  }, [selectedChat?._id]);

  useEffect(() => {
    if (auth.isError) addNotification(auth.errorMessage, -1);
    if (auth.user._id) {
      dispatch(
        getShopsRequest({
          accountId: auth.user.accountId,
          staffId: auth.user._id,
        }),
      );
      userApi.getByAccountId(auth.user.accountId).then((res) => {
        if (res.status === 1) setStaffs(res.data);
      });

      getUser();
      getShopGroups();
    }
  }, [auth, dispatch]);

  // Refactored: Load shop-specific data (Tags, QuickMessages) whenever selectedShop changes
  // This works for both Single Shop Mode and Group Mode
  useEffect(() => {
    (async () => {
      const shopIdToLoad = activeContactShop?._id || selectedShop?._id;
      if (!shopIdToLoad) return;

      try {
        await getTagZalos(shopIdToLoad);

        const resTags = await tagApi.getByShopId(shopIdToLoad);
        if (resTags.status === 1) {
          setTags(resTags.data);
          // Also update groupTags to keep it consistent
          setGroupTags((prev) => {
            const otherShopsTags = prev.filter(
              (t) => t._shopId !== shopIdToLoad,
            );
            const newShopTags = resTags.data.map((t) => ({
              ...t,
              _shopId: shopIdToLoad,
            }));
            return [...otherShopsTags, ...newShopTags];
          });
        }

        const resQuickMessages =
          await quickMessageApi.getByShopId(shopIdToLoad);
        if (resQuickMessages.status === 1)
          setQuickMessages(resQuickMessages.data);
      } catch (error) {
        console.error("Error loading shop data:", error);
      }
    })();
  }, [selectedShop?._id, activeContactShop?._id]);

  useEffect(() => {
    (async () => {
      try {
        // Skip if in group mode or ad-hoc multi-shop mode
        if (groupId || multiShopIds.length > 0) return;

        const shop = shops.data.find((x) => x._id === shopId);
        if (shop) {
          // Force reload if coming from group mode or if shop changed
          const needsReload =
            shop?._id !== selectedShop?._id || isGroupModeRef.current;

          if (needsReload) {
            setSelectedShop(shop);

            // Data loading moved to selectedShop effect
          }
        } else if (!shopId && shops.data.length === 0) {
          setSelectedShop(null);
          setContacts([]);
        }
      } catch (error) {
        setIsLoadingScreen(false);
        console.log(error);
      }
    })();
  }, [shopId, multiShopIds.length]);

  useEffect(() => {
    // Skip redirect if in group mode or ad-hoc multi-shop mode
    if (groupId || multiShopIds.length > 0) return;

    if (!shopId && shops.data[0]?._id) {
      navigate(`/chat/${shops.data[0]._id}`);
      return;
    }
    (async () => {
      const shop = shops.data.find((x) => x._id === shopId);
      if (shop) {
        if (hasShopSessionChanged(selectedShop, shop)) {
          setSelectedShop(shop);

          //setIsLoadingScreen(true);
          // Data loading moved to selectedShop effect
          //setIsLoadingScreen(false);
        }
      } else if (shops.data.length > 0) {
        // Shop URL không hợp lệ, chuyển về trang danh sách shop
        navigate("/shop");
      } else {
        setSelectedShop(null);
        setContacts([]);
      }
    })();
  }, [shops]);

  useEffect(() => {
    if (!isGroupModeRef.current || groupShops.length === 0) return;

    const currentGroupIds = new Set(groupShops.map((shop) => shop._id));
    const nextGroupShops = shops.data.filter((shop) =>
      currentGroupIds.has(shop._id),
    );

    const hasGroupChange =
      nextGroupShops.length !== groupShops.length ||
      nextGroupShops.some((shop) => {
        const previous = groupShops.find((item) => item._id === shop._id);
        return hasShopSessionChanged(previous, shop);
      });

    if (!hasGroupChange) return;

    setGroupShops(nextGroupShops);

    if (activeContactShop?._id) {
      const nextActiveContactShop =
        nextGroupShops.find((shop) => shop._id === activeContactShop._id) ||
        null;
      if (hasShopSessionChanged(activeContactShop, nextActiveContactShop)) {
        setActiveContactShop(nextActiveContactShop);
      }
    }

    if (selectedShop?._id) {
      const nextSelectedShop =
        nextGroupShops.find((shop) => shop._id === selectedShop._id) ||
        nextGroupShops[0] ||
        null;
      if (hasShopSessionChanged(selectedShop, nextSelectedShop)) {
        setSelectedShop(nextSelectedShop);
      }
    }
  }, [activeContactShop, groupShops, selectedShop, shops]);

  // Handle group mode - load group data and contacts from all shops
  useEffect(() => {
    if (!groupId || !auth.user?._id || shops.data.length === 0) {
      // Only tear down group mode if we're NOT also in ad-hoc multi mode
      if (!groupId && multiShopIds.length === 0) {
        setIsGroupMode(false);
        isGroupModeRef.current = false;
        setGroupShops([]);
        setActiveShopGroup(null);
        // Clean up group sockets
        groupSocketsRef.current.forEach((s) => s.close());
        groupSocketsRef.current.clear();
      }
      return;
    }

    (async () => {
      try {
        setIsLoadingScreen(true);
        const res = await shopGroupApi.getById(groupId, auth.user._id);
        if (res.status === 1 && res.data) {
          const group = res.data;
          const shopsInGroup = shops.data.filter((s) =>
            group.shopIds?.includes(s._id),
          );

          if (shopsInGroup.length > 0) {
            setGroupShops(shopsInGroup);
            setIsGroupMode(true);
            isGroupModeRef.current = true;
            setActiveShopGroup(group); // Set active group for display in UserPopover

            // Set selectedShop to default or first shop in group
            const defaultShop = group.defaultSearchShopId
              ? shopsInGroup.find((s) => s._id === group.defaultSearchShopId)
              : shopsInGroup[0];
            setSelectedShop(defaultShop || shopsInGroup[0]);

            // Load contacts from all shops
            await loadContactsFromShops(shopsInGroup);
          }
        } else {
          addNotification("Không tìm thấy nhóm hoặc bạn không có quyền", -1);
        }
        setIsLoadingScreen(false);
      } catch (error) {
        console.error("Error loading group:", error);
        setIsLoadingScreen(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId, shops.data.length, auth.user?._id]);

  // Handle ad-hoc multi-shop mode (/chat/multi/:shopIds) - no saved group record
  useEffect(() => {
    if (multiShopIds.length === 0 || shops.data.length === 0) return;

    const shopsSelected = shops.data.filter((s) =>
      multiShopIds.includes(s._id),
    );

    if (shopsSelected.length === 0) {
      // All IDs invalid → fallback to first shop
      if (shops.data[0]?._id) {
        navigate(`/chat/${shops.data[0]._id}`, { replace: true });
      }
      return;
    }

    if (shopsSelected.length === 1) {
      // Only one valid shop → collapse to single-shop URL
      navigate(`/chat/${shopsSelected[0]._id}`, { replace: true });
      return;
    }

    (async () => {
      try {
        setIsLoadingScreen(true);
        setGroupShops(shopsSelected);
        setIsGroupMode(true);
        isGroupModeRef.current = true;
        setActiveShopGroup(null); // ad-hoc: no saved group
        setSelectedShop(shopsSelected[0]);
        await loadContactsFromShops(shopsSelected);
      } catch (error) {
        console.error("Error loading multi-shop:", error);
      } finally {
        setIsLoadingScreen(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopIdsParam, shops.data.length, auth.user?._id]);

  useEffect(() => {
    if (selectedChat && selectedShop) {
      const newSelectedChat = contacts
        .filter(
          (x) =>
            user?.role?.includes("admin") ||
            user?._id === selectedShop?.staffId ||
            user?.shopRoles
              ?.find((sr) => sr.shopId === selectedShop?._id)
              ?.role?.includes("admin") ||
            !user?.shopRoles
              ?.find((sr) => sr.shopId === selectedShop?._id)
              ?.permissions?.includes("view_only_own_contact") ||
            x.staffIds.length === 0 ||
            x.staffIds.includes(auth?.user?._id) ||
            x.staffIds.some((staffId) =>
              user?.shopRoles
                ?.find((sr) => sr.shopId === selectedShop?._id)
                ?.viewMoreStaffIds?.includes(staffId),
            ),
        )
        .filter(
          (x) =>
            user?.role?.includes("admin") ||
            user?._id === selectedShop?.staffId ||
            user?.shopRoles
              ?.find((sr) => sr.shopId === selectedShop?._id)
              ?.role?.includes("admin") ||
            !user?.shopRoles
              ?.find((sr) => sr.shopId === selectedShop?._id)
              ?.permissions?.includes("not_view_contact_no_one_manage") ||
            x.staffIds.length > 0,
        )
        .find((x) => x.uid === selectedChat.uid);
      // Only update selectedChat if newSelectedChat exists to prevent blank screen
      // when contact is temporarily not found due to race conditions (e.g., after accepting friend request)
      if (newSelectedChat) {
        if (
          !selectedChat?.messages?.find((msg) => msg.isSending) ||
          selectedChat?.messages?.filter((m) => m.uidFrom === "0")?.length <=
            newSelectedChat?.messages?.filter((m) => m.uidFrom === "0")?.length
        ) {
          setSelectedChat(newSelectedChat);
        } else {
          setSelectedChat((pre) => ({
            ...newSelectedChat,
            messages: pre?.messages ?? newSelectedChat?.messages ?? [],
          }));
        }
      }
    }
    // Group members are loaded in the selectedChat?._id useEffect, no need to reload here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contacts]);

  const [contactPage, setContactPage] = useState(1);
  const contactListRef = useRef(null);

  const triggerLoadMoreContacts = useCallback(() => {
    if (isLoadingMoreContactsRef.current || !hasMoreContactsRef.current) return;
    isLoadingMoreContactsRef.current = true;
    setContactPage((prevPage) => prevPage + 1);
  }, []);

  // IntersectionObserver theo dõi sentinel ở cuối list — trigger load thêm khi sentinel vào viewport
  useEffect(() => {
    const sentinel = sentinelRef.current;
    const root = contactListRef.current;
    if (!sentinel || !root) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          triggerLoadMoreContacts();
        }
      },
      { root, rootMargin: "200px 0px", threshold: 0 },
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [triggerLoadMoreContacts, hasMoreContacts, loadMoreContactsError]);

  // Load more contacts when scrolling down
  useEffect(() => {
    if (contactPage === 1 || !hasMoreContacts || isLoadingMoreContacts) return;

    // Group mode pagination
    if (isGroupMode && groupShops.length > 0) {
      setIsLoadingMoreContacts(true);
      isLoadingMoreContactsRef.current = true;
      setLoadMoreContactsError(false);
      loadContactsFromShops(groupShops, contactPage, true)
        .then(() => {
          setIsLoadingMoreContacts(false);
          isLoadingMoreContactsRef.current = false;
        })
        .catch(() => {
          setIsLoadingMoreContacts(false);
          isLoadingMoreContactsRef.current = false;
          setLoadMoreContactsError(true);
        });
      return;
    }

    // Single shop mode
    if (!selectedShop) return;

    // Cancel previous fetch if still in flight
    if (contactsFetchAbortRef.current) {
      contactsFetchAbortRef.current.abort();
    }
    const controller = new AbortController();
    contactsFetchAbortRef.current = controller;

    setIsLoadingMoreContacts(true);
    isLoadingMoreContactsRef.current = true;
    setLoadMoreContactsError(false);
    const filters = {
      categories: selectedCategoriesRef.current,
      staffId: auth.user._id,
      tagIds: selectedTagsRef.current,
      tagZaloIds: selectedTagZalosRef.current,
      staffIds: selectedStaffsRef.current,
      pipelineStageIds: selectedPipelineStageIdsRef.current,
      needsReplyMinutes: needsReplyMinutesRef.current,
      newCustomerDays: newCustomerDaysRef.current,
      hasContactInfo: hasContactInfoRef.current,
      upcomingBirthdayDays: upcomingBirthdayDaysRef.current,
      sortMode: sortModeRef.current,
    };
    shopApi
      .getContacts(selectedShop._id, 0, contactPage, 20, filters, controller.signal)
      .then((res) => {
        if (res.status === 1) {
          setContacts((prev) => {
            const existingIds = new Set(prev.map((c) => c._id));
            const newContacts = res.data.filter((c) => !existingIds.has(c._id));
            return [...prev, ...newContacts];
          });
          const hasMore = res.hasMore !== false && res.data.length > 0;
          setHasMoreContacts(hasMore);
          hasMoreContactsRef.current = hasMore;
        } else {
          setHasMoreContacts(false);
          hasMoreContactsRef.current = false;
        }
        setIsLoadingMoreContacts(false);
        isLoadingMoreContactsRef.current = false;
      })
      .catch((err) => {
        // Ignore aborted requests (user changed filter mid-flight)
        if (err?.name === "CanceledError" || err?.name === "AbortError" || err?.code === "ERR_CANCELED") {
          return;
        }
        setIsLoadingMoreContacts(false);
        isLoadingMoreContactsRef.current = false;
        setLoadMoreContactsError(true);
      });

    return () => controller.abort();
  }, [contactPage]);

  // Reload contacts when any filter (category/tag/tagZalo/staff/pipeline/needsReply/sort) changes
  useEffect(() => {
    selectedCategoriesRef.current = selectedCategories;
    selectedTagsRef.current = selectedTags;
    selectedTagZalosRef.current = selectedTagZalos;
    selectedStaffsRef.current = selectedStaffs;
    selectedPipelineStageIdsRef.current = selectedPipelineStageIds;
    needsReplyMinutesRef.current = needsReplyMinutes;
    newCustomerDaysRef.current = newCustomerDays;
    hasContactInfoRef.current = hasContactInfo;
    upcomingBirthdayDaysRef.current = upcomingBirthdayDays;
    sortModeRef.current = sortMode;
    refreshUnreadMessageCount();

    // Reset pagination
    setContactPage(1);
    setHasMoreContacts(true);
    hasMoreContactsRef.current = true;
    setIsLoadingMoreContacts(true);
    isLoadingMoreContactsRef.current = true;
    setLoadMoreContactsError(false);

    // Group mode: reload from all shops
    if (isGroupMode && groupShops.length > 0) {
      loadContactsFromShops(groupShops, 1, false)
        .then(() => {
          setIsLoadingMoreContacts(false);
          isLoadingMoreContactsRef.current = false;
        })
        .catch(() => {
          setIsLoadingMoreContacts(false);
          isLoadingMoreContactsRef.current = false;
          setLoadMoreContactsError(true);
        });
      return;
    }

    // Single shop mode
    if (!selectedShop) {
      setIsLoadingMoreContacts(false);
      isLoadingMoreContactsRef.current = false;
      return;
    }

    // Cancel previous fetch if still in flight (prevents stale data after filter change)
    if (contactsFetchAbortRef.current) {
      contactsFetchAbortRef.current.abort();
    }
    const controller = new AbortController();
    contactsFetchAbortRef.current = controller;

    const filters = {
      categories: selectedCategories,
      staffId: auth.user._id,
      tagIds: selectedTags,
      tagZaloIds: selectedTagZalos,
      staffIds: selectedStaffs,
      pipelineStageIds: selectedPipelineStageIds,
      needsReplyMinutes,
      newCustomerDays,
      hasContactInfo,
      upcomingBirthdayDays,
      sortMode,
    };
    shopApi
      .getContacts(selectedShop._id, 0, 1, 20, filters, controller.signal)
      .then((res) => {
        if (res.status === 1) {
          // Merge new data while preserving read state for recently read conversations
          setContacts((prev) =>
            prev.length > 0
              ? mergeContactsPreservingReadState(res.data, prev)
              : res.data,
          );
          setHasMoreContacts(res.hasMore !== false);
          hasMoreContactsRef.current = res.hasMore !== false;
        }
        setIsLoadingMoreContacts(false);
        isLoadingMoreContactsRef.current = false;
      })
      .catch((err) => {
        if (err?.name === "CanceledError" || err?.name === "AbortError" || err?.code === "ERR_CANCELED") {
          return;
        }
        setIsLoadingMoreContacts(false);
        isLoadingMoreContactsRef.current = false;
        setLoadMoreContactsError(true);
      });

    return () => controller.abort();
  }, [
    selectedCategories,
    selectedTags,
    selectedTagZalos,
    selectedStaffs,
    selectedPipelineStageIds,
    needsReplyMinutes,
    newCustomerDays,
    hasContactInfo,
    upcomingBirthdayDays,
    sortMode,
    isGroupMode,
    groupShops,
    refreshUnreadMessageCount,
  ]);

  useEffect(() => {
    refreshUnreadMessageCount();
  }, [selectedShop?._id, isGroupMode, groupShops, refreshUnreadMessageCount]);

  // Ref to store loadOlderMessages function (will be set after definition)
  const loadOlderMessagesRef = useRef(null);
  const messageListRef = useRef(null);

  const handleScrollMessage = () => {
    const listNode = messageListRef.current;
    if (!listNode) return;

    // Check guards before loading more
    if (isLoadingMoreMessagesRef.current || !hasMoreMessagesRef.current) return;

    // For flex-direction: column-reverse layout:
    // scrollTop = 0 means at bottom (newest messages)
    // scrollTop < 0 (negative) means scrolled up to see older messages
    // We need to load more when reached the "top" (oldest visible messages)
    // This happens when: scrollHeight + scrollTop <= clientHeight + threshold
    const { scrollTop, scrollHeight, clientHeight } = listNode;
    const distanceFromOldest = scrollHeight + scrollTop - clientHeight;

    if (distanceFromOldest <= 50) {
      // Call anchor-based load function
      if (loadOlderMessagesRef.current) {
        loadOlderMessagesRef.current();
      }
    }
  };

  useEffect(() => {
    const listNode = messageListRef.current;
    if (listNode) {
      listNode.addEventListener("scroll", handleScrollMessage);
    }
    // Cleanup
    return () => {
      if (listNode) {
        listNode.removeEventListener("scroll", handleScrollMessage);
      }
    };
  }, [selectedChat]);

  useEffect(() => {
    // Reset hasMoreMessages when switching chats
    setHasMoreMessages(true);
    hasMoreMessagesRef.current = true;
  }, [selectedChat?._id]);

  // Display-ready messages: slice raw messages first, then merge, then add timeline, then reverse
  const groupMemberNameToUid = useMemo(() => {
    const map = new Map();
    for (const m of groupMembers || []) {
      registerGroupEventLookupValue(map, m?.name, m?.uid);
      registerGroupEventLookupValue(map, m?.zaloName, m?.uid);
    }
    for (const c of contacts || []) {
      if (c?.isGroup) continue;
      registerGroupEventLookupValue(map, c?.name, c?.uid);
      registerGroupEventLookupValue(map, c?.zaloName, c?.uid);
    }
    for (const msg of selectedChat?.messages || []) {
      if (msg?.memberIds?.length && msg?.memberNames?.length) {
        msg.memberIds.forEach((uid, i) => {
          const name = msg.memberNames[i];
          registerGroupEventLookupValue(map, name, uid);
        });
      }
    }
    return map;
  }, [groupMembers, contacts, selectedChat?.messages]);

  const displayMessages = useMemo(() => {
    if (!selectedChat?.messages) return [];
    const dedupedMessages = dedupeMessagesByStableKey(selectedChat.messages);

    // 1. Calculate how many raw messages to take (from the end, since messages are sorted asc by time)
    // With anchor-based loading, we show all loaded messages
    const limit = scrollToMessageIndex
      ? Math.max(scrollToMessageIndex, dedupedMessages.length)
      : dedupedMessages.length;
    const slicedMessages = dedupedMessages.slice(-limit);

    // 2. Merge consecutive images (no timeline insertion)
    const merged = mergeImageMessages(slicedMessages);

    // 3. Insert timeline entries and reverse for display (newest at top)
    const result = [];
    let currentDateStr = "";

    for (const msg of merged) {
      const dateStr = common.getPreviewTimeListMessage(msg.dateAction);
      if (dateStr !== currentDateStr) {
        result.push({
          type: "event_timeline",
          content: dateStr,
          _timelineKey: `timeline_${msg._id || msg.dateAction}`,
        });
        currentDateStr = dateStr;
      }
      result.push(msg);
    }

    return result.reverse();
  }, [selectedChat?.messages, scrollToMessageIndex]);

  // Initial viewport fill check: trigger load more if content doesn't fill viewport
  useEffect(() => {
    if (!selectedChat?.messages || selectedChat.messages.length === 0) return;
    if (isLoadingMoreMessagesRef.current || !hasMoreMessagesRef.current) return;

    const timer = setTimeout(() => {
      const listNode = messageListRef.current;
      if (
        listNode &&
        hasMoreMessagesRef.current &&
        !isLoadingMoreMessagesRef.current
      ) {
        const { scrollHeight, clientHeight } = listNode;
        // If content doesn't fill viewport, trigger load more
        if (scrollHeight <= clientHeight) {
          loadOlderMessages();
        }
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [selectedChat?.messages?.length]);

  // Anchor-based load older messages function
  const loadOlderMessages = async () => {
    if (
      !selectedShop ||
      !selectedChat ||
      isLoadingMoreMessagesRef.current ||
      !hasMoreMessagesRef.current
    )
      return;

    setIsLoadingMoreMessages(true);
    isLoadingMoreMessagesRef.current = true;

    try {
      // Get the oldest message's dateAction as anchor
      const messages = selectedChat.messages || [];
      const oldestMsg = messages[0]; // First message is oldest (sorted by dateAction asc)
      const anchorDate = oldestMsg?.dateAction;

      const res = await shopApi.getMessagesByAnchor(
        selectedShop._id,
        selectedChat.uid,
        {
          anchorDate: anchorDate,
          direction: "before",
          limit: 20,
        },
      );

      if (res.status === 1 && res.data && res.data.length > 0) {
        setSelectedChat((prev) => {
          if (!prev) return prev;
          const existingIds = new Set(prev.messages?.map((m) => m._id) || []);
          const newMessages = res.data.filter((m) => !existingIds.has(m._id));
          return {
            ...prev,
            messages: [...newMessages, ...(prev.messages || [])],
          };
        });
        setContacts((prev) =>
          prev.map((c) => {
            if (c._id !== selectedChat._id) return c;
            const existingIds = new Set(c.messages?.map((m) => m._id) || []);
            const newMessages = res.data.filter((m) => !existingIds.has(m._id));
            return {
              ...c,
              messages: [...newMessages, ...(c.messages || [])],
            };
          }),
        );
        // Update hasMoreMessages based on response
        const hasMore = res.hasMoreBefore !== false;
        setHasMoreMessages(hasMore);
        hasMoreMessagesRef.current = hasMore;
      } else {
        setHasMoreMessages(false);
        hasMoreMessagesRef.current = false;
      }
    } catch (err) {
      console.error("Error loading older messages:", err);
    }

    setIsLoadingMoreMessages(false);
    isLoadingMoreMessagesRef.current = false;
  };

  // Update ref so scroll handler can access the latest loadOlderMessages
  useEffect(() => {
    loadOlderMessagesRef.current = loadOlderMessages;
  });

  useEffect(() => {
    const handleMove = (e) => {
      if (!sidebarResizingRef.current) return;
      const clientX = e.clientX ?? (e.touches && e.touches[0]?.clientX);
      if (clientX == null) return;
      const newWidth = Math.min(
        Math.max(window.innerWidth - clientX, 250),
        500,
      );
      setSidebarInfoWidth(newWidth);
    };
    const stopResize = () => {
      sidebarResizingRef.current = false;
    };
    window.addEventListener("pointermove", handleMove);
    window.addEventListener("pointerup", stopResize);
    window.addEventListener("touchmove", handleMove);
    window.addEventListener("touchend", stopResize);
    return () => {
      window.removeEventListener("pointermove", handleMove);
      window.removeEventListener("pointerup", stopResize);
      window.removeEventListener("touchmove", handleMove);
      window.removeEventListener("touchend", stopResize);
    };
  }, []);

  // Resize cho pannel trái (contacts list) — kéo cạnh phải để thay đổi độ rộng
  useEffect(() => {
    const handleMove = (e) => {
      if (!contactListResizingRef.current) return;
      const clientX = e.clientX ?? (e.touches && e.touches[0]?.clientX);
      if (clientX == null) return;
      const newWidth = Math.min(Math.max(clientX, 240), 560);
      setContactListWidth(newWidth);
      window.localStorage.setItem("contactListWidth", String(newWidth));
    };
    const stopResize = () => {
      contactListResizingRef.current = false;
    };
    window.addEventListener("pointermove", handleMove);
    window.addEventListener("pointerup", stopResize);
    window.addEventListener("touchmove", handleMove);
    window.addEventListener("touchend", stopResize);
    return () => {
      window.removeEventListener("pointermove", handleMove);
      window.removeEventListener("pointerup", stopResize);
      window.removeEventListener("touchmove", handleMove);
      window.removeEventListener("touchend", stopResize);
    };
  }, []);

  // Resize for chat composer (kéo thả thay đổi chiều cao khung nhập)
  useEffect(() => {
    const MIN_HEIGHT = 72;
    const handleMove = (e) => {
      if (!composerResizingRef.current) return;
      const clientY = e.clientY ?? (e.touches && e.touches[0]?.clientY);
      if (clientY == null) return;
      const rect = composerContainerRef.current?.getBoundingClientRect();
      if (!rect) return;
      const maxHeight = Math.floor(window.innerHeight * 0.6);
      const newHeight = Math.min(
        Math.max(rect.bottom - clientY, MIN_HEIGHT),
        maxHeight,
      );
      setComposerHeight(newHeight);
    };
    const stopResize = () => {
      composerResizingRef.current = false;
    };
    window.addEventListener("pointermove", handleMove);
    window.addEventListener("pointerup", stopResize);
    window.addEventListener("touchmove", handleMove);
    window.addEventListener("touchend", stopResize);
    return () => {
      window.removeEventListener("pointermove", handleMove);
      window.removeEventListener("pointerup", stopResize);
      window.removeEventListener("touchmove", handleMove);
      window.removeEventListener("touchend", stopResize);
    };
  }, []);

  // Global keyboard shortcut: Cmd/Ctrl+K to open search modal
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setIsSearchModalOpen(true);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  // Cmd/Ctrl+Shift+X to toggle advanced rich-text composer
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (
        (e.metaKey || e.ctrlKey) &&
        e.shiftKey &&
        e.key.toLowerCase() === "x"
      ) {
        e.preventDefault();
        setIsAdvancedCompose((prev) => {
          const next = !prev;
          if (next) setMessageHtml((cur) => cur || plainToHtml(message));
          else
            setMessage((cur) => {
              const extracted = stripHtml(messageHtml);
              return extracted || cur;
            });
          return next;
        });
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [message, messageHtml]);

  // Ctrl/Cmd+F to toggle in-chat search (when a chat is selected)
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "f") {
        if (!selectedChat) return;
        e.preventDefault();
        setChatSearchOpen((v) => !v);
      } else if (e.key === "Escape" && chatSearchOpen) {
        setChatSearchOpen(false);
        setChatSearchQuery("");
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedChat, chatSearchOpen]);

  // Tick every 30s so SLA "KH chờ Xp" indicators stay fresh
  const [, setNowTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setNowTick((t) => t + 1), 30000);
    return () => clearInterval(id);
  }, []);

  // Derived values for header data
  const countUnreadMessage = unreadMessageTotal;
  const countRequesting =
    contacts?.filter((c) => !c.isGroup && c.isRequested)?.length ?? 0;
  const countStranger =
    contacts?.filter(
      (c) => !c.isGroup && !c.isFriend && !c.isRequesting && !c.isRequested,
    )?.length ?? 0;

  const showPermissionButton =
    user?.role?.includes("super_admin") ||
    user?.role?.includes("admin") ||
    user?.shopRoles
      ?.find((sr) => sr.shopId === selectedShop?._id)
      ?.role?.includes("admin");

  const showStagesManagerButton =
    user?.role?.includes("super_admin") ||
    user?.role?.includes("admin") ||
    user?.shopRoles
      ?.find((sr) => sr.shopId === selectedShop?._id)
      ?.role?.includes("admin");

  // Register header data with context so TopNavBar renders the horizontal menu
  useEffect(() => {
    setHeaderData({
      activeTab,
      setActiveTab,
      countUnreadMessage,
      role: filterRole,
      onRoleChange: handleRoleChange,
      activePresetId,
      onApplyPreset: handleApplyPreset,
      shopId: selectedShop?._id,
      staffId: auth.user?._id,
      accountId: auth.user?.accountId,
      pipelineStages,
      currentFilterSnapshot: {
        categories: selectedCategories,
        tagIds: selectedTags,
        tagZaloIds: selectedTagZalos,
        staffIds: selectedStaffs,
        pipelineStageIds: selectedPipelineStageIds,
        needsReplyMinutes,
        newCustomerDays,
        hasContactInfo,
        upcomingBirthdayDays,
        sortMode,
      },
      onApplyView: (view) => {
        const f = view.filterJson || {};
        setActivePresetId(null);
        setSelectedCategories(f.categories || []);
        setSelectedTags(f.tagIds || []);
        setSelectedTagZalos(f.tagZaloIds || []);
        setSelectedStaffs(f.staffIds || []);
        setSelectedPipelineStageIds(f.pipelineStageIds || []);
        setNeedsReplyMinutes(f.needsReplyMinutes ?? null);
        setNewCustomerDays(f.newCustomerDays ?? null);
        setHasContactInfo(f.hasContactInfo ?? null);
        setUpcomingBirthdayDays(f.upcomingBirthdayDays ?? null);
        if (view.sortMode) setSortMode(view.sortMode);
      },
      onOpenStagesManager: () => setIsStagesManagerOpen(true),
      showStagesManagerButton,
      tags,
      tagZalos,
      managers: staffs,
      selectedTags,
      selectedTagZalos,
      selectedManagers: selectedStaffs,
      selectedCategories,
      selectedPipelineStageIds,
      needsReplyMinutes,
      newCustomerDays,
      hasContactInfo,
      upcomingBirthdayDays,
      onPipelineStagesChange: (v) => {
        setSelectedPipelineStageIds(v);
        setActivePresetId(null);
      },
      onNeedsReplyMinutesChange: (v) => {
        setNeedsReplyMinutes(v);
        setActivePresetId(null);
      },
      onNewCustomerDaysChange: (v) => {
        setNewCustomerDays(v);
        setActivePresetId(null);
      },
      onHasContactInfoChange: (v) => {
        setHasContactInfo(v);
        setActivePresetId(null);
      },
      onUpcomingBirthdayDaysChange: (v) => {
        setUpcomingBirthdayDays(v);
        setActivePresetId(null);
      },
      onTagsChange: (v) => {
        setSelectedTags(v);
        setActivePresetId(null);
      },
      onTagZalosChange: (v) => {
        setSelectedTagZalos(v);
        setActivePresetId(null);
      },
      onManagersChange: (v) => {
        setSelectedStaffs(v);
        setActivePresetId(null);
      },
      onCategoriesChange: (v) => {
        setSelectedCategories(v);
        setActivePresetId(null);
      },
      sortMode,
      onSortModeChange: handleSortModeChange,
      shops: shops.data,
      shopGroups: shopGroupsList,
      activeGroup: activeShopGroup,
      currentUser: selectedShop,
      selectedShopIds:
        multiShopIds.length > 0
          ? multiShopIds
          : isGroupMode
            ? groupShops.map((s) => s._id)
            : selectedShop?._id
              ? [selectedShop._id]
              : [],
      changeShop: (s) => {
        if (
          selectedShop?._id !== s?._id ||
          activeShopGroup ||
          multiShopIds.length > 0
        ) {
          window.location.href = `/chat/${s._id}`;
        }
      },
      onApplyMultiSelect: (ids) => {
        if (!ids || ids.length === 0) return;
        window.location.href = `/chat/multi/${ids.join(",")}`;
      },
      onChangeGroup: (group) => {
        window.location.href = `/chat/group/${group._id}`;
      },
      onManageStaffClick: () => {
        toggleMenu("account");
        handleManageStaffClick();
      },
      onLogoutClick: handleLogoutClick,
      onClickPermission: () => setIsOpenPermissionModal(true),
      onClickSetting: () => setIsOpenSettingModal(true),
      onClickHiddenConversations: () =>
        setIsHiddenConversationsModalOpen(true),
      showManageStaffButton,
      showPermissionButton,
    });

    return () => {
      clearHeaderData();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activeTab,
    countUnreadMessage,
    filterRole,
    activePresetId,
    pipelineStages,
    tags,
    tagZalos,
    staffs,
    selectedTags,
    selectedTagZalos,
    selectedStaffs,
    selectedPipelineStageIds,
    needsReplyMinutes,
    selectedCategories,
    sortMode,
    shops.data,
    shopGroupsList,
    activeShopGroup,
    selectedShop,
    isGroupMode,
    groupShops,
    multiShopIds,
    showManageStaffButton,
    showPermissionButton,
  ]);

  // Load pipeline stages once user account is known.
  useEffect(() => {
    if (!auth?.user?.accountId) return;
    let cancelled = false;
    pipelineStageApi
      .getByAccountId(auth.user.accountId)
      .then((res) => {
        if (cancelled) return;
        if (res?.status === 1) setPipelineStages(res.data || []);
      })
      .catch((err) => console.error("load pipeline stages failed:", err));
    return () => {
      cancelled = true;
    };
  }, [auth?.user?.accountId]);

  return (
    <>
      <div className="flex flex-1 overflow-hidden relative">
        <main className="flex-1 flex bg-white text-gray-800">
          {(!isMobile ||
            (mobileShowing === "contacts" && !openMenus.sidebarInfo)) && (
            <section
              className={cn(
                "overflow-y-auto relative flex-shrink-0",
                isMobile
                  ? isSidebarOpen
                    ? "w-[85vw]"
                    : "w-full"
                  : "border-r border-gray-200",
              )}
              style={{ width: isMobile ? undefined : contactListWidth }}
              ref={contactListRef}
            >
              {!isMobile && (
                <div
                  className="absolute right-0 top-0 bottom-0 w-1 cursor-ew-resize hover:bg-blue-300 z-20"
                  onPointerDown={() => {
                    contactListResizingRef.current = true;
                  }}
                  onTouchStart={() => {
                    contactListResizingRef.current = true;
                  }}
                  title="Kéo để thay đổi độ rộng"
                />
              )}
              <div className="sticky top-0 bg-white z-10">
                {/* Conversation type pills - Tất cả / Cá nhân / Group */}
                <div className="flex items-center gap-1.5 px-2 py-1.5 bg-white border-b border-gray-100">
                  {[
                    { value: "all", label: "Tất cả" },
                    { value: "personal", label: "Cá nhân" },
                    { value: "group", label: "Group" },
                  ].map((opt) => (
                    <button
                      key={opt.value}
                      type="button"
                      onClick={() => setConversationType(opt.value)}
                      className={cn(
                        "h-7 px-3 rounded-full border text-[12px] font-medium transition-colors",
                        conversationType === opt.value
                          ? "bg-primary text-white border-primary"
                          : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50",
                      )}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
                <div className="flex items-center gap-1 md:gap-1.5 px-2 py-1.5 bg-white border-b border-gray-100">
                  <Button
                    variant="outline"
                    size="sm"
                    className={cn(
                      "rounded-full flex-shrink-0 text-[12px] border-gray-200 text-gray-600",
                      isMobile ? "touch-target-large w-10 p-0" : "flex-1 h-8",
                    )}
                    onClick={() => setIsSearchModalOpen(true)}
                  >
                    <Search size={14} className={cn(!isMobile && "mr-1.5")} />
                    {!isMobile && "Tìm kiếm"}
                  </Button>

                  <Button
                    variant="ghost"
                    size="icon"
                    className="rounded-full h-8 w-8 touch-target-large"
                    onClick={() => setIsOpenSearchModal(true)}
                    title="Thêm bạn"
                  >
                    <UserPlus size={16} />
                    <span className="sr-only">Thêm bạn</span>
                  </Button>

                  <Button
                    variant="ghost"
                    size="icon"
                    className="rounded-full h-8 w-8 touch-target-large"
                    onClick={() => setIsOpenCreateGroupModal(true)}
                    title="Tạo nhóm"
                  >
                    <Users size={16} />
                    <span className="sr-only">Tạo nhóm</span>
                  </Button>
                </div>
                {/* Tabs row - like Zalo */}
                <div className="flex items-center px-3 py-0.5 border-b border-gray-100 gap-4">
                  <button
                    className={cn(
                      "text-[12px] font-medium py-1 border-b-2 transition-colors",
                      conversationTab === "all"
                        ? "border-primary text-primary"
                        : "border-transparent text-gray-500 hover:text-gray-700",
                    )}
                    onClick={() => setConversationTab("all")}
                  >
                    Tất cả
                  </button>
                  <button
                    className={cn(
                      "text-[12px] font-medium py-1 border-b-2 transition-colors inline-flex items-center gap-1.5",
                      conversationTab === "unread"
                        ? "border-primary text-primary"
                        : "border-transparent text-gray-500 hover:text-gray-700",
                    )}
                    onClick={() => setConversationTab("unread")}
                  >
                    Chưa đọc
                    {countUnreadMessage > 0 && (
                      <span className="inline-flex items-center justify-center min-w-[16px] h-[16px] px-1 text-[10px] font-semibold text-white bg-red-500 rounded-full">
                        {countUnreadMessage > 99 ? "99+" : countUnreadMessage}
                      </span>
                    )}
                  </button>
                </div>
              </div>
              <ul className="divide-y divide-gray-100">
                {contacts
                  .filter(
                    (x) =>
                      user?.role?.includes("admin") ||
                      user?._id === selectedShop?.staffId ||
                      user?.shopRoles
                        ?.find((sr) => sr.shopId === selectedShop?._id)
                        ?.role?.includes("admin") ||
                      !user?.shopRoles
                        ?.find((sr) => sr.shopId === selectedShop?._id)
                        ?.permissions?.includes("view_only_own_contact") ||
                      x.staffIds.length === 0 ||
                      x.staffIds.includes(auth?.user?._id) ||
                      x.staffIds.some((staffId) =>
                        user?.shopRoles
                          ?.find((sr) => sr.shopId === selectedShop?._id)
                          ?.viewMoreStaffIds?.includes(staffId),
                      ),
                  )
                  .filter(
                    (x) =>
                      user?.role?.includes("admin") ||
                      user?._id === selectedShop?.staffId ||
                      user?.shopRoles
                        ?.find((sr) => sr.shopId === selectedShop?._id)
                        ?.role?.includes("admin") ||
                      !user?.shopRoles
                        ?.find((sr) => sr.shopId === selectedShop?._id)
                        ?.permissions?.includes(
                          "not_view_contact_no_one_manage",
                        ) ||
                      x.staffIds.length > 0,
                  )
                  .filter(
                    (x) =>
                      (searchText.trim() &&
                        x.name
                          .toLowerCase()
                          .includes(searchText.toLowerCase())) ||
                      (!searchText.trim() &&
                        (x.isGroup || x.isFriend || x.messages.length > 0)),
                  )
                  // Filter by conversation tab (Tất cả / Chưa đọc)
                  .filter(
                    (x) =>
                      conversationTab === "all" ||
                      (conversationTab === "unread" && shouldShowUnread(x)),
                  )
                  // Filter by conversation type (Tất cả / Cá nhân / Group)
                  .filter(
                    (x) =>
                      conversationType === "all" ||
                      (conversationType === "personal" && !x.isGroup) ||
                      (conversationType === "group" && x.isGroup),
                  )
                  .filter((x) => {
                    // Birthday check helper - check sdob field (format: dd/MM/yyyy)
                    const isBirthdayToday = () => {
                      if (!x.sdob) return false;
                      const today = new Date();
                      const todayDayMonth = `${String(today.getDate()).padStart(2, "0")}/${String(today.getMonth() + 1).padStart(2, "0")}`;
                      return x.sdob.startsWith(todayDayMonth);
                    };

                    return (
                      (selectedCategories.length === 0 ||
                        (selectedCategories.includes("unread") &&
                          shouldShowUnread(x)) ||
                        (selectedCategories.includes("friends") &&
                          x.isFriend) ||
                        (selectedCategories.includes("stranger") &&
                          !x.isFriend &&
                          !x.isGroup) ||
                        (selectedCategories.includes("groups") && x.isGroup) ||
                        (selectedCategories.includes("requesting") &&
                          !x.isGroup &&
                          !x.isFriend &&
                          x.isRequesting) ||
                        (selectedCategories.includes("birthday") &&
                          isBirthdayToday())) &&
                      // Tag/TagZalo/Manager/Pipeline filters đã chạy server-side
                      // qua shopApi.getContacts(filters), không cần filter lại ở client.
                      true
                    );
                  })
                  .sort((a, b) => {
                    // 1. Ưu tiên Pinned
                    if (a.isPinned && !b.isPinned) return 1;
                    if (!a.isPinned && b.isPinned) return -1;

                    // 2. Nếu cả 2 cùng Pinned, so sánh pinnedAt
                    if (a.isPinned && b.isPinned) {
                      const pinTimeA = a.pinnedAt
                        ? new Date(a.pinnedAt).getTime()
                        : 0;
                      const pinTimeB = b.pinnedAt
                        ? new Date(b.pinnedAt).getTime()
                        : 0;
                      if (pinTimeA !== pinTimeB) return pinTimeA - pinTimeB;
                    }

                    // 3. Nếu sortMode là unread_first, ưu tiên chưa đọc
                    // Note: return 1 để đưa lên đầu vì có .reverse() ở cuối
                    if (sortMode === "unread_first") {
                      const aUnread = shouldShowUnread(a);
                      const bUnread = shouldShowUnread(b);
                      if (aUnread && !bUnread) return 1;
                      if (!aUnread && bUnread) return -1;
                    }

                    // 4. So sánh dateAction
                    const dateA = a.messages?.[a.messages.length - 1]
                      ?.dateAction
                      ? new Date(a.messages[a.messages.length - 1].dateAction)
                      : new Date(0);
                    const dateB = b.messages?.[b.messages.length - 1]
                      ?.dateAction
                      ? new Date(b.messages[b.messages.length - 1].dateAction)
                      : new Date(0);

                    return dateA.getTime() === dateB.getTime()
                      ? b.name.localeCompare(a.name)
                      : dateA.getTime() - dateB.getTime();
                  })
                  .reverse()
                  .map((contact) => {
                    // Determine which tag lists to use
                    // In group mode, use aggregated groupTags/groupTagZalos and filter by shopId
                    // In single mode, use standard tags/tagZalos (which are already shop-specific)
                    const currentTags = isGroupModeRef.current
                      ? groupTags.filter((t) => t._shopId === contact._shopId)
                      : tags;
                    const currentTagZalos = isGroupModeRef.current
                      ? groupTagZalos.filter(
                          (t) => t._shopId === contact._shopId,
                        )
                      : tagZalos;

                    const pipelineStage = contact.pipelineStageId
                      ? pipelineStages.find(
                          (s) =>
                            (s._id || s.id) === contact.pipelineStageId,
                        )
                      : null;
                    return {
                      ...contact,
                      displayTags: [
                        pipelineStage && {
                          name: "▶ " + pipelineStage.name,
                          color: pipelineStage.color || "#6b7280",
                        },
                        currentTagZalos.find((t) =>
                          t.conversations?.includes(contact.uid),
                        ) && {
                          name:
                            "z: " +
                            currentTagZalos.find((t) =>
                              t.conversations?.includes(contact.uid),
                            ).text,
                          color: currentTagZalos.find((t) =>
                            t.conversations?.includes(contact.uid),
                          ).color,
                        },
                        !contact.isFriend &&
                          !contact.isGroup && {
                            name: contact.isRequested
                              ? "Đã gửi KB"
                              : contact.isRequesting
                                ? "Chờ KB"
                                : "Người lạ",
                            color: "#FF0000",
                          },
                      ]
                        .filter(Boolean)
                        .concat(
                          currentTags.filter(
                            (t) =>
                              contact.tagIds?.includes(t._id) && t.isActive,
                          ),
                        ),
                    };
                  })
                  .map((contact, i) => {
                    const assignedStaffs = contact.staffIds?.length > 0
                      ? contact.staffIds
                          .map((sid) => staffs.find((s) => s._id === sid))
                          .filter(Boolean)
                      : [];
                    const assignedStaff = assignedStaffs[0] || null;
                    const isAdminViewForContact = isOwnerOrAdmin();
                    const rawUnreadCount = getContactUnreadMessageCount(
                      contact,
                      {
                        staffId: auth.user._id,
                        isAdminView: isAdminViewForContact,
                      },
                    );
                    const rawHasUnread = shouldShowUnread(contact);
                    const isRecentlyReadByUser =
                      wasRecentlyMarkedAsRead(contact);
                    // Suppress unread display if user just clicked to read,
                    // even if peer staff still have non-zero counts.
                    const maxUnreadCount = isRecentlyReadByUser
                      ? 0
                      : rawUnreadCount;
                    const isUnread =
                      !isRecentlyReadByUser &&
                      rawHasUnread &&
                      contact?._id !== selectedChat?._id;
                    const lastMsg = contact.messages?.[contact.messages.length - 1];
                    const previewText = !lastMsg
                      ? "Chưa có tin nhắn"
                      : lastMsg.isUndo
                        ? "Tin nhắn đã được thu hồi"
                        : ["text", "file", "sticker", "event"].includes(lastMsg.type)
                          ? lastMsg.content
                          : lastMsg.type === "video"
                            ? "Video"
                            : "Hình ảnh";

                    // SLA: nếu tin cuối của khách (uidFrom !== "0") và chưa trả lời quá lâu → cảnh báo
                    const waitMinItem =
                      lastMsg && lastMsg.uidFrom && lastMsg.uidFrom !== "0"
                        ? Math.floor(
                            (Date.now() -
                              new Date(lastMsg.dateAction).getTime()) /
                              60000,
                          )
                        : null;
                    const slaAccent =
                      waitMinItem !== null && waitMinItem >= 30
                        ? "before:bg-red-500"
                        : waitMinItem !== null && waitMinItem >= 10
                          ? "before:bg-amber-400"
                          : "before:bg-transparent";

                    return (
                    <li
                      key={i}
                      className={`flex items-start gap-2.5 px-3 py-2 cursor-pointer transition-colors relative group before:content-[''] before:absolute before:left-0 before:top-0 before:bottom-0 before:w-[3px] ${slaAccent} ${
                        selectedChat?._id === contact?._id
                          ? "bg-indigo-50"
                          : isUnread
                            ? "bg-amber-50 hover:bg-amber-100/70"
                            : "hover:bg-gray-50"
                      }`}
                      onClick={() => handleContactClick(contact)}
                      onContextMenu={(e) => handleContextMenu(e, contact)}
                    >
                      <div className="flex items-center justify-center pt-0.5">
                        <div className="relative">
                          <div className="w-10 h-10 bg-gradient-to-br from-pink-500 to-purple-500 rounded-full flex-shrink-0 overflow-hidden">
                            <img
                              src={
                                contact.isGroup && !contact.avatar
                                  ? "https://w7.pngwing.com/pngs/924/119/png-transparent-basic-group-team-people-avatar-profile-face-office-icon.png"
                                  : contact.avatar
                              }
                              alt=""
                              className="w-full h-full object-cover"
                            />
                          </div>
                          {/* Shop badge when viewing 2+ shops (saved group or ad-hoc multi) */}
                          {groupShops.length > 1 && contact._shopId && (
                            <div
                              className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full border-2 border-white overflow-hidden bg-gradient-to-br from-blue-400 to-indigo-500"
                              title={contact._shopName || "Shop"}
                            >
                              {contact._shopAvatar ? (
                                <img
                                  src={contact._shopAvatar}
                                  alt={contact._shopName}
                                  className="w-full h-full object-cover"
                                />
                              ) : (
                                <span className="w-full h-full flex items-center justify-center text-white text-[9px] font-bold">
                                  {contact._shopName?.charAt(0) || "S"}
                                </span>
                              )}
                            </div>
                          )}
                          {/* Staff badge when viewing a single shop */}
                          {groupShops.length <= 1 && assignedStaff && (
                            <>
                              <div
                                className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full border-2 border-white overflow-hidden bg-gradient-to-br from-green-400 to-blue-500 flex items-center justify-center"
                                title={
                                  assignedStaffs.length > 1
                                    ? `Phụ trách: ${assignedStaffs.map((s) => s.name).join(", ")}`
                                    : `Phụ trách: ${assignedStaff.name}`
                                }
                              >
                                {assignedStaff.avatar ? (
                                  <img
                                    src={assignedStaff.avatar}
                                    alt={assignedStaff.name}
                                    className="w-full h-full object-cover"
                                  />
                                ) : (
                                  <span className="text-white text-[9px] font-semibold leading-none">
                                    {assignedStaff.name
                                      ?.split(" ")
                                      .map((w) => w[0])
                                      .slice(-2)
                                      .join("")}
                                  </span>
                                )}
                              </div>
                              {assignedStaffs.length > 1 && (
                                <div
                                  className="absolute -top-1 -right-1 min-w-[14px] h-[14px] px-0.5 rounded-full bg-blue-600 border border-white text-white text-[9px] font-bold flex items-center justify-center leading-none"
                                  title={assignedStaffs.map((s) => s.name).join(", ")}
                                >
                                  +{assignedStaffs.length - 1}
                                </div>
                              )}
                            </>
                          )}
                          {/* Pin Icon - Top Left of Avatar */}
                          {contact.isPinned && (
                            <div className="absolute -top-1 -left-1 bg-white rounded-full p-[2px] shadow-sm z-10 border border-gray-100">
                              <Pin className="w-2.5 h-2.5 text-blue-600 fill-current" />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex-1 min-w-0">
                        {/* Row 1: Name + Time */}
                        <div className="flex items-center justify-between gap-2">
                          <p
                            className={`${
                              isUnread
                                ? "font-bold text-gray-900"
                                : "font-medium text-gray-800"
                            } text-[13px] truncate`}
                          >
                            {contact.name}
                          </p>
                          <p
                            className={`${
                              isUnread
                                ? "font-semibold text-gray-700"
                                : "text-gray-400"
                            } text-[11px] flex-shrink-0 whitespace-nowrap`}
                          >
                            {lastMsg
                              ? common.getRelativeTimeContact(lastMsg.dateAction)
                              : ""}
                          </p>
                        </div>
                        {/* Row 2: Message preview + Unread badge */}
                        <div className="flex items-center gap-1 mt-0.5">
                          <p
                            className={`${
                              isUnread
                                ? "font-medium text-gray-700"
                                : "text-gray-500"
                            } text-[12px] truncate flex-1 min-w-0`}
                          >
                            {previewText}
                          </p>
                          {maxUnreadCount > 0 &&
                            contact?._id !== selectedChat?._id && (
                              <span className="min-w-[18px] h-[18px] px-1 bg-red-500 text-white text-[10px] font-semibold rounded-full flex items-center justify-center flex-shrink-0">
                                {maxUnreadCount > 99
                                  ? "99+"
                                  : maxUnreadCount}
                              </span>
                            )}
                        </div>
                        {/* Row 3: Shop + Assignee */}
                        {(groupShops.length > 1 && contact._shopName) || assignedStaffs.length > 0 ? (
                          <div className="flex items-center gap-2 mt-0.5 text-[11px] text-gray-500 min-w-0">
                            {groupShops.length > 1 && contact._shopName && (
                              <span className="inline-flex items-center gap-1 min-w-0 max-w-[50%]">
                                <Store className="w-3 h-3 flex-shrink-0" />
                                <span className="truncate">
                                  {contact._shopName}
                                </span>
                              </span>
                            )}
                            {assignedStaffs.length > 0 && (
                              <span
                                className="inline-flex items-center gap-1 min-w-0 max-w-[60%] text-blue-600"
                                title={assignedStaffs.map((s) => s.name).join(", ")}
                              >
                                <User className="w-3 h-3 flex-shrink-0" />
                                <span className="truncate">
                                  {assignedStaffs.map((s) => s.name).join(", ")}
                                </span>
                              </span>
                            )}
                          </div>
                        ) : null}
                        {/* Row 4: Tags wrap (max 2 lines) */}
                        {contact.displayTags?.length > 0 && (
                          <TagList
                            tags={contact.displayTags}
                            maxLines={2}
                          />
                        )}
                      </div>
                    </li>
                  );})}
                {hasMoreContacts && !loadMoreContactsError && (
                  <li
                    ref={sentinelRef}
                    className="py-3 flex items-center justify-center text-[12px] text-gray-400"
                    aria-hidden="true"
                  >
                    {isLoadingMoreContacts ? (
                      <span className="flex items-center gap-2">
                        <span className="inline-block w-3 h-3 border-2 border-gray-300 border-t-gray-500 rounded-full animate-spin" />
                        Đang tải thêm...
                      </span>
                    ) : (
                      <span className="opacity-0">.</span>
                    )}
                  </li>
                )}
                {loadMoreContactsError && (
                  <li className="py-3 flex items-center justify-center text-[12px]">
                    <button
                      type="button"
                      onClick={() => {
                        setLoadMoreContactsError(false);
                        isLoadingMoreContactsRef.current = false;
                        setContactPage((p) => p);
                        triggerLoadMoreContacts();
                      }}
                      className="text-red-500 hover:text-red-600 underline"
                    >
                      Lỗi tải contact. Nhấn để thử lại
                    </button>
                  </li>
                )}
              </ul>
            </section>
          )}
          {(!isMobile ||
            (mobileShowing === "chat" && !openMenus.sidebarInfo)) && (
            <section className="flex-1 flex flex-col">
              {selectedChat ? (
                <>
                  {(() => {
                    const lastM =
                      selectedChat.messages?.[selectedChat.messages.length - 1];
                    const isCustomerLast = lastM && lastM.uidFrom !== "0";
                    const waitMin = isCustomerLast
                      ? Math.floor(
                          (Date.now() -
                            new Date(lastM.dateAction).getTime()) /
                            60000,
                        )
                      : null;
                    const showSla = waitMin !== null && waitMin >= 10;
                    // Online status — chỉ hiện cho contact 1-1 (không phải group)
                    // và khi lastOnline khớp uid hiện tại (tránh hiển thị sai khi đổi contact nhanh)
                    let onlineInfo = null;
                    if (
                      !selectedChat.isGroup &&
                      selectedChatOnline?.uid === selectedChat.uid &&
                      selectedChatOnline.lastOnline > 0
                    ) {
                      const diffMs =
                        Date.now() - selectedChatOnline.lastOnline;
                      const minutes = Math.floor(diffMs / 60000);
                      if (minutes < 5) {
                        onlineInfo = {
                          isOnline: true,
                          text: "Đang hoạt động",
                        };
                      } else if (minutes < 60) {
                        onlineInfo = {
                          isOnline: false,
                          text: `Hoạt động ${minutes}p trước`,
                        };
                      } else {
                        const hours = Math.floor(minutes / 60);
                        if (hours < 24) {
                          onlineInfo = {
                            isOnline: false,
                            text: `Hoạt động ${hours}h trước`,
                          };
                        } else {
                          const days = Math.floor(hours / 24);
                          onlineInfo = {
                            isOnline: false,
                            text: `Hoạt động ${days}d trước`,
                          };
                        }
                      }
                    }
                    const activeRealtimeShopId =
                      selectedChat._shopId ||
                      selectedChat.shopId ||
                      activeContactShop?._id ||
                      selectedShop?._id;
                    const visibleRealtimeStatus =
                      realtimeConnectionStatus?.state !== "idle" &&
                      (!realtimeConnectionStatus.shopId ||
                        !activeRealtimeShopId ||
                        realtimeConnectionStatus.shopId ===
                          activeRealtimeShopId);
                    return (
                  <div className="flex items-center justify-between gap-2 px-3 py-1.5 border-b border-gray-100 bg-white top-0">
                    <div className="flex items-center gap-2.5 min-w-0 flex-1">
                      {isMobile && (
                        <ChevronLeft
                          className="w-5 h-5 cursor-pointer hover:text-blue-500 shrink-0"
                          onClick={() => setMobileShowing("contacts")}
                        />
                      )}
                      <div className="relative shrink-0">
                        <div className="w-9 h-9 bg-gradient-to-br from-green-400 to-blue-500 rounded-full flex items-center justify-center overflow-hidden">
                          <img
                            src={
                              selectedChat.isGroup
                                ? selectedChat.avatar
                                  ? selectedChat.avatar
                                  : "https://w7.pngwing.com/pngs/924/119/png-transparent-basic-group-team-people-avatar-profile-face-office-icon.png"
                                : selectedChat.avatar
                            }
                            alt=""
                            className="w-full h-full object-cover"
                          />
                        </div>
                        {onlineInfo?.isOnline && (
                          <span
                            className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-500 rounded-full border-2 border-white"
                            title="Đang hoạt động"
                          />
                        )}
                      </div>
                      <div className="min-w-0 flex-1">
                        {isEditingName ? (
                          <div className="flex">
                            <input
                              type="text"
                              autoFocus
                              placeholder={selectedChat?.zaloName}
                              value={selectedChatName}
                              onChange={(e) =>
                                setSelectedChatName(e.target.value.slice(0, 50))
                              }
                              onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault(); // Ngăn việc xuống dòng tự động
                                  handleEditName();
                                }
                              }}
                              className="font-bold text-gray-800 bg-transparent border-b border-gray-300 focus:outline-none focus:border-blue-500"
                            />
                            <button
                              onClick={handleEditName}
                              title="Lưu"
                              disabled={isRenaming}
                              className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none"
                            >
                              {isRenaming ? (
                                <LoaderCircle
                                  className="animate-spin"
                                  size={16}
                                />
                              ) : (
                                <Check size={16} />
                              )}
                            </button>
                            <button
                              onClick={() => {
                                setIsEditingName(false);
                                setSelectedChatName(selectedChat?.name);
                              }}
                              title="Huỷ"
                              className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none"
                            >
                              <X size={16} />
                            </button>
                          </div>
                        ) : (
                          <div className="flex items-center">
                            <p className="text-[14px] font-semibold text-gray-800 truncate">
                              {selectedChatName}
                            </p>
                            {!selectedChat?.isGroup && (
                              <button
                                onClick={() => {
                                  setIsEditingName(true);
                                }}
                                title="Sửa tên"
                                className="ml-1.5 text-gray-400 hover:text-gray-700 focus:outline-none"
                              >
                                <Pen size={13} />
                              </button>
                            )}
                            {onlineInfo && (
                              <span
                                className={`ml-2 inline-flex items-center gap-1 text-[11px] whitespace-nowrap ${
                                  onlineInfo.isOnline
                                    ? "text-green-600"
                                    : "text-gray-500"
                                }`}
                              >
                                {onlineInfo.isOnline && (
                                  <span className="w-1.5 h-1.5 rounded-full bg-green-500" />
                                )}
                                {onlineInfo.text}
                              </span>
                            )}
                            {showSla && (
                              <span
                                className={`ml-2 inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold whitespace-nowrap ${
                                  waitMin >= 30
                                    ? "bg-red-100 text-red-700"
                                    : "bg-amber-100 text-amber-700"
                                }`}
                                title={`Khách đã chờ ${waitMin} phút chưa được phản hồi`}
                              >
                                ⏱ Khách chờ {waitMin}p
                              </span>
                            )}
                            {visibleRealtimeStatus && (
                              <span
                                className={cn(
                                  "ml-2 inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold whitespace-nowrap",
                                  realtimeConnectionStatus.state === "failed"
                                    ? "bg-red-100 text-red-700"
                                    : "bg-amber-100 text-amber-700",
                                )}
                                title={
                                  realtimeConnectionStatus.message ||
                                  realtimeConnectionStatus.shopName ||
                                  "Realtime đang kết nối lại"
                                }
                              >
                                <span
                                  className={cn(
                                    "w-1.5 h-1.5 rounded-full",
                                    realtimeConnectionStatus.state === "failed"
                                      ? "bg-red-500"
                                      : "bg-amber-500",
                                  )}
                                />
                                {realtimeConnectionStatus.state === "failed"
                                  ? "Realtime lỗi"
                                  : "Đang nối realtime"}
                              </span>
                            )}
                          </div>
                        )}
                        <div className="flex items-center">
                          <p className="text-[11px] text-gray-500 mr-1">
                            {selectedChat.isGroup &&
                              (selectedChat.groupMemberIds?.length ?? 0) +
                                " thành viên |"}
                          </p>
                          <TagZaloPicker
                            tagZalos={tagZalos}
                            currentUid={selectedChat?.uid}
                            onAddTag={(tag) => {
                              const prev = tagZalos.find((t) =>
                                t.conversations?.includes(selectedChat.uid),
                              );
                              const payload = [
                                {
                                  _id: tag._id,
                                  conversations: [
                                    ...(tag.conversations || []),
                                    selectedChat.uid,
                                  ],
                                },
                              ];
                              if (prev && prev._id !== tag._id) {
                                payload.push({
                                  _id: prev._id,
                                  conversations: prev.conversations.filter(
                                    (c) => c !== selectedChat.uid,
                                  ),
                                });
                              }
                              shopApi
                                .updateTagZalos(getActualShop()._id, payload, {
                                  tagAction: "add_tag_zalo",
                                  tagName: tag.text,
                                  uid: selectedChat.uid,
                                })
                                .then((res) => {
                                  getTagZalos(getActualShop()._id);
                                  addNotification(
                                    res.status === 1
                                      ? "Gắn tag thành công"
                                      : res.message,
                                    res.status,
                                  );
                                });
                            }}
                            onRemoveTag={(tag) => {
                              shopApi
                                .updateTagZalos(
                                  getActualShop()._id,
                                  [
                                    {
                                      _id: tag._id,
                                      conversations: (
                                        tag.conversations || []
                                      ).filter((c) => c !== selectedChat.uid),
                                    },
                                  ],
                                  {
                                    tagAction: "remove_tag_zalo",
                                    tagName: tag.text,
                                    uid: selectedChat.uid,
                                  },
                                )
                                .then((res) => {
                                  getTagZalos(getActualShop()._id);
                                  addNotification(
                                    res.status === 1
                                      ? "Gỡ tag thành công"
                                      : res.message,
                                    res.status,
                                  );
                                });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-0.5 shrink-0">
                      {selectedChat.staffIds?.map((sId) => (
                        <div
                          key={sId}
                          className="w-7 h-7 bg-gradient-to-br from-green-400 to-blue-500 rounded-full flex items-center justify-center overflow-hidden"
                        >
                          {staffs.find((s) => s._id === sId)?.avatar ? (
                            <img
                              src={staffs.find((s) => s._id === sId)?.avatar}
                              alt={staffs.find((s) => s._id === sId)?.name}
                              className="w-full h-full object-cover"
                              title={staffs.find((s) => s._id === sId)?.name}
                            />
                          ) : (
                            <div
                              className="w-full h-full object-cover flex items-center justify-center cursor-default text-[10px] text-white font-semibold"
                              title={staffs.find((s) => s._id === sId)?.name}
                            >
                              {staffs
                                .find((s) => s._id === sId)
                                ?.name.split(" ")
                                .map((w) => w[0])
                                .slice(0, 2)}
                            </div>
                          )}
                        </div>
                      ))}
                      <StaffAssignmentPopover
                        user={user}
                        selectedShop={selectedShop}
                        selectedChat={selectedChat}
                        staffs={staffs}
                        onAssignStaffClick={handleChangeStaffManageClick}
                      />
                      {/* Pinned Messages Toggle Button */}
                      {pinnedMessages.length > 0 && (
                        <button
                          className={`p-1.5 rounded-full transition-colors relative ${
                            showPinnedPanel
                              ? "bg-blue-100"
                              : "hover:bg-secondary"
                          }`}
                          onClick={() => setShowPinnedPanel(!showPinnedPanel)}
                          title={`${pinnedMessages.length} tin nhắn đã ghim`}
                        >
                          <Pin size={16} className="text-blue-600" />
                          <span className="absolute -top-0.5 -right-0.5 bg-blue-600 text-white text-[9px] rounded-full w-3.5 h-3.5 flex items-center justify-center">
                            {pinnedMessages.length}
                          </span>
                        </button>
                      )}
                      <button
                        className={`p-1.5 rounded-full transition-colors ${
                          openMenus.sidebarInfo
                            ? "bg-secondary"
                            : "hover:bg-secondary"
                        }`}
                        onClick={() => toggleMenu("sidebarInfo")}
                        title="Thông tin hội thoại"
                      >
                        <Info size={16} className="text-gray-600" />
                      </button>
                    </div>
                  </div>
                    );
                  })()}
                  {!selectedChat.isFriend && !selectedChat.isGroup && (
                    <div
                      className={`flex items-center ${
                        selectedChat.isRequested
                          ? "justify-start"
                          : "justify-end"
                      } space-x-3 px-4 py-1 border-b border-gray-200 bg-white top-10`}
                    >
                      {selectedChat.isRequested ? (
                        <p>Đã gửi lời mời kết bạn</p>
                      ) : (
                        <button
                          className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-1 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                          onClick={() => setIsOpenAddFriendModal(true)}
                        >
                          {selectedChat.isRequesting
                            ? "Đồng ý kết bạn"
                            : "Gửi kết bạn"}
                        </button>
                      )}
                    </div>
                  )}

                  <ChatSearchBar
                    open={chatSearchOpen}
                    query={chatSearchQuery}
                    setQuery={setChatSearchQuery}
                    onClose={() => {
                      setChatSearchOpen(false);
                      setChatSearchQuery("");
                    }}
                    messages={selectedChat?.messages}
                  />

                  {/* Pinned Messages Panel */}
                  {showPinnedPanel && pinnedMessages.length > 0 && (
                    <PinnedMessagesPanel
                      shop={getActualShop()}
                      contact={selectedChat}
                      pinnedMessages={pinnedMessages}
                      onClose={() => setShowPinnedPanel(false)}
                      onNavigateToMessage={handleNavigateToPinnedMessage}
                      onUnpin={(messageId) => {
                        setPinnedMessages((prev) =>
                          prev.filter((p) => p.messageId !== messageId),
                        );
                        setPinnedMessageIds((prev) => {
                          const newSet = new Set(prev);
                          newSet.delete(messageId);
                          return newSet;
                        });
                      }}
                      staffName={user?.name}
                    />
                  )}

                  <div
                    className="flex-1 flex flex-col-reverse p-4 overflow-y-auto relative"
                    ref={messageListRef}
                  >
                    {isLoadingQuotedMessage && (
                      <div className="absolute inset-0 bg-white/70 flex items-center justify-center z-10">
                        <div className="flex flex-col items-center gap-2">
                          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                          <span className="text-sm text-gray-600">
                            Đang tìm tin nhắn...
                          </span>
                        </div>
                      </div>
                    )}
                    <div ref={lastMessageDivRef}></div>
                    {displayMessages.map((msg, index) => (
                      <div key={msg._id || msg._timelineKey || `msg_${index}`}>
                        {msg.type === "timestamp" ? (
                          <div className="text-center text-gray-500 text-sm my-4">
                            {msg.timestamp}
                          </div>
                        ) : msg.type === "event" ? (
                          <div className="flex justify-center max-w-3/4">
                            <span className="justify-self-center bg-gray-300 text-gray-600 text-center text-sm my-2 px-4 py-1 rounded-lg break-words">
                              {renderGroupEventContent(
                                msg,
                                ({ uid, name }) => {
                                  if (!uid) {
                                    addNotification(
                                      name
                                        ? `Không tìm thấy thông tin thành viên: ${name}`
                                        : "Không tìm thấy thông tin thành viên",
                                      -1,
                                    );
                                    return;
                                  }
                                  setUserInfoUid(uid);
                                  setIsUserInfoOpen(true);
                                },
                                groupMemberNameToUid,
                              )}
                            </span>
                          </div>
                        ) : msg.type === "event_timeline" ? (
                          <div className="flex justify-center max-w-3/4">
                            <span className="justify-self-center bg-gray-100 text-gray-500 text-center text-[11px] my-1.5 px-2.5 py-0.5 rounded-full break-words">
                              {msg.content}
                            </span>
                          </div>
                        ) : (
                          <div
                            data-msg-id={msg.msgId}
                            className="group relative transition-colors duration-500"
                          >
                            <div
                              className={`flex ${
                                msg.uidFrom === "0"
                                  ? "flex-row-reverse"
                                  : "justify-start"
                              } gap-1 mb-1`}
                            >
                              <div className="flex items-start">
                                {msg.uidFrom !== "0" && (
                                  <div className="w-8 h-8 rounded-full bg-gray-300 mr-2 flex-shrink-0">
                                    <img
                                      src={
                                        msg.avatarFrom
                                          ? msg.avatarFrom
                                          : selectedChat.avatar
                                      }
                                      alt=""
                                      className="w-full h-full object-cover rounded-full"
                                    />
                                  </div>
                                )}
                                {msg.type === "text" ||
                                (msg.type === "file" && !msg.isSending) ||
                                msg.isUndo ? (
                                  <div
                                    className={`relative max-w-xs text-[13px] leading-snug ${
                                      msg.uidFrom === "0"
                                        ? "bg-blue-500 text-white"
                                        : "bg-gray-100 text-gray-800"
                                    } ${
                                      hasActiveReactions(msg.reacts)
                                        ? "mb-3"
                                        : ""
                                    } rounded-2xl px-3 py-1.5 whitespace-pre-wrap break-words min-w-12 ${
                                      msg.isUndo
                                        ? "border border-red-400 bg-opacity-80"
                                        : ""
                                    }`}
                                  >
                                    {msg.isUndo && (
                                      <p className="text-red-600 text-xs font-medium mb-1">
                                        Đã thu hồi
                                      </p>
                                    )}
                                    {msg.quote && (
                                      <div
                                        className="flex gap-2 rounded-lg bg-gray-100 p-2 mb-2 cursor-pointer hover:bg-gray-200 transition-colors"
                                        onClick={() =>
                                          scrollToQuotedMessage(msg.quote)
                                        }
                                      >
                                        <div className="border-2 border-blue-500"></div>
                                        {msg.quote.attach &&
                                          JSON.parse(msg.quote.attach)
                                            ?.oriUrl && (
                                            <img
                                              src={
                                                JSON.parse(msg.quote.attach)
                                                  ?.oriUrl
                                              }
                                              alt=""
                                              className="w-12 h-12 object-cover"
                                            />
                                          )}
                                        <div className="flex flex-col w-full">
                                          <div className="flex items-center justify-between text-gray-900 text-sm">
                                            <div className="flex items-center gap-1">
                                              <span>{msg.quote.fromD}</span>
                                            </div>
                                          </div>
                                          <span className="text-gray-600">
                                            {msg.quote.cliMsgType === 1
                                              ? msg.quote.msg
                                              : "[Hình ảnh]"}
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                    <RichText
                                      text={msg.content}
                                      styles={msg.styles}
                                      isFile={msg.type === "file"}
                                      file={msg.file}
                                      isUndo={false}
                                      isSelf={msg.uidFrom === "0"}
                                    />
                                    {hasActiveReactions(msg.reacts) && (
                                      <div className="absolute bot-2 left-1 z-10">
                                        <ReactionBadge reacts={msg.reacts} />
                                      </div>
                                    )}
                                    {msg.ts && !msg.isUndo && (
                                      <div
                                        className={`absolute bottom-0 ${
                                          msg.uidFrom === "0"
                                            ? "right-full mr-1.5"
                                            : "left-full ml-1.5"
                                        } z-20 opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-opacity duration-150`}
                                      >
                                        <MessageActionsBar
                                          shop={getActualShop()}
                                          msg={msg}
                                          isGroup={selectedChat.isGroup}
                                          isSelf={msg.uidFrom === "0"}
                                          isPinned={pinnedMessageIds.has(
                                            msg.id || msg._id,
                                          )}
                                          onPinChange={handlePinChange}
                                          staffName={user?.name}
                                          onReply={() =>
                                            handleRepMessageClick(msg)
                                          }
                                          onForward={() => handleShareClick(msg)}
                                          onReactionApplied={(reaction) =>
                                            applyReactionEventsToChatState([reaction])
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>
                                ) : msg.type === "card" && msg.card ? (
                                  <div
                                    className={`${
                                      msg.isUndo
                                        ? "border border-red-400 p-1 rounded-lg"
                                        : ""
                                    }`}
                                  >
                                    {msg.isUndo && (
                                      <p className="text-red-600 text-xs font-medium mb-1">
                                        Đã thu hồi
                                      </p>
                                    )}
                                    <div
                                      className={`relative w-[300px] rounded-2xl overflow-hidden shadow-sm ${
                                        msg.isUndo ? "opacity-75" : ""
                                      }`}
                                    >
                                      <div
                                        className="relative px-4 pt-4 pb-3"
                                        style={{
                                          background:
                                            "linear-gradient(135deg, #4FA3E3 0%, #2E7DD1 100%)",
                                        }}
                                      >
                                        <div className="flex items-center gap-3">
                                          {msg.card.contactAvatar ? (
                                            <img
                                              src={msg.card.contactAvatar}
                                              alt=""
                                              className="w-14 h-14 rounded-full object-cover border-2 border-white/40"
                                            />
                                          ) : (
                                            <div className="w-14 h-14 rounded-full bg-white/30 flex items-center justify-center text-white text-lg font-semibold">
                                              {(msg.card.contactName || "?")
                                                .charAt(0)
                                                .toUpperCase()}
                                            </div>
                                          )}
                                          <div className="flex-1 min-w-0">
                                            <div className="font-semibold text-white text-base truncate">
                                              {msg.card.contactName ||
                                                "Danh thiếp"}
                                            </div>
                                            {msg.card.phoneNumber && (
                                              <div className="text-xs text-white/80 truncate">
                                                {msg.card.phoneNumber}
                                              </div>
                                            )}
                                          </div>
                                          {msg.card.qrCodeUrl && (
                                            <img
                                              src={msg.card.qrCodeUrl}
                                              alt="QR"
                                              className="w-16 h-16 rounded-md bg-white p-1 shrink-0"
                                            />
                                          )}
                                        </div>
                                      </div>
                                      <div className="flex bg-white border-t border-gray-100">
                                        {msg.card.phoneNumber ? (
                                          <a
                                            href={`tel:${msg.card.phoneNumber}`}
                                            className="flex-1 py-2.5 text-center text-[13px] text-gray-700 hover:bg-gray-50 font-medium"
                                          >
                                            Gọi Điện
                                          </a>
                                        ) : (
                                          <button
                                            type="button"
                                            disabled
                                            className="flex-1 py-2.5 text-center text-[13px] text-gray-400 font-medium"
                                          >
                                            Gọi Điện
                                          </button>
                                        )}
                                        <div className="w-px bg-gray-200" />
                                        <button
                                          type="button"
                                          onClick={() =>
                                            handleOpenCardConversation(
                                              msg.card,
                                            )
                                          }
                                          className="flex-1 py-2.5 text-center text-[13px] text-gray-700 hover:bg-gray-50 font-medium"
                                        >
                                          Nhắn Tin
                                        </button>
                                      </div>
                                      {msg.isSending && (
                                        <div className="absolute top-2 right-2">
                                          <LoaderCircle
                                            className="animate-spin text-white/80"
                                            width={14}
                                            height={14}
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {msg.ts && !msg.isUndo && (
                                      <MessageActionsBar
                                        shop={getActualShop()}
                                        msg={msg}
                                        isGroup={selectedChat.isGroup}
                                        isSelf={msg.uidFrom === "0"}
                                        isPinned={pinnedMessageIds.has(
                                          msg.id || msg._id,
                                        )}
                                        onPinChange={handlePinChange}
                                        staffName={user?.name}
                                        onReply={() =>
                                          handleRepMessageClick(msg)
                                        }
                                        onForward={() => handleShareClick(msg)}
                                        showReaction={false}
                                      />
                                    )}
                                  </div>
                                ) : msg.isSending ? (
                                  <LoaderCircle
                                    className="animate-spin text-blue-600"
                                    width={30}
                                    height={30}
                                  />
                                ) : msg.type === "image" ? (
                                  <div
                                    className={`${
                                      msg.isUndo
                                        ? "border border-red-400 p-1 rounded-lg"
                                        : ""
                                    }`}
                                  >
                                    {msg.isUndo && (
                                      <p className="text-red-600 text-xs font-medium mb-1">
                                        Đã thu hồi
                                      </p>
                                    )}
                                    <div
                                      className={msg.isUndo ? "opacity-75" : ""}
                                    >
                                      <div
                                        title="ảnh"
                                        className="cursor-pointer"
                                        onClick={(e) =>
                                          handleMediaClick(e, msg)
                                        }
                                      >
                                        <ReliableChatImage
                                          src={msg.img}
                                          previewSrc={
                                            msg.previewSrc || msg.localPreviewUrl
                                          }
                                          alt="Message content"
                                          containerClassName="rounded-lg"
                                          className="max-w-xs rounded-lg"
                                          onResolved={() =>
                                            markImageMessageResolved(msg)
                                          }
                                        />
                                      </div>
                                    </div>
                                    {hasActiveReactions(msg.reacts) && (
                                      <div
                                        className={`flex ${
                                          msg.uidFrom === "0"
                                            ? "justify-end"
                                            : "justify-start"
                                        }`}
                                      >
                                        <ReactionBadge reacts={msg.reacts} />
                                      </div>
                                    )}
                                    {msg.ts && !msg.isUndo && (
                                      <MessageActionsBar
                                        shop={getActualShop()}
                                        msg={msg}
                                        isGroup={selectedChat.isGroup}
                                        isSelf={msg.uidFrom === "0"}
                                        isPinned={pinnedMessageIds.has(
                                          msg.id || msg._id,
                                        )}
                                        onPinChange={handlePinChange}
                                        staffName={user?.name}
                                        onReply={() =>
                                          handleRepMessageClick(msg)
                                        }
                                        onForward={() => handleShareClick(msg)}
                                        onReactionApplied={(reaction) =>
                                          applyReactionEventsToChatState([reaction])
                                        }
                                      />
                                    )}
                                  </div>
                                ) : msg.type === "video" ? (
                                  <div
                                    className={`${
                                      msg.isUndo
                                        ? "border border-red-400 p-1 rounded-lg"
                                        : ""
                                    }`}
                                  >
                                    {msg.isUndo && (
                                      <p className="text-red-600 text-xs font-medium mb-1">
                                        Đã thu hồi
                                      </p>
                                    )}
                                    <div
                                      className={msg.isUndo ? "opacity-75" : ""}
                                    >
                                      <div
                                        title="video"
                                        className="relative inline-block cursor-pointer"
                                        onClick={(e) =>
                                          handleMediaClick(e, msg, true)
                                        }
                                      >
                                        <img
                                          src={msg.content}
                                          alt="Video thumb"
                                          className="max-w-xs rounded-lg"
                                        />
                                        <div className="absolute inset-0 flex items-center justify-center">
                                          <Play className="h-12 w-12 text-white" />
                                        </div>
                                      </div>
                                    </div>
                                    {hasActiveReactions(msg.reacts) && (
                                      <div
                                        className={`flex ${
                                          msg.uidFrom === "0"
                                            ? "justify-end"
                                            : "justify-start"
                                        }`}
                                      >
                                        <ReactionBadge reacts={msg.reacts} />
                                      </div>
                                    )}
                                    {msg.ts && !msg.isUndo && (
                                      <MessageActionsBar
                                        shop={getActualShop()}
                                        msg={msg}
                                        isGroup={selectedChat.isGroup}
                                        isSelf={msg.uidFrom === "0"}
                                        isPinned={pinnedMessageIds.has(
                                          msg.id || msg._id,
                                        )}
                                        onPinChange={handlePinChange}
                                        staffName={user?.name}
                                        onReply={() =>
                                          handleRepMessageClick(msg)
                                        }
                                        onForward={() => handleShareClick(msg)}
                                        onReactionApplied={(reaction) =>
                                          applyReactionEventsToChatState([reaction])
                                        }
                                      />
                                    )}
                                  </div>
                                ) : msg.type === "sticker" ? (
                                  <div
                                    className={`${
                                      msg.isUndo
                                        ? "border border-red-400 p-1 rounded-lg"
                                        : ""
                                    }`}
                                  >
                                    {msg.isUndo && (
                                      <p className="text-red-600 text-xs font-medium mb-1">
                                        Đã thu hồi
                                      </p>
                                    )}
                                    <div
                                      className={msg.isUndo ? "opacity-75" : ""}
                                    >
                                      <a
                                        title="Sticker"
                                        href={msg.img}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="relative inline-block"
                                      >
                                        <img
                                          src={msg.img}
                                          alt="Sticker"
                                          className="max-w-xs rounded-lg"
                                        />
                                      </a>
                                    </div>
                                    {msg.ts && !msg.isUndo && (
                                      <MessageActionsBar
                                        shop={getActualShop()}
                                        msg={msg}
                                        isGroup={selectedChat.isGroup}
                                        isSelf={msg.uidFrom === "0"}
                                        isPinned={pinnedMessageIds.has(
                                          msg.id || msg._id,
                                        )}
                                        onPinChange={handlePinChange}
                                        staffName={user?.name}
                                        onReply={() =>
                                          handleRepMessageClick(msg)
                                        }
                                        onForward={() => handleShareClick(msg)}
                                        showReaction={false}
                                      />
                                    )}
                                  </div>
                                ) : (
                                  <div
                                    className={`${
                                      msg.isUndo
                                        ? "border border-red-400 p-1 rounded-lg"
                                        : ""
                                    }`}
                                  >
                                    {msg.isUndo && (
                                      <p className="text-red-600 text-xs font-medium mb-1">
                                        Đã thu hồi
                                      </p>
                                    )}
                                    <div
                                      className={msg.isUndo ? "opacity-75" : ""}
                                    >
                                      <div
                                        className={`flex flex-col gap-1 ${
                                          msg.uidFrom === "0"
                                            ? "items-end"
                                            : "items-start"
                                        }`}
                                      >
                                        <ImageGridAlbum
                                          imgs={msg.imgs}
                                          previewImgs={msg.previewImgs}
                                          imageRefs={msg.imageRefs}
                                          onImageClick={(e, index) =>
                                            handleMediaClick(e, {
                                              ...msg,
                                              img: msg.imgs[index],
                                              previewSrc:
                                                msg.previewImgs?.[index],
                                              content: msg.imgs[index],
                                              _id: `${msg._id}_${index}`,
                                            })
                                          }
                                          onImageResolved={markImageMessageResolved}
                                        />
                                        {!msg.isSending ? (
                                          <p
                                            className={`flex items-end text-xs text-gray-500`}
                                          >
                                            {msg.sendingStatus === "error" && (
                                              <>
                                                <span className="text-red-600">
                                                  {"Gửi lỗi-"}
                                                </span>
                                              </>
                                            )}
                                            {renderMediaRetryAction(msg)}
                                            {common.getPreviewTimeMessage(
                                              msg.dateAction,
                                            )}
                                          </p>
                                        ) : (
                                          msg.uidFrom === "0" &&
                                          msg.type !== "images" &&
                                          selectedChat.messages[
                                            selectedChat.messages.length - 1
                                          ].dateAction !== msg.dateAction && (
                                            <p
                                              className={`flex items-end text-xs text-gray-500`}
                                            >
                                              Đang gửi
                                            </p>
                                          )
                                        )}
                                      </div>
                                    </div>
                                    {hasActiveReactions(msg.reacts) && (
                                      <div
                                        className={`flex ${
                                          msg.uidFrom === "0"
                                            ? "justify-end"
                                            : "justify-start"
                                        }`}
                                      >
                                        <ReactionBadge reacts={msg.reacts} />
                                      </div>
                                    )}
                                    {msg.ts && !msg.isUndo && (
                                      <MessageActionsBar
                                        shop={getActualShop()}
                                        msg={msg}
                                        isGroup={selectedChat.isGroup}
                                        isSelf={msg.uidFrom === "0"}
                                        isPinned={pinnedMessageIds.has(
                                          msg.id || msg._id,
                                        )}
                                        onPinChange={handlePinChange}
                                        staffName={user?.name}
                                        onReply={() =>
                                          handleRepMessageClick(msg)
                                        }
                                        onForward={() => handleShareClick(msg)}
                                        onReactionApplied={(reaction) =>
                                          applyReactionEventsToChatState([reaction])
                                        }
                                      />
                                    )}
                                  </div>
                                )}
                              </div>
                              {!msg.isSending && msg.type !== "images" ? (
                                <p
                                  className={`flex items-end mt-1 mb-1 text-xs text-gray-500`}
                                >
                                  {msg.sendingStatus === "error" && (
                                    <>
                                      <span className="text-red-600">
                                        {"Gửi lỗi-"}
                                      </span>
                                    </>
                                  )}
                                  {renderMediaRetryAction(msg)}
                                  {common.getPreviewTimeMessage(msg.dateAction)}
                                </p>
                              ) : (
                                // Only show "Đang gửi" for single images/text, not merged images
                                msg.uidFrom === "0" &&
                                msg.type !== "images" &&
                                selectedChat.messages[
                                  selectedChat.messages.length - 1
                                ].dateAction !== msg.dateAction && (
                                  <p
                                    className={`flex items-end mt-1 mb-1 text-xs text-gray-500`}
                                  >
                                    Đang gửi
                                  </p>
                                )
                              )}
                              {/* {msg.uidFrom === "0" && (
                              <div className="w-8 h-8 rounded-full bg-gray-300 ml-2 flex-shrink-0">
                                <img
                                  src={selectedShop.avatar}
                                  alt=""
                                  className="w-full h-full object-cover rounded-full"
                                />
                              </div>
                            )} */}
                            </div>
                            {msg.uidFrom === "0" &&
                              selectedChat.messages[
                                selectedChat.messages.length - 1
                              ].dateAction === msg.dateAction && (
                                <p
                                  className={`flex ${
                                    msg.uidFrom === "0"
                                      ? "justify-end pr-3"
                                      : "justify-start ml-8 pl-3"
                                  } ${
                                    hasActiveReactions(msg.reacts)
                                      ? "mt-2"
                                      : "mt-0.5"
                                  } mb-1 text-[10px] ${
                                    msg.sendingStatus === "seen"
                                      ? "text-blue-500 font-medium"
                                      : msg.sendingStatus === "error"
                                        ? "text-red-500"
                                        : "text-gray-400"
                                  }`}
                                >
                                  {msg.isSending ? (
                                    "Đang gửi..."
                                  ) : msg.sendingStatus === "seen" ? (
                                    `Đã xem · ${common.getPreviewTimeMessage(msg.dateAction)}`
                                  ) : msg.sendingStatus === "error" ? (
                                    <>
                                      <span>Gửi lỗi</span>
                                      {renderMediaRetryAction(msg)}
                                    </>
                                  ) : (
                                    `Đã nhận · ${common.getPreviewTimeMessage(msg.dateAction)}`
                                  )}
                                </p>
                              )}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  {selectedChat?.isGroup && (
                    <SelectMentionModal
                      isOpen={isOpenSelectMentionModal}
                      setIsOpen={setIsOpenSelectMentionModal}
                      content={message}
                      setContent={setMessage}
                      setMentions={setMentions}
                      groupMembers={groupMembers}
                      messageInputRef={messageInputRef}
                    />
                  )}
                  <SelectQuickMessageModal
                    isOpen={isOpenSelectQuickMessageModal}
                    setIsOpen={setIsOpenSelectQuickMessageModal}
                    content={message}
                    files={files}
                    setFiles={setFiles}
                    setContent={setMessage}
                    quickMessages={quickMessages}
                    messageInputRef={messageInputRef}
                    contact={selectedChat}
                  />
                  <div
                    ref={composerContainerRef}
                    className="border-t border-gray-100 bg-white flex flex-col relative shrink-0"
                    style={{ height: composerHeight }}
                  >
                    {/* Drag handle - kéo để thay đổi chiều cao */}
                    <div
                      className="absolute -top-[3px] left-0 right-0 h-1.5 cursor-ns-resize group z-10"
                      onPointerDown={() => {
                        composerResizingRef.current = true;
                      }}
                      onTouchStart={() => {
                        composerResizingRef.current = true;
                      }}
                      title="Kéo để thay đổi chiều cao"
                    >
                      <div className="mx-auto w-12 h-1 rounded-full bg-gray-300 group-hover:bg-gray-400 mt-[2px]" />
                    </div>
                    <div className="p-2 flex-1 min-h-0 flex flex-col">
                    {repMessage && (
                      <div className="flex gap-2 rounded-lg bg-gray-100 p-2 mb-2">
                        <div className="border-2 border-blue-500"></div>
                        {repMessage.type !== "text" && (
                          <img
                            src={repMessage.img}
                            alt=""
                            className="w-12 h-12 object-cover"
                          />
                        )}
                        <div className="flex flex-col w-full">
                          <div className="flex items-center justify-between text-gray-900 text-sm">
                            <div className="flex items-center gap-1">
                              <Quote className="w-3 h-3" />
                              <span>Trả lời</span>
                            </div>
                            <X
                              className="w-4 h-4 self-start cursor-pointer hover:text-blue-500"
                              onClick={() => setRepMessage(null)}
                            />
                          </div>
                          <span className="text-gray-600">
                            {repMessage.type === "text"
                              ? repMessage.content
                              : "[Hình ảnh]"}
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="flex-1 min-h-0 flex flex-col">
                      <div className="flex-1 min-h-0 flex flex-col">
                        {files.length > 0 && (
                          <div className="flex flex-wrap gap-2 mb-2">
                            {files.map((file, index) => (
                              <div key={index} className="relative">
                                {file.type.startsWith("image/") ? (
                                  <img
                                    src={URL.createObjectURL(file)}
                                    alt={`File ${index + 1}`}
                                    className="w-20 h-20 object-cover rounded-lg shadow-md"
                                  />
                                ) : file.type.startsWith("video/") ? (
                                  <div className="w-20 h-20 flex items-center justify-center bg-gray-200 rounded-lg shadow-md">
                                    <Film className="w-8 h-8 text-gray-500" />
                                  </div>
                                ) : (
                                  <div className="w-20 h-20 flex items-center justify-center bg-gray-200 rounded-lg shadow-md">
                                    <FileText className="w-8 h-8 text-gray-500" />
                                  </div>
                                )}
                                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white text-xs p-1 truncate rounded-b-lg">
                                  {file.name}
                                </div>
                                <button
                                  onClick={() => handleRemoveFile(index)}
                                  className="absolute -top-2 -right-2 p-1 bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors"
                                  aria-label={`Remove file ${index + 1}`}
                                >
                                  <X className="w-3 h-3" />
                                </button>
                              </div>
                            ))}
                          </div>
                        )}
                        <div className="flex flex-col bg-gray-50 rounded-lg flex-1 min-h-0 border border-gray-100">
                          <TagChipsBar
                            selectedChat={selectedChat}
                            tags={tags}
                            tagZalos={tagZalos}
                            onRemoveAkabizTag={handleAddRemoveTag}
                            onRemoveZaloTag={(tag) => {
                              shopApi
                                .updateTagZalos(
                                  getActualShop()._id,
                                  [
                                    {
                                      _id: tag._id,
                                      conversations: (
                                        tag.conversations || []
                                      ).filter((c) => c !== selectedChat.uid),
                                    },
                                  ],
                                  {
                                    tagAction: "remove_tag_zalo",
                                    tagName: tag.text,
                                    uid: selectedChat.uid,
                                  },
                                )
                                .then((res) => {
                                  getTagZalos(getActualShop()._id);
                                  addNotification(
                                    res.status === 1
                                      ? "Gỡ tag thành công"
                                      : res.message,
                                    res.status,
                                  );
                                });
                            }}
                            onAdd={(type) => {
                              if (type === "akabiz") {
                                document
                                  .querySelector('button[aria-label="Gắn nhãn"]')
                                  ?.click();
                              } else {
                                const btn = document.querySelector(
                                  'button[title="Gắn tag Zalo"], button[title="Đổi tag"]',
                                );
                                btn?.click();
                              }
                            }}
                          />
                          {/* Toolbar row - các icon menu nằm phía trên */}
                          <div className="flex items-center gap-0.5 px-1.5 pt-1 pb-1 border-b border-gray-100 shrink-0">
                            <TagAssignmentPopover
                              selectedChat={selectedChat}
                              tags={tags.filter((t) => t.isActive)}
                              onTagsChange={handleAddRemoveTag}
                            />
                            <PipelineStageSelector
                              stages={pipelineStages.filter(
                                (s) => !s.isDelete && s.isActive !== false,
                              )}
                              currentStageId={selectedChat?.pipelineStageId}
                              onChange={handleUpdatePipelineStage}
                            />
                            <button
                              className="p-1.5 rounded-md hover:bg-gray-200 transition-colors text-gray-500 hover:text-gray-700"
                              aria-label="Gửi hình ảnh"
                              onClick={handleImageClick}
                              title="Gửi hình ảnh"
                            >
                              <ImageIcon className="w-4 h-4" />
                            </button>
                            <input
                              type="file"
                              ref={imageInputRef}
                              className="hidden"
                              accept="image/*"
                              onChange={handleFileChange}
                              multiple
                            />
                            <button
                              className="p-1.5 rounded-md hover:bg-gray-200 transition-colors text-gray-500 hover:text-gray-700"
                              aria-label="Đính kèm file"
                              onClick={handleFileClick}
                              title="Đính kèm file"
                            >
                              <Paperclip className="w-4 h-4" />
                            </button>
                            <input
                              type="file"
                              ref={fileInputRef}
                              className="hidden"
                              accept="/*"
                              onChange={handleFileChange}
                              multiple
                            />
                            <ScreenshotCapture
                              onCapture={(file) =>
                                setFiles((prev) => [...prev, file])
                              }
                            />
                            <button
                              className="p-1.5 rounded-md hover:bg-gray-200 transition-colors text-gray-500 hover:text-gray-700"
                              onClick={() => setIsOpenSendCardModal(true)}
                              aria-label="Gửi danh thiếp"
                              title="Gửi danh thiếp"
                              type="button"
                            >
                              <IdCard className="w-4 h-4" />
                            </button>
                            <EmojiPicker handleEmojiSelect={handleEmojiSelect} />
                            <StickerPicker
                              shopId={selectedShop._id}
                              selectedChat={selectedChat}
                            />
                            <button
                              type="button"
                              className={`p-1.5 rounded-md transition-colors ${
                                isAdvancedCompose
                                  ? "bg-blue-50 text-blue-600"
                                  : "hover:bg-gray-200 text-gray-500 hover:text-gray-700"
                              }`}
                              onClick={() =>
                                setIsAdvancedCompose((prev) => {
                                  const next = !prev;
                                  if (next)
                                    setMessageHtml(plainToHtml(message));
                                  else setMessage(stripHtml(messageHtml));
                                  return next;
                                })
                              }
                              aria-label="Soạn nâng cao"
                              title="Soạn nâng cao (Cmd+Shift+X)"
                              aria-pressed={isAdvancedCompose}
                            >
                              <Type className="w-4 h-4" />
                            </button>
                          </div>
                          {/* Input row - textarea + Send button */}
                          {isAdvancedCompose ? (
                            <RichTextComposer
                              value={messageHtml}
                              onChange={setMessageHtml}
                              onSend={() =>
                                handleSendMessage(
                                  selectedShop?._id,
                                  selectedChat?.uid,
                                )
                              }
                              onPaste={handlePaste}
                              placeholder="Nhấn Cmd + Shift + X để định dạng tin nhắn"
                              autoFocus
                            />
                          ) : (
                            <div className="flex items-end gap-2 p-1.5 flex-1 min-h-0">
                              <textarea
                                placeholder="Nhập tin nhắn... (Enter để gửi, Shift+Enter xuống dòng)"
                                className="flex-1 min-h-0 bg-transparent focus:outline-none text-[13px] text-gray-800 placeholder:text-gray-400 px-2 py-1 resize-none overflow-auto self-stretch"
                                autoFocus
                                ref={messageInputRef}
                                value={message}
                                onChange={(e) => {
                                  setMessage(e.target.value);
                                  const words = e.target.value.split("@");
                                  const mentionsGroupMembers =
                                    groupMembers.filter((c) =>
                                      c.name
                                        .toLowerCase()
                                        .startsWith(
                                          words[words.length - 1].toLowerCase(),
                                        ),
                                    );
                                  if (
                                    words.length > 1 &&
                                    mentionsGroupMembers.length > 0
                                  ) {
                                    setIsOpenSelectMentionModal(true);
                                  } else {
                                    setIsOpenSelectMentionModal(false);
                                  }

                                  if (e.target.value.startsWith("/")) {
                                    setIsOpenSelectQuickMessageModal(true);
                                  } else {
                                    setIsOpenSelectQuickMessageModal(false);
                                  }
                                }}
                                onKeyPress={(e) => {
                                  if (e.key === "Enter" && !e.shiftKey) {
                                    e.preventDefault(); // Ngăn việc xuống dòng tự động
                                    handleSendMessage(
                                      selectedShop?._id,
                                      selectedChat?.uid,
                                    ); // Gửi tin nhắn
                                  }
                                }}
                                onPaste={handlePaste}
                              />
                              <button
                                className="h-8 w-8 flex items-center justify-center rounded-full bg-primary text-white hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed transition-opacity shrink-0"
                                onClick={() =>
                                  handleSendMessage(
                                    selectedShop?._id,
                                    selectedChat?.uid,
                                  )
                                }
                                disabled={!message.trim() && files.length === 0}
                                aria-label="Gửi tin nhắn"
                                title="Gửi (Enter)"
                              >
                                <Send className="w-3.5 h-3.5" />
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex items-center justify-center h-full bg-gradient-to-br from-gray-50 to-white p-8">
                    <div className="w-full max-w-md text-center">
                      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/5 mb-4">
                        <MessageCircle className="w-8 h-8 text-primary/50" />
                      </div>
                      <h2 className="text-[15px] font-semibold text-gray-700 mb-1">
                        Chưa có hội thoại nào được chọn
                      </h2>
                      <p className="text-[12px] text-gray-500 mb-6">
                        Chọn một khách hàng từ danh sách bên trái để bắt đầu
                        trò chuyện
                      </p>
                      <div className="grid grid-cols-3 gap-2 mb-5">
                        <button
                          type="button"
                          onClick={() => setConversationTab("unread")}
                          className="rounded-lg border border-gray-100 bg-white p-3 text-left hover:border-primary/30 hover:shadow-sm transition-all"
                        >
                          <div className="text-[18px] font-semibold text-red-500 leading-tight">
                            {countUnreadMessage}
                          </div>
                          <div className="text-[11px] text-gray-500 mt-0.5">
                            Chưa đọc
                          </div>
                        </button>
                        <button
                          type="button"
                          onClick={() => setSelectedCategories(["requesting"])}
                          className="rounded-lg border border-gray-100 bg-white p-3 text-left hover:border-primary/30 hover:shadow-sm transition-all"
                        >
                          <div className="text-[18px] font-semibold text-amber-500 leading-tight">
                            {countRequesting}
                          </div>
                          <div className="text-[11px] text-gray-500 mt-0.5">
                            Chờ kết bạn
                          </div>
                        </button>
                        <button
                          type="button"
                          onClick={() => setSelectedCategories(["stranger"])}
                          className="rounded-lg border border-gray-100 bg-white p-3 text-left hover:border-primary/30 hover:shadow-sm transition-all"
                        >
                          <div className="text-[18px] font-semibold text-blue-500 leading-tight">
                            {countStranger}
                          </div>
                          <div className="text-[11px] text-gray-500 mt-0.5">
                            Người lạ
                          </div>
                        </button>
                      </div>
                      <p className="text-[11px] text-gray-400">
                        Mẹo: bấm{" "}
                        <kbd className="px-1.5 py-0.5 text-[10px] font-semibold text-gray-600 bg-white border border-gray-200 rounded">
                          ⌘K
                        </kbd>{" "}
                        để tìm nhanh
                      </p>
                    </div>
                  </div>
                </>
              )}
            </section>
          )}
          {/* Mobile AI Assistant panel shown as a slide-up panel instead */}
          {openMenus.aiAssistant && (
            <section
              className={cn(
                "flex flex-col border-l border-gray-200 bg-white",
                isMobile ? "w-full" : "w-80",
              )}
            >
              {" "}
              <AIAssistantPanel
                isOpen={true}
                onClose={() => toggleMenu("aiAssistant")}
              />
            </section>
          )}
          {openMenus.sidebarInfo && (
            <section
              className={cn(
                "flex flex-col border-l border-gray-200 bg-white relative",
                isMobile ? "w-full" : "",
              )}
              style={{ width: isMobile ? undefined : sidebarInfoWidth }}
            >
              <div
                className="absolute left-0 top-0 bottom-0 w-1 cursor-ew-resize hover:bg-gray-200"
                onPointerDown={() => {
                  sidebarResizingRef.current = true;
                }}
                onTouchStart={() => {
                  sidebarResizingRef.current = true;
                }}
              />
              {selectedChat && !isOpenGroupMembersSideBar && (
                <>
                  <div className="flex items-center justify-between py-1.5 border-b border-gray-100 top-0">
                    <X
                      className="w-5 h-5 ml-2 cursor-pointer invisible"
                      onClick={() => toggleMenu("sidebarInfo")}
                    />
                    <h2 className="h-9 flex items-center justify-center text-[13px] font-semibold text-gray-800">
                      Thông tin hội thoại
                    </h2>
                    <X
                      className="w-5 h-5 mr-2 cursor-pointer text-gray-500 hover:text-gray-700"
                      onClick={() => toggleMenu("sidebarInfo")}
                    />
                  </div>
                  {isLoadingGroupMember ? (
                    <div className="flex items-center justify-center flex-1 overflow-y-auto">
                      <LoaderCircle
                        className="animate-spin text-blue-600"
                        width={30}
                        height={30}
                      />
                    </div>
                  ) : (
                    <div className="flex-1 overflow-y-auto">
                      {!selectedChat.isGroup && (
                        <>
                          {selectedChat.isFriend && (
                            <div className="flex justify-around gap-2 px-3 py-1.5 border-b border-gray-100">
                              <button
                                className="flex flex-col items-center gap-0.5 p-1.5 hover:bg-gray-100 rounded-md"
                                onClick={() => {
                                  setSelectedCreateGroupContacts([
                                    selectedChat,
                                  ]);
                                  setIsOpenCreateGroupModal(true);
                                }}
                              >
                                <Users className="h-4 w-4" />
                                <span className="text-[11px]">Tạo nhóm</span>
                              </button>
                              {(user?.role?.includes("admin") ||
                                user?.role?.includes("super_admin")) && (
                                <button
                                  className="flex flex-col items-center gap-0.5 p-1.5 hover:bg-gray-100 rounded-md text-red-700"
                                  onClick={handleRemoveFriend}
                                >
                                  <UserX className="h-4 w-4" />
                                  <span className="text-[11px]">Huỷ kết bạn</span>
                                </button>
                              )}
                            </div>
                          )}
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("chatInfo")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <User className="w-4 h-4 text-gray-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Thông tin cá nhân
                                </span>
                              </div>
                              {openMenus.chatInfo ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>

                            {openMenus.chatInfo && (
                              <div className="px-3 py-2 bg-gray-50 text-gray-800">
                                <div className="grid grid-cols-[84px_1fr] gap-x-2 gap-y-1 text-[12px]">
                                  <span className="text-gray-500">Tên</span>
                                  <span className="truncate">{selectedChat.name}</span>
                                  <span className="text-gray-500">SĐT</span>
                                  <span>{selectedChat.phone || "**********"}</span>
                                  <span className="text-gray-500">Giới tính</span>
                                  <span>{selectedChat.gender === 1 ? "Nữ" : "Nam"}</span>
                                  <span className="text-gray-500">Ngày sinh</span>
                                  <span>{selectedChat.sdob || "**/**/****"}</span>
                                  <span className="text-gray-500">Bio</span>
                                  <span className="break-words">{selectedChat.bio || "—"}</span>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("contactInfo")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <Phone className="w-4 h-4 text-gray-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Thông tin liên hệ
                                </span>
                              </div>
                              {openMenus.contactInfo ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>

                            {openMenus.contactInfo && (
                              <div className="flex flex-col px-3 py-2 bg-gray-50 text-gray-800 gap-2.5 text-[12px]">
                                {/* Phone List */}
                                <div>
                                  <div className="flex items-center justify-between mb-1">
                                    <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">
                                      Số điện thoại:
                                    </p>
                                    <button
                                      onClick={() => toggleMenu("addPhone")}
                                      className="p-1 rounded-full hover:bg-blue-100 text-blue-500"
                                      title="Thêm SĐT"
                                    >
                                      <Plus className="w-4 h-4" />
                                    </button>
                                  </div>
                                  {selectedChat.phoneList &&
                                  selectedChat.phoneList.length > 0 ? (
                                    <div className="flex flex-wrap gap-1">
                                      {selectedChat.phoneList.map(
                                        (phone, idx) => (
                                          <span
                                            key={idx}
                                            className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full cursor-pointer hover:bg-blue-200 transition-colors"
                                            onClick={() => {
                                              navigator.clipboard.writeText(
                                                phone,
                                              );
                                              addNotification(
                                                "Đã sao chép SĐT",
                                                1,
                                              );
                                            }}
                                            title="Sao chép"
                                          >
                                            {phone}
                                          </span>
                                        ),
                                      )}
                                    </div>
                                  ) : (
                                    <p className="text-[11px] text-gray-500 italic">
                                      Chưa có SĐT nào
                                    </p>
                                  )}
                                  {/* Add Phone Input - Toggle */}
                                  {openMenus.addPhone && (
                                    <div className="flex gap-1 mt-2">
                                      <input
                                        type="text"
                                        placeholder="Nhập SĐT..."
                                        className="flex-1 px-2 py-1 text-sm border rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        autoFocus
                                        onKeyPress={(e) => {
                                          if (e.key === "Enter") {
                                            const value = e.target.value.trim();
                                            if (value) {
                                              handleAddContactInfo(
                                                "phone",
                                                value,
                                              );
                                              e.target.value = "";
                                              toggleMenu("addPhone");
                                            }
                                          }
                                        }}
                                        id="add-phone-input"
                                      />
                                      <button
                                        onClick={() => {
                                          const input =
                                            document.getElementById(
                                              "add-phone-input",
                                            );
                                          const value = input?.value?.trim();
                                          if (value) {
                                            handleAddContactInfo(
                                              "phone",
                                              value,
                                            );
                                            input.value = "";
                                            toggleMenu("addPhone");
                                          }
                                        }}
                                        className="px-2 py-1 bg-blue-500 text-white text-xs rounded hover:bg-blue-600"
                                      >
                                        Thêm
                                      </button>
                                      <button
                                        onClick={() => toggleMenu("addPhone")}
                                        className="px-2 py-1 bg-gray-300 text-gray-700 text-xs rounded hover:bg-gray-400"
                                      >
                                        Hủy
                                      </button>
                                    </div>
                                  )}
                                </div>

                                {/* Email List */}
                                <div>
                                  <div className="flex items-center justify-between mb-1">
                                    <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">
                                      Email:
                                    </p>
                                    <button
                                      onClick={() => toggleMenu("addEmail")}
                                      className="p-1 rounded-full hover:bg-green-100 text-green-500"
                                      title="Thêm email"
                                    >
                                      <Plus className="w-4 h-4" />
                                    </button>
                                  </div>
                                  {selectedChat.emailList &&
                                  selectedChat.emailList.length > 0 ? (
                                    <div className="flex flex-wrap gap-1">
                                      {selectedChat.emailList.map(
                                        (email, idx) => (
                                          <span
                                            key={idx}
                                            className="inline-flex items-center px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full cursor-pointer hover:bg-green-200 transition-colors"
                                            onClick={() => {
                                              navigator.clipboard.writeText(
                                                email,
                                              );
                                              addNotification(
                                                "Đã sao chép email",
                                                1,
                                              );
                                            }}
                                            title="Sao chép"
                                          >
                                            {email}
                                          </span>
                                        ),
                                      )}
                                    </div>
                                  ) : (
                                    <p className="text-[11px] text-gray-500 italic">
                                      Chưa có email nào
                                    </p>
                                  )}
                                  {/* Add Email Input - Toggle */}
                                  {openMenus.addEmail && (
                                    <div className="flex gap-1 mt-2">
                                      <input
                                        type="email"
                                        placeholder="Nhập email..."
                                        className="flex-1 px-2 py-1 text-sm border rounded focus:outline-none focus:ring-1 focus:ring-green-500"
                                        autoFocus
                                        onKeyPress={(e) => {
                                          if (e.key === "Enter") {
                                            const value = e.target.value.trim();
                                            if (value) {
                                              handleAddContactInfo(
                                                "email",
                                                value,
                                              );
                                              e.target.value = "";
                                              toggleMenu("addEmail");
                                            }
                                          }
                                        }}
                                        id="add-email-input"
                                      />
                                      <button
                                        onClick={() => {
                                          const input =
                                            document.getElementById(
                                              "add-email-input",
                                            );
                                          const value = input?.value?.trim();
                                          if (value) {
                                            handleAddContactInfo(
                                              "email",
                                              value,
                                            );
                                            input.value = "";
                                            toggleMenu("addEmail");
                                          }
                                        }}
                                        className="px-2 py-1 bg-green-500 text-white text-xs rounded hover:bg-green-600"
                                      >
                                        Thêm
                                      </button>
                                      <button
                                        onClick={() => toggleMenu("addEmail")}
                                        className="px-2 py-1 bg-gray-300 text-gray-700 text-xs rounded hover:bg-gray-400"
                                      >
                                        Hủy
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("mutualGroup")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <Users className="w-4 h-4 text-gray-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Nhóm chung
                                </span>
                              </div>
                              {openMenus.mutualGroup ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>

                            {openMenus.mutualGroup && (
                              <ul>
                                {contacts
                                  .filter(
                                    (c) =>
                                      c.isGroup &&
                                      c.groupMemberIds?.includes(
                                        selectedChat.uid,
                                      ),
                                  )
                                  .map((group) => (
                                    <li
                                      key={group._id}
                                      className="flex items-center justify-between px-3 py-1.5 bg-gray-50 border-b border-gray-100 cursor-pointer transition-colors hover:bg-gray-100 text-[12px]"
                                      onClick={() => handleContactClick(group)}
                                    >
                                      <div className="flex items-center gap-2 w-full">
                                        <div className="flex flex-col overflow-hidden">
                                          <span className="truncate font-medium text-gray-700">
                                            {group.name} (
                                            {group.groupMemberIds?.length ?? 0})
                                          </span>
                                        </div>
                                      </div>
                                      <div className="flex flex-col gap-1"></div>
                                    </li>
                                  ))}
                              </ul>
                            )}
                          </div>
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("images")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <ImageIcon className="w-4 h-4 text-gray-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Xem ảnh
                                </span>
                              </div>
                              {openMenus.images ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>
                            {openMenus.images && (
                              <div className="grid grid-cols-3 gap-1.5 p-2 bg-gray-50">
                                {mediaMessages.map((item, idx) => (
                                  <div
                                    key={idx}
                                    className="relative w-full h-20 cursor-pointer group"
                                    onClick={(e) => handleMediaClick(e, item)}
                                  >
                                    <img
                                      src={
                                        item.type === "video"
                                          ? item.content
                                          : item.img
                                      }
                                      alt="thumbnail"
                                      className="w-full h-full object-cover rounded-md"
                                      onError={(e) => {
                                        e.target.style.display = "none";
                                      }}
                                    />
                                    {item.type === "video" && (
                                      <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/10 transition-colors rounded-md">
                                        <div className="w-8 h-8 rounded-full bg-black/50 flex items-center justify-center backdrop-blur-sm">
                                          <Play className="w-4 h-4 text-white fill-white ml-0.5" />
                                        </div>
                                        <span className="absolute bottom-1 right-1 px-1 py-0.5 bg-black/60 text-[10px] text-white rounded font-medium">
                                          Video
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("files")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <FileText className="w-4 h-4 text-gray-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Xem file
                                </span>
                              </div>
                              {openMenus.files ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>
                            {openMenus.files && (
                              <div className="flex flex-col gap-2 p-2 bg-gray-50">
                                <input
                                  type="text"
                                  value={fileSearch}
                                  onChange={(e) => {
                                    setFileSearch(e.target.value);
                                    setFilePage(1);
                                  }}
                                  placeholder="Tìm kiếm file..."
                                  className="mb-2 border rounded px-2 py-1 text-sm"
                                />
                                <select
                                  className="mb-2 border rounded px-2 py-1 text-sm"
                                  value={fileFilter}
                                  onChange={(e) => {
                                    setFileFilter(e.target.value);
                                    setFilePage(1);
                                  }}
                                >
                                  <option value="all">Tất cả</option>
                                  <option value="pdf">PDF</option>
                                  <option value="doc">DOC</option>
                                  <option value="docx">DOCX</option>
                                  <option value="xls">XLS</option>
                                  <option value="xlsx">XLSX</option>
                                  <option value="ppt">PPT</option>
                                  <option value="pptx">PPTX</option>
                                  <option value="zip">ZIP</option>
                                  <option value="rar">RAR</option>
                                </select>
                                {paginatedFileMessages.map((file, idx) => (
                                  <div
                                    key={idx}
                                    className="flex items-center justify-between bg-white p-1.5 rounded shadow-sm"
                                  >
                                    <div className="flex items-center gap-1.5 overflow-hidden">
                                      <FileText className="w-4 h-4 text-gray-500 flex-shrink-0" />
                                      <span className="truncate text-[12px]">
                                        {file.content}
                                      </span>
                                    </div>
                                    <a
                                      href={file.file}
                                      className="text-blue-500 text-[12px]"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Tải xuống
                                    </a>
                                  </div>
                                ))}
                                {filteredFileMessages.length > filesPerPage && (
                                  <div className="flex justify-between mt-2">
                                    <button
                                      className="px-2 py-1 border rounded text-sm"
                                      disabled={filePage === 1}
                                      onClick={() => setFilePage((p) => p - 1)}
                                    >
                                      Trước
                                    </button>
                                    <span className="text-sm">
                                      {filePage}/
                                      {Math.ceil(
                                        filteredFileMessages.length /
                                          filesPerPage,
                                      )}
                                    </span>
                                    <button
                                      className="px-2 py-1 border rounded text-sm"
                                      disabled={
                                        filePage >=
                                        Math.ceil(
                                          filteredFileMessages.length /
                                            filesPerPage,
                                        )
                                      }
                                      onClick={() => setFilePage((p) => p + 1)}
                                    >
                                      Sau
                                    </button>
                                  </div>
                                )}
                                {filteredFileMessages.length === 0 && (
                                  <p className="text-sm text-gray-500">
                                    Chưa có file nào
                                  </p>
                                )}
                              </div>
                            )}
                          </div>
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("links")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <Link className="w-4 h-4 text-gray-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Xem link
                                </span>
                              </div>
                              {openMenus.links ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>
                            {openMenus.links && (
                              <div className="flex flex-col gap-2 p-2 bg-gray-50">
                                {linkMessages.map((link, idx) => (
                                  <div key={idx} className="flex flex-col">
                                    <a
                                      href={
                                        link.link.startsWith("http")
                                          ? link.link
                                          : `http://${link.link}`
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-blue-500 underline truncate text-[12px]"
                                    >
                                      {link.link}
                                    </a>
                                    <span className="text-[10px] text-gray-400">
                                      {common.getPreviewTimeMessage(
                                        link.dateAction,
                                      )}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("noteInfo")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <StickyNote className="w-4 h-4 text-gray-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Ghi chú
                                </span>
                              </div>
                              {openMenus.noteInfo ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>

                            {openMenus.noteInfo && (
                              <div className="flex flex-col px-3 py-2 bg-gray-50 text-gray-800 gap-2.5 text-[12px]">
                                <div>
                                  <div className="flex items-center justify-between mb-1">
                                    <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">
                                      Danh sách ghi chú:
                                    </p>
                                    <button
                                      onClick={() => toggleMenu("addNote")}
                                      className="p-1 rounded hover:bg-yellow-100 text-yellow-600"
                                      title="Thêm ghi chú"
                                    >
                                      <Plus className="w-4 h-4" />
                                    </button>
                                  </div>
                                  {selectedChat.noteList &&
                                  selectedChat.noteList.length > 0 ? (
                                    <div className="flex flex-col gap-1">
                                      {selectedChat.noteList.map(
                                        (note, idx) => (
                                          <div
                                            key={idx}
                                            className="w-full p-2 bg-yellow-100 text-yellow-800 text-sm rounded-md cursor-pointer hover:bg-yellow-200 transition-colors whitespace-pre-wrap"
                                            onClick={() => {
                                              navigator.clipboard.writeText(
                                                note,
                                              );
                                              addNotification(
                                                "Đã sao chép ghi chú",
                                                1,
                                              );
                                            }}
                                            title="Sao chép"
                                          >
                                            {note}
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  ) : (
                                    <p className="text-[11px] text-gray-500 italic">
                                      Chưa có ghi chú nào
                                    </p>
                                  )}

                                  {/* Add Note Input - Toggle */}
                                  {openMenus.addNote && (
                                    <div className="flex flex-col gap-2 mt-2">
                                      <textarea
                                        placeholder="Nhập ghi chú..."
                                        className="w-full px-2 py-1 text-sm border rounded-md focus:outline-none focus:ring-1 focus:ring-yellow-500 resize-none"
                                        rows={3}
                                        autoFocus
                                        id="add-note-input-individual"
                                      />
                                      <div className="flex gap-2 justify-end">
                                        <button
                                          onClick={() => toggleMenu("addNote")}
                                          className="px-3 py-1 bg-gray-300 text-gray-700 text-xs rounded hover:bg-gray-400"
                                        >
                                          Hủy
                                        </button>
                                        <button
                                          onClick={() => {
                                            const input =
                                              document.getElementById(
                                                "add-note-input-individual",
                                              );
                                            const value = input?.value?.trim();
                                            if (value) {
                                              handleAddContactInfo(
                                                "note",
                                                value,
                                              );
                                              input.value = "";
                                              toggleMenu("addNote");
                                            }
                                          }}
                                          className="px-3 py-1 bg-yellow-500 text-white text-xs rounded hover:bg-yellow-600"
                                        >
                                          Thêm
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          {isChatbotEventEnabled && (
                            <div className="border-b">
                              <button
                                onClick={() => toggleMenu("botMessages")}
                                className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                              >
                                <div className="flex items-center gap-2">
                                  <Bot className="w-4 h-4 text-gray-500" />
                                  <span className="text-[13px] font-medium text-gray-700">
                                    Tin nhắn bot - Sự kiện
                                  </span>
                                </div>
                                {openMenus.botMessages ? (
                                  <ChevronDown className="w-4 h-4 text-gray-500" />
                                ) : (
                                  <ChevronRight className="w-4 h-4 text-gray-500" />
                                )}
                              </button>
                              {openMenus.botMessages && (
                                <BotMessagesTab
                                  contactId={selectedChat?.id}
                                  isOpen={openMenus.botMessages}
                                  chatbotType="event"
                                />
                              )}
                            </div>
                          )}
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("botKeywordMessages")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <Bot className="w-4 h-4 text-purple-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Tin nhắn bot - Ý nghĩa
                                </span>
                              </div>
                              {openMenus.botKeywordMessages ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>
                            {openMenus.botKeywordMessages && (
                              <BotMessagesTab
                                contactId={selectedChat?.id}
                                isOpen={openMenus.botKeywordMessages}
                                chatbotType="keyword"
                              />
                            )}
                          </div>
                        </>
                      )}
                      {selectedChat.isGroup && (
                        <>
                          <div className="flex justify-around gap-2 px-3 py-1.5 border-b border-gray-100">
                            <button
                              className="flex flex-col items-center gap-0.5 p-1.5 hover:bg-gray-100 rounded-md"
                              onClick={async () => {
                                setIsLoadingGroupMember(true);
                                await loadGroupMembers();
                                setIsOpenGroupMembersSideBar(true);
                                setIsLoadingGroupMember(false);
                              }}
                            >
                              <Users className="h-4 w-4" />
                              <span className="text-[11px]">Xem thành viên</span>
                            </button>
                            <button
                              className="flex flex-col items-center gap-0.5 p-1.5 hover:bg-gray-100 rounded-md"
                              onClick={() => {
                                setSelectedInviteGroup(selectedChat);
                                setIsOpenCreateGroupModal(true);
                              }}
                            >
                              <UserPlus className="h-4 w-4" />
                              <span className="text-[11px]">Thêm thành viên</span>
                            </button>
                          </div>
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("chatInfo")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <User className="w-4 h-4 text-gray-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Thông tin nhóm
                                </span>
                              </div>
                              {openMenus.chatInfo ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>

                            {openMenus.chatInfo && (
                              <div className="px-3 py-2 bg-gray-50 text-gray-800">
                                <div className="grid grid-cols-[112px_1fr] gap-x-2 gap-y-1 text-[12px]">
                                  <span className="text-gray-500">Tên nhóm</span>
                                  <span className="break-words">{selectedChat.name}</span>
                                  <span className="text-gray-500">Số thành viên</span>
                                  <span>{selectedChat.groupMemberIds?.length ?? 0}</span>
                                  <span className="text-gray-500">Loại nhóm</span>
                                  <span>{selectedChat.groupType === 1 ? "Nhóm" : "Cộng đồng"}</span>
                                  <span className="text-gray-500">Tư cách</span>
                                  <span>
                                    {selectedChat.groupCreatorId ===
                                    selectedShop.zaloId
                                      ? `Trưởng${selectedChat.groupType === 1 ? " nhóm" : " cộng đồng"}`
                                      : selectedChat.groupAdminIds.includes(
                                            selectedShop.zaloId,
                                          )
                                        ? `Phó${selectedChat.groupType === 1 ? " nhóm" : " cộng đồng"}`
                                        : "Thành viên"}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("contactInfo")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <Phone className="w-4 h-4 text-gray-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Thông tin liên hệ
                                </span>
                              </div>
                              {openMenus.contactInfo ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>

                            {openMenus.contactInfo && (
                              <div className="flex flex-col px-3 py-2 bg-gray-50 text-gray-800 gap-2.5 text-[12px]">
                                {/* Phone List */}
                                <div>
                                  <div className="flex items-center justify-between mb-1">
                                    <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">
                                      Số điện thoại:
                                    </p>
                                    <button
                                      onClick={() => toggleMenu("addPhone")}
                                      className="p-1 rounded-full hover:bg-blue-100 text-blue-500"
                                      title="Thêm SĐT"
                                    >
                                      <Plus className="w-4 h-4" />
                                    </button>
                                  </div>
                                  {selectedChat.phoneList &&
                                  selectedChat.phoneList.length > 0 ? (
                                    <div className="flex flex-wrap gap-1">
                                      {selectedChat.phoneList.map(
                                        (phone, idx) => (
                                          <span
                                            key={idx}
                                            className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full cursor-pointer hover:bg-blue-200 transition-colors"
                                            onClick={() => {
                                              navigator.clipboard.writeText(
                                                phone,
                                              );
                                              addNotification(
                                                "Đã sao chép SĐT",
                                                1,
                                              );
                                            }}
                                            title="Sao chép"
                                          >
                                            {phone}
                                          </span>
                                        ),
                                      )}
                                    </div>
                                  ) : (
                                    <p className="text-[11px] text-gray-500 italic">
                                      Chưa có SĐT nào
                                    </p>
                                  )}
                                  {/* Add Phone Input - Toggle */}
                                  {openMenus.addPhone && (
                                    <div className="flex gap-1 mt-2">
                                      <input
                                        type="text"
                                        placeholder="Nhập SĐT..."
                                        className="flex-1 px-2 py-1 text-sm border rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        autoFocus
                                        onKeyPress={(e) => {
                                          if (e.key === "Enter") {
                                            const value = e.target.value.trim();
                                            if (value) {
                                              handleAddContactInfo(
                                                "phone",
                                                value,
                                              );
                                              e.target.value = "";
                                              toggleMenu("addPhone");
                                            }
                                          }
                                        }}
                                        id="add-phone-input-group"
                                      />
                                      <button
                                        onClick={() => {
                                          const input = document.getElementById(
                                            "add-phone-input-group",
                                          );
                                          const value = input?.value?.trim();
                                          if (value) {
                                            handleAddContactInfo(
                                              "phone",
                                              value,
                                            );
                                            input.value = "";
                                            toggleMenu("addPhone");
                                          }
                                        }}
                                        className="px-2 py-1 bg-blue-500 text-white text-xs rounded hover:bg-blue-600"
                                      >
                                        Thêm
                                      </button>
                                      <button
                                        onClick={() => toggleMenu("addPhone")}
                                        className="px-2 py-1 bg-gray-300 text-gray-700 text-xs rounded hover:bg-gray-400"
                                      >
                                        Hủy
                                      </button>
                                    </div>
                                  )}
                                </div>

                                {/* Email List */}
                                <div>
                                  <div className="flex items-center justify-between mb-1">
                                    <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">
                                      Email:
                                    </p>
                                    <button
                                      onClick={() => toggleMenu("addEmail")}
                                      className="p-1 rounded-full hover:bg-green-100 text-green-500"
                                      title="Thêm email"
                                    >
                                      <Plus className="w-4 h-4" />
                                    </button>
                                  </div>
                                  {selectedChat.emailList &&
                                  selectedChat.emailList.length > 0 ? (
                                    <div className="flex flex-wrap gap-1">
                                      {selectedChat.emailList.map(
                                        (email, idx) => (
                                          <span
                                            key={idx}
                                            className="inline-flex items-center px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full cursor-pointer hover:bg-green-200 transition-colors"
                                            onClick={() => {
                                              navigator.clipboard.writeText(
                                                email,
                                              );
                                              addNotification(
                                                "Đã sao chép email",
                                                1,
                                              );
                                            }}
                                            title="Sao chép"
                                          >
                                            {email}
                                          </span>
                                        ),
                                      )}
                                    </div>
                                  ) : (
                                    <p className="text-[11px] text-gray-500 italic">
                                      Chưa có email nào
                                    </p>
                                  )}
                                  {/* Add Email Input - Toggle */}
                                  {openMenus.addEmail && (
                                    <div className="flex gap-1 mt-2">
                                      <input
                                        type="email"
                                        placeholder="Nhập email..."
                                        className="flex-1 px-2 py-1 text-sm border rounded focus:outline-none focus:ring-1 focus:ring-green-500"
                                        autoFocus
                                        onKeyPress={(e) => {
                                          if (e.key === "Enter") {
                                            const value = e.target.value.trim();
                                            if (value) {
                                              handleAddContactInfo(
                                                "email",
                                                value,
                                              );
                                              e.target.value = "";
                                              toggleMenu("addEmail");
                                            }
                                          }
                                        }}
                                        id="add-email-input-group"
                                      />
                                      <button
                                        onClick={() => {
                                          const input = document.getElementById(
                                            "add-email-input-group",
                                          );
                                          const value = input?.value?.trim();
                                          if (value) {
                                            handleAddContactInfo(
                                              "email",
                                              value,
                                            );
                                            input.value = "";
                                            toggleMenu("addEmail");
                                          }
                                        }}
                                        className="px-2 py-1 bg-green-500 text-white text-xs rounded hover:bg-green-600"
                                      >
                                        Thêm
                                      </button>
                                      <button
                                        onClick={() => toggleMenu("addEmail")}
                                        className="px-2 py-1 bg-gray-300 text-gray-700 text-xs rounded hover:bg-gray-400"
                                      >
                                        Hủy
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("images")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <ImageIcon className="w-4 h-4 text-gray-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Xem ảnh
                                </span>
                              </div>
                              {openMenus.images ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>
                            {openMenus.images && (
                              <div className="grid grid-cols-3 gap-1.5 p-2 bg-gray-50">
                                {mediaMessages.map((item, idx) => (
                                  <div
                                    key={idx}
                                    className="relative w-full h-20 cursor-pointer group"
                                    onClick={(e) => handleMediaClick(e, item)}
                                  >
                                    <img
                                      src={
                                        item.type === "video"
                                          ? item.content
                                          : item.img
                                      }
                                      alt="thumbnail"
                                      className="w-full h-full object-cover rounded-md"
                                      onError={(e) => {
                                        e.target.style.display = "none";
                                      }}
                                    />
                                    {item.type === "video" && (
                                      <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/10 transition-colors rounded-md">
                                        <div className="w-8 h-8 rounded-full bg-black/50 flex items-center justify-center backdrop-blur-sm">
                                          <Play className="w-4 h-4 text-white fill-white ml-0.5" />
                                        </div>
                                        <span className="absolute bottom-1 right-1 px-1 py-0.5 bg-black/60 text-[10px] text-white rounded font-medium">
                                          Video
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("files")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <FileText className="w-4 h-4 text-gray-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Xem file
                                </span>
                              </div>
                              {openMenus.files ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>
                            {openMenus.files && (
                              <div className="flex flex-col gap-2 p-2 bg-gray-50">
                                <input
                                  type="text"
                                  value={fileSearch}
                                  onChange={(e) => {
                                    setFileSearch(e.target.value);
                                    setFilePage(1);
                                  }}
                                  placeholder="Tìm kiếm file..."
                                  className="mb-2 border rounded px-2 py-1 text-sm"
                                />
                                <select
                                  className="mb-2 border rounded px-2 py-1 text-sm"
                                  value={fileFilter}
                                  onChange={(e) => {
                                    setFileFilter(e.target.value);
                                    setFilePage(1);
                                  }}
                                >
                                  <option value="all">Tất cả</option>
                                  <option value="pdf">PDF</option>
                                  <option value="doc">DOC</option>
                                  <option value="docx">DOCX</option>
                                  <option value="xls">XLS</option>
                                  <option value="xlsx">XLSX</option>
                                  <option value="ppt">PPT</option>
                                  <option value="pptx">PPTX</option>
                                  <option value="zip">ZIP</option>
                                  <option value="rar">RAR</option>
                                </select>
                                {paginatedFileMessages.map((file, idx) => (
                                  <div
                                    key={idx}
                                    className="flex items-center justify-between bg-white p-1.5 rounded shadow-sm"
                                  >
                                    <div className="flex items-center gap-1.5 overflow-hidden">
                                      <FileText className="w-4 h-4 text-gray-500 flex-shrink-0" />
                                      <span className="truncate text-[12px]">
                                        {file.content}
                                      </span>
                                    </div>
                                    <a
                                      href={file.file}
                                      className="text-blue-500 text-[12px]"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Tải xuống
                                    </a>
                                  </div>
                                ))}
                                {filteredFileMessages.length > filesPerPage && (
                                  <div className="flex justify-between mt-2">
                                    <button
                                      className="px-2 py-1 border rounded text-sm"
                                      disabled={filePage === 1}
                                      onClick={() => setFilePage((p) => p - 1)}
                                    >
                                      Trước
                                    </button>
                                    <span className="text-sm">
                                      {filePage}/
                                      {Math.ceil(
                                        filteredFileMessages.length /
                                          filesPerPage,
                                      )}
                                    </span>
                                    <button
                                      className="px-2 py-1 border rounded text-sm"
                                      disabled={
                                        filePage >=
                                        Math.ceil(
                                          filteredFileMessages.length /
                                            filesPerPage,
                                        )
                                      }
                                      onClick={() => setFilePage((p) => p + 1)}
                                    >
                                      Sau
                                    </button>
                                  </div>
                                )}
                                {filteredFileMessages.length === 0 && (
                                  <p className="text-sm text-gray-500">
                                    Chưa có file nào
                                  </p>
                                )}
                              </div>
                            )}
                          </div>
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("links")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <Link className="w-4 h-4 text-gray-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Xem link
                                </span>
                              </div>
                              {openMenus.links ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>
                            {openMenus.links && (
                              <div className="flex flex-col gap-2 p-2 bg-gray-50">
                                {linkMessages.map((link, idx) => (
                                  <div key={idx} className="flex flex-col">
                                    <a
                                      href={
                                        link.link.startsWith("http")
                                          ? link.link
                                          : `http://${link.link}`
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-blue-500 underline truncate text-[12px]"
                                    >
                                      {link.link}
                                    </a>
                                    <span className="text-[10px] text-gray-400">
                                      {common.getPreviewTimeMessage(
                                        link.dateAction,
                                      )}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("noteInfo")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <StickyNote className="w-4 h-4 text-gray-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Ghi chú
                                </span>
                              </div>
                              {openMenus.noteInfo ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>

                            {openMenus.noteInfo && (
                              <div className="flex flex-col px-3 py-2 bg-gray-50 text-gray-800 gap-2.5 text-[12px]">
                                <div>
                                  <div className="flex items-center justify-between mb-1">
                                    <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">
                                      Danh sách ghi chú:
                                    </p>
                                    <button
                                      onClick={() => toggleMenu("addNote")}
                                      className="p-1 rounded hover:bg-yellow-100 text-yellow-600"
                                      title="Thêm ghi chú"
                                    >
                                      <Plus className="w-4 h-4" />
                                    </button>
                                  </div>
                                  {selectedChat.noteList &&
                                  selectedChat.noteList.length > 0 ? (
                                    <div className="flex flex-col gap-1">
                                      {selectedChat.noteList.map(
                                        (note, idx) => (
                                          <div
                                            key={idx}
                                            className="w-full p-2 bg-yellow-100 text-yellow-800 text-sm rounded-md cursor-pointer hover:bg-yellow-200 transition-colors whitespace-pre-wrap"
                                            onClick={() => {
                                              navigator.clipboard.writeText(
                                                note,
                                              );
                                              addNotification(
                                                "Đã sao chép ghi chú",
                                                1,
                                              );
                                            }}
                                            title="Sao chép"
                                          >
                                            {note}
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  ) : (
                                    <p className="text-[11px] text-gray-500 italic">
                                      Chưa có ghi chú nào
                                    </p>
                                  )}

                                  {/* Add Note Input - Toggle */}
                                  {openMenus.addNote && (
                                    <div className="flex flex-col gap-2 mt-2">
                                      <textarea
                                        placeholder="Nhập ghi chú..."
                                        className="w-full px-2 py-1 text-sm border rounded-md focus:outline-none focus:ring-1 focus:ring-yellow-500 resize-none"
                                        rows={3}
                                        autoFocus
                                        id="add-note-input"
                                      />
                                      <div className="flex gap-2 justify-end">
                                        <button
                                          onClick={() => toggleMenu("addNote")}
                                          className="px-3 py-1 bg-gray-300 text-gray-700 text-xs rounded hover:bg-gray-400"
                                        >
                                          Hủy
                                        </button>
                                        <button
                                          onClick={() => {
                                            const input =
                                              document.getElementById(
                                                "add-note-input",
                                              );
                                            const value = input?.value?.trim();
                                            if (value) {
                                              handleAddContactInfo(
                                                "note",
                                                value,
                                              );
                                              input.value = "";
                                              toggleMenu("addNote");
                                            }
                                          }}
                                          className="px-3 py-1 bg-yellow-500 text-white text-xs rounded hover:bg-yellow-600"
                                        >
                                          Thêm
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          {isChatbotEventEnabled && (
                            <div className="border-b">
                              <button
                                onClick={() => toggleMenu("botMessages")}
                                className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                              >
                                <div className="flex items-center gap-2">
                                  <Bot className="w-4 h-4 text-gray-500" />
                                  <span className="text-[13px] font-medium text-gray-700">
                                    Tin nhắn bot - Sự kiện
                                  </span>
                                </div>
                                {openMenus.botMessages ? (
                                  <ChevronDown className="w-4 h-4 text-gray-500" />
                                ) : (
                                  <ChevronRight className="w-4 h-4 text-gray-500" />
                                )}
                              </button>
                              {openMenus.botMessages && (
                                <BotMessagesTab
                                  contactId={selectedChat?.id}
                                  isOpen={openMenus.botMessages}
                                  chatbotType="event"
                                />
                              )}
                            </div>
                          )}
                          <div className="border-b">
                            <button
                              onClick={() => toggleMenu("botKeywordMessages")}
                              className="w-full flex items-center justify-between px-3 py-1.5 transition duration-200 hover:bg-gray-50 focus:outline-none"
                            >
                              <div className="flex items-center gap-2">
                                <Bot className="w-4 h-4 text-purple-500" />
                                <span className="text-[13px] font-medium text-gray-700">
                                  Tin nhắn bot - Ý nghĩa
                                </span>
                              </div>
                              {openMenus.botKeywordMessages ? (
                                <ChevronDown className="w-4 h-4 text-gray-500" />
                              ) : (
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              )}
                            </button>
                            {openMenus.botKeywordMessages && (
                              <BotMessagesTab
                                contactId={selectedChat?.id}
                                isOpen={openMenus.botKeywordMessages}
                                chatbotType="keyword"
                              />
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </>
              )}
              {selectedChat && isOpenGroupMembersSideBar && (
                <GroupMemberSideBar
                  user={user}
                  staffs={staffs}
                  shop={getActualShop()}
                  group={selectedGroup}
                  members={groupMembers}
                  setSelectedChat={(contact) => {
                    setSelectedChat(contact);
                    setSelectedChatName(contact?.name ?? "");
                    setIsEditingName(false);
                    messageInputRef?.current?.focus();
                  }}
                  setContacts={setContacts}
                  isOpen={isOpenGroupMembersSideBar}
                  setIsOpen={setIsOpenGroupMembersSideBar}
                />
              )}
            </section>
          )}
        </main>
        <SearchContactModal
          open={isSearchModalOpen}
          onOpenChange={setIsSearchModalOpen}
          shopId={selectedShop?._id}
          staffId={auth?.user?._id}
          onSelectConversation={(result, opts) => {
            const lookup =
              contactsRef.current.find(
                (c) =>
                  (result?.uid && c.uid === result.uid) ||
                  (result?._id && c._id === result._id),
              ) || null;
            const full = lookup || result;
            const safe = {
              ...full,
              messages: Array.isArray(full?.messages) ? full.messages : [],
            };
            setSelectedChat(safe);
            setSelectedChatName(safe?.name ?? "");
            if (opts?.jumpTo) {
              setPendingSearchJump({
                contactId: safe?._id,
                contactUid: safe?.uid,
                message: opts.jumpTo,
              });
            }
          }}
        />
        <AddFriendModal
          isOpen={isOpenAddFriendModal}
          setIsOpen={setIsOpenAddFriendModal}
          shop={getActualShop()}
          addFriend={handleAddFriend}
        />
        <SendContactCardModal
          open={isOpenSendCardModal}
          onOpenChange={setIsOpenSendCardModal}
          shopId={getActualShop()?._id}
          akabizTags={(tags || []).filter((t) => t.isActive)}
          onSend={handleSendContactCards}
        />
        <UserInfoModal
          isOpen={isUserInfoOpen}
          setIsOpen={setIsUserInfoOpen}
          uid={userInfoUid}
          shop={getActualShop()}
          user={user}
          staffs={staffs}
          setContacts={setContacts}
          setSelectedChat={setSelectedChat}
        />
        <PipelineStagesManager
          isOpen={isStagesManagerOpen}
          onClose={() => setIsStagesManagerOpen(false)}
          accountId={auth.user?.accountId}
          onChanged={() => {
            if (!auth?.user?.accountId) return;
            pipelineStageApi
              .getByAccountId(auth.user.accountId)
              .then((res) => {
                if (res?.status === 1) setPipelineStages(res.data || []);
              })
              .catch(() => {});
          }}
        />
        <ShareMessageModal
          isOpen={isOpenShareModal}
          setIsOpen={setIsOpenShareModal}
          shop={getActualShop()}
          message={shareMessage}
          tagZalos={tagZalos}
        />
        <ContactModal
          isOpen={isOpenSearchModal}
          setIsOpen={setIsOpenSearchModal}
          user={user}
          staffs={staffs}
          shop={getDefaultSearchShop()}
          setNewContact={setNewContact}
        />
        <CreateGroupModal
          isOpen={isOpenCreateGroupModal}
          setIsOpen={setIsOpenCreateGroupModal}
          shop={selectedShop}
          contacts={contacts.filter((x) => x.isFriend)}
          selectedContacts={selectedCreateGroupContacts}
          setSelectedContacts={setSelectedCreateGroupContacts}
          selectedGroup={selectedInviteGroup}
          setSelectedGroup={setSelectedInviteGroup}
        />
        <PermissionModal
          isOpen={isOpenPermissionModal}
          setIsOpen={setIsOpenPermissionModal}
          shop={selectedShop}
          handleManageStaffClick={handleManageStaffClick}
        />
        <SettingModal
          isOpen={isOpenSettingModal}
          setIsOpen={setIsOpenSettingModal}
          user={user}
          shop={selectedShop}
          quickMessages={quickMessages}
          setQuickMessages={setQuickMessages}
          tags={tags}
          setTags={setTags}
        />
        <ImageAlbumModal
          isOpen={albumState.isOpen}
          onClose={() => setAlbumState((prev) => ({ ...prev, isOpen: false }))}
          initialMedia={albumState.initialMedia}
          mediaList={mediaMessages}
        />
        {contextMenu.visible && (
          <div
            className="fixed bg-white shadow-xl rounded-lg py-2 z-50 border border-gray-100 min-w-[200px]"
            style={{ top: contextMenu.y, left: contextMenu.x }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="px-4 py-2 text-sm font-medium text-gray-700 border-b border-gray-100 mb-1">
              {contextMenu.contact?.name}
            </div>
            <button
              className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
              onClick={() => {
                setContextMenu((prev) => ({ ...prev, visible: false }));
                contextMenu.contact.isPinned
                  ? handleUnpinConversation(contextMenu.contact)
                  : handlePinConversation(contextMenu.contact);
              }}
            >
              <Pin size={16} className="text-gray-500" />
              {contextMenu.contact.isPinned
                ? "Bỏ ghim hội thoại"
                : "Ghim hội thoại"}
            </button>
            <button
              className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
              onClick={() => {
                setContextMenu((prev) => ({ ...prev, visible: false }));
                contextMenu.contact.isHidden
                  ? handleUnhideConversation(contextMenu.contact)
                  : handleHideConversation(contextMenu.contact);
              }}
            >
              <EyeOff size={16} className="text-gray-500" />
              {contextMenu.contact.isHidden
                ? "Bỏ ẩn hội thoại"
                : "Ẩn hội thoại"}
            </button>
          </div>
        )}
        {isLoading && <LoadingLeftBot />}
        <HiddenConversationsModal
          isOpen={isHiddenConversationsModalOpen}
          onClose={() => setIsHiddenConversationsModalOpen(false)}
          shops={shops.data}
          selectedShop={selectedShop}
          isGroupMode={isGroupMode}
          onUnhideSuccess={(count) => {
            addNotification(`Đã bỏ ẩn ${count} hội thoại`, 1);
            if (isGroupMode && groupShops.length > 0) {
              loadContactsFromShops(groupShops, 1, false);
            } else {
              getContacts();
            }
          }}
        />
      </div>
    </>
  );
};

export default ChatPage;
